// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23666%27 d=%27M6 8L1 3h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rs-anchor { position: relative; width: 100%; overflow: visible; }

/* ensure the menu expands to the control width */
.rs-anchor .rs__menu,
.rs-anchor .rs__menu-portal { width: 100% !important; left: 0 !important; }

@media screen and (min-width: 1022px) {
  #SalesOrder-popup {
    width: 70% !important;
    left: 70px !important;
  }

  #checkoutpopup {
    left: 24% !important;
    width: 114% !important;
  }
}

@media screen and (max-width: 1021px) {
  #SalesOrder-popup {
    width: 96% !important;
    /* left: 70px !important; */
  }

  #checkoutpopup {
    left: 3% !important;
  }
}

.icon-chip{
  width:32px;height:32x;border-radius:8px;
  display:inline-flex;align-items:center;justify-content:center;
  font-size:16px;
}
.chip-orange{ background:#FFF3E6; color:#E17100; } /* product */
.chip-blue  { background:#EEF5FF; color:#0d6efd; } /* order */


.order-card {
  box-shadow: 0 4px 6px -1px #0000001a, 0 2px 4px -1px #0000000f;
  background-color: #fff;
  border-radius: .625rem;
  border-width: 1px;
}

.order-tittle {
  font-size: 0.875rem;
  color: #111827;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  font-weight: 500 !important;
}

.order-card-title {
  font-size: 0.875rem;
  color: #111827;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  font-weight: 500 !important;
}

.order-card-cells {
  font-size: 0.875rem;
  color: #111827;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;

}

.order-card-log {
  font-size: 12px;
  color: #111827;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;

}
.card{
  margin-bottom: 7px;
}
#right-column{
  padding-left: 1px !important;
}
#left-column{
  padding-right: 3px !important;
}

/* Scope everything to ONLY this card */
.product-table-card .card-header {
  border-bottom: 1px solid #edf1f5;
}

/* Remove ALL table borders from Bootstrap (header + body cells) */
.product-table-card .ps-table,
.product-table-card .ps-table th,
.product-table-card .ps-table td {
  border: 0 !important;
  border-color: transparent !important;
}

.product-table-card .ps-table> :not(caption)>*>* {
  border-bottom-width: 0 !important;
  /* BS5 reset */
  box-shadow: none !important;
}

/* Header look (light background + bold text) */
.product-table-card .ps-table thead.sticky-top {
  top: 0;
  z-index: 2;
}

.product-table-card .ps-table thead th {
  background: #f6f8fb !important;
  /* soft grey */
  color: #111827;
  font-weight: 600;
}

/* Soft row divider (no vertical grid lines) */
.product-table-card .ps-table tbody tr {
  border-bottom: 1px solid #eef2f7;
}

.product-table-card .ps-table tbody tr:last-child {
  border-bottom: 0;
}

/* Image cell: small rounded preview */
.product-table-card .ps-table td:first-child>div {
  width: 56px !important;
  height: 56px !important;
  flex-shrink: 0;
  border-radius: 10px;
  overflow: hidden;
}

.product-table-card .ps-table td:first-child img {
  width: 56px !important;
  height: 56px !important;
  object-fit: cover;
  border: none !important;
  border-radius: 10px;
}

/* Product name + subtext styling */
.product-table-card .ps-table td:nth-child(2) .fw-semibold {
  font-size: 14px;
  letter-spacing: .2px;
}

.product-table-card .ps-table td:nth-child(2) .custom-fields-container {
  font-size: 12px;
  color: #6b7280;
  /* muted lines under title */
}

/* Center numeric columns like the screenshot */
.product-table-card .ps-table th:nth-child(3),
.product-table-card .ps-table th:nth-child(4),
.product-table-card .ps-table th:nth-child(5),
.product-table-card .ps-table td:nth-child(3),
.product-table-card .ps-table td:nth-child(4),
.product-table-card .ps-table td:nth-child(5) {
  text-align: center;
  white-space: nowrap;
}
/* vertical scroll container */
.ps-wrap {
  max-height: 350px;
  overflow-y: auto;
  position: relative;           /* required so sticky anchors to THIS scroller */
  overscroll-behavior: contain; /* prevents body scroll takeover */
}

/* keep table tight inside */
.ps-wrap .table {
  margin-bottom: 0;
}

/* sticky header that stays visible while body scrolls */
.ps-wrap thead .ps-head th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8f9fa; /* same as .table-light */
}

/* optional: if you use .table-light, you can keep it */
.ps-wrap thead .ps-head th.table-light {
  background: #f8f9fa;
}
/* Smooth scrollbar only when needed */
.product-table-card .ps-wrap {
  scrollbar-gutter: stable;
  /* avoids layout jump when scrollbar appears */
}

.css-dn1p29 {
  min-height: 0 !important;
}

.css-19bb58m {
  margin: 0 !important;
  padding-top: 0 !important;
}

.css-xorh0z {
  display: block !important;
}

/* brokerage agent side custom css  */



  :root {
            --primary: #1e5db8;
            --primary-light: #2a6dc4;
            --primary-dark: #1548a0;
            --accent: #ff9800;
            --text-dark: #1a1a1a;
            --text-gray: #666666;
            --text-light: #999999;
            --bg-white: #ffffff;
            --bg-light: #f8f9fa;
            --border: #e0e0e0;
            --success: #4caf50;
            --rating: #ffc107;
            --sidebar-width: 260px;
            --header-height: 64px;
        }

        body {
            font-family: 'Roboto', sans-serif;
            background: var(--bg-light);
            color: var(--text-dark);
            line-height: 1.6;
            overflow-x: hidden;
        }

        /* SaaS Top Header */
        .saas-header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            height: var(--header-height);
            background: var(--bg-white);
            border-bottom: 1px solid var(--border);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;
            z-index: 1000;
        }

        .saas-header-left {
            display: flex;
            align-items: center;
            gap: 16px;
        }

        .sidebar-toggle {
            display: none;
            flex-direction: column;
            gap: 4px;
            background: none;
            border: none;
            cursor: pointer;
            padding: 8px;
        }

        .sidebar-toggle span {
            display: block;
            width: 20px;
            height: 2px;
            background: var(--text-gray);
            border-radius: 2px;
            transition: all 0.3s;
        }

        .saas-logo {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .saas-logo-mark {
            width: 36px;
            height: 36px;
            background: linear-gradient(135deg, var(--primary), #3b82f6);
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 18px;
            font-weight: 700;
        }

        .saas-logo-text {
            font-size: 20px;
            font-weight: 700;
            color: var(--text-dark);
        }

        .saas-header-center {
            flex: 1 1;
            max-width: 500px;
            margin: 0 40px;
        }

        .global-search {
            position: relative;
            display: flex;
            align-items: center;
        }

        .global-search-icon {
            position: absolute;
            left: 14px;
            font-size: 14px;
            color: var(--text-light);
        }

        .global-search-input {
            width: 100%;
            padding: 10px 70px 10px 40px;
            border: 1px solid var(--border);
            border-radius: 8px;
            font-size: 14px;
            background: var(--bg-light);
            transition: all 0.2s;
        }

        .global-search-input:focus {
            outline: none;
            border-color: var(--primary);
            background: var(--bg-white);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .global-search-shortcut {
            position: absolute;
            right: 12px;
            padding: 4px 8px;
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 4px;
            font-size: 11px;
            color: var(--text-light);
        }

        .saas-header-right {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .header-icon-btn {
            width: 40px;
            height: 40px;
            border: none;
            background: transparent;
            border-radius: 8px;
            font-size: 18px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            transition: all 0.2s;
        }

        .header-icon-btn:hover {
            background: var(--bg-light);
        }

        .notification-btn {
            position: relative;
        }

        .notification-badge {
            position: absolute;
            top: 4px;
            right: 4px;
            width: 18px;
            height: 18px;
            background: #e53935;
            color: white;
            font-size: 10px;
            font-weight: 700;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .header-divider {
            width: 1px;
            height: 32px;
            background: var(--border);
            margin: 0 8px;
        }

        .user-menu {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 6px 12px 6px 6px;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s;
            position: relative;
        }

        .user-menu:hover {
            background: var(--bg-light);
        }

        .user-avatar {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background: linear-gradient(135deg, #667BC6, #4A5BA8);
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 13px;
            font-weight: 600;
        }

        .user-info {
            display: flex;
            flex-direction: column;
        }

        .user-name {
            font-size: 13px;
            font-weight: 600;
            color: var(--text-dark);
        }

        .user-role {
            font-size: 11px;
            color: var(--text-light);
        }

        .user-dropdown-icon {
            font-size: 10px;
            color: var(--text-light);
        }

        .user-dropdown {
            position: absolute;
            top: 100%;
            right: 0;
            margin-top: 8px;
            width: 260px;
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 12px;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
            opacity: 0;
            visibility: hidden;
            transform: translateY(-10px);
            transition: all 0.2s;
            z-index: 1001;
        }

        .user-dropdown.active {
            opacity: 1;
            visibility: visible;
            transform: translateY(0);
        }

        .user-dropdown-header {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 16px;
        }

        .user-avatar-large {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            background: linear-gradient(135deg, #667BC6, #4A5BA8);
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 16px;
            font-weight: 600;
        }

        .user-dropdown-name {
            font-size: 14px;
            font-weight: 600;
            color: var(--text-dark);
        }

        .user-dropdown-email {
            font-size: 12px;
            color: var(--text-gray);
        }

        .user-dropdown-divider {
            height: 1px;
            background: var(--border);
            margin: 4px 0;
        }

        .user-dropdown-item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px 16px;
            color: var(--text-dark);
            text-decoration: none;
            font-size: 13px;
            transition: all 0.2s;
        }

        .user-dropdown-item:hover {
            background: var(--bg-light);
        }

        .user-dropdown-item.logout {
            color: #e53935;
        }

        /* SaaS Left Sidebar */
        .saas-sidebar {
            position: fixed;
            top: var(--header-height);
            left: 0;
            bottom: 0;
            width: var(--sidebar-width);
            background: var(--bg-white);
            border-right: 1px solid var(--border);
            display: flex;
            flex-direction: column;
            z-index: 999;
            transition: transform 0.3s ease;
        }

        .sidebar-nav {
            flex: 1 1;
            padding: 20px 12px;
            overflow-y: auto;
        }

        .sidebar-section {
            margin-bottom: 24px;
        }

        .sidebar-section-title {
            font-size: 11px;
            font-weight: 600;
            color: var(--text-light);
            text-transform: uppercase;
            letter-spacing: 0.5px;
            padding: 0 12px;
            margin-bottom: 8px;
        }

        .sidebar-item {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 10px 12px;
            border-radius: 8px;
            color: var(--text-gray);
            text-decoration: none;
            font-size: 14px;
            font-weight: 500;
            transition: all 0.2s;
            margin-bottom: 2px;
        }

        .sidebar-item:hover {
            background: var(--bg-light);
            color: var(--text-dark);
        }

        .sidebar-item.active {
            background: rgba(30, 93, 184, 0.08);
            color: var(--primary);
        }

        .sidebar-icon {
            font-size: 18px;
            width: 24px;
            text-align: center;
        }

        .sidebar-text {
            flex: 1 1;
        }

        .sidebar-badge {
            padding: 2px 8px;
            background: var(--primary);
            color: white;
            font-size: 10px;
            font-weight: 600;
            border-radius: 10px;
        }

        .sidebar-count {
            padding: 2px 8px;
            background: var(--bg-light);
            color: var(--text-gray);
            font-size: 11px;
            font-weight: 600;
            border-radius: 10px;
        }

        .sidebar-footer {
            padding: 12px;
            border-top: 1px solid var(--border);
        }

        .sidebar-upgrade-card {
            background: linear-gradient(135deg, #f0f7ff, #e8f4fd);
            border: 1px solid rgba(30, 93, 184, 0.15);
            border-radius: 10px;
            padding: 14px;
            margin-bottom: 12px;
        }

        .upgrade-icon {
            font-size: 20px;
            margin-bottom: 8px;
        }

        .upgrade-text {
            margin-bottom: 12px;
        }

        .upgrade-text strong {
            display: block;
            font-size: 13px;
            color: var(--text-dark);
            margin-bottom: 2px;
        }

        .upgrade-text span {
            font-size: 12px;
            color: var(--text-gray);
        }

        .btn-upgrade {
            width: 100%;
            padding: 8px;
            background: var(--primary);
            border: none;
            color: white;
            border-radius: 6px;
            font-size: 12px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-upgrade:hover {
            background: var(--primary-dark);
        }

        .sidebar-help {
            margin-top: 8px;
        }

        /* Main Content Wrapper */
        .saas-main-wrapper {
            margin-left: var(--sidebar-width);
            margin-top: var(--header-height);
            min-height: calc(100vh - var(--header-height));
        }

        .saas-main {
            padding: 24px;
        }

        /* Responsive Sidebar */
        @media (max-width: 1024px) {
            .sidebar-toggle {
                display: flex;
            }

            .saas-sidebar {
                transform: translateX(-100%);
            }

            .saas-sidebar.active {
                transform: translateX(0);
            }

            .saas-main-wrapper {
                margin-left: 0;
            }

            .saas-header-center {
                display: none;
            }
        }

        @media (max-width: 768px) {
            .user-info {
                display: none;
            }

            .user-dropdown-icon {
                display: none;
            }
        }

        /* Old Header - Hidden */
        .header {
            display: none;
        }

        .header-content {
            max-width: 1320px;
            margin: 0 auto;
            padding: 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .logo {
            font-size: 20px;
            font-weight: 700;
            letter-spacing: -0.3px;
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .logo-mark {
            width: 28px;
            height: 28px;
            background: linear-gradient(135deg, var(--accent), var(--primary));
            border-radius: 6px;
        }

        .btn-request {
            background: var(--primary);
            color: white;
            border: none;
            padding: 10px 20px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-request:hover {
            background: var(--primary-dark);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(30, 93, 184, 0.25);
        }

        /* Main */
        .main {
            max-width: 1320px;
            margin: 0 auto;
            padding: 40px 20px;
        }

        .hero {
            margin-bottom: 60px;
            text-align: center;
        }

        .hero h1 {
            font-size: 36px;
            font-weight: 700;
            margin-bottom: 12px;
            color: var(--text-dark);
            letter-spacing: -0.5px;
        }

        .hero p {
            font-size: 16px;
            color: var(--text-gray);
            max-width: 700px;
            line-height: 1.6;
            margin: 0 auto;
        }

        /* CTA Banner */
        .cta-section {
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 12px;
            padding: 32px;
            margin-bottom: 50px;
            display: grid;
            grid-template-columns: 1fr auto;
            gap: 40px;
            align-items: center;
            box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        }

        .cta-content h2 {
            font-size: 22px;
            font-weight: 700;
            margin-bottom: 12px;
            color: var(--text-dark);
        }

        .cta-content p {
            font-size: 15px;
            color: var(--text-gray);
            line-height: 1.6;
            margin-bottom: 16px;
        }

        .cta-features {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        .cta-feature {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 14px;
            color: var(--text-gray);
        }

        .check-icon {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: var(--success);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: bold;
            flex-shrink: 0;
        }

        .btn-primary1 {
            background: var(--primary);
            color: white;
            border: none;
            padding: 14px 28px;
            border-radius: 8px;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            white-space: nowrap;
        }

        .btn-primary1:hover {
            background: var(--primary-dark);
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(30, 93, 184, 0.25);
        }

        /* Controls */
        .controls {
            display: flex;
            gap: 16px;
            margin-bottom: 40px;
            align-items: center;
            flex-wrap: wrap;
            justify-content: flex-end;
        }

        .search-wrapper {
            min-width: 280px;
            max-width: 380px;
            position: relative;
        }

        .search-wrapper input {
            width: 100%;
            padding: 12px 16px 12px 40px;
            border: 1px solid var(--border);
            border-radius: 8px;
            font-size: 14px;
            background: var(--bg-white);
            transition: all 0.2s;
        }

        .search-wrapper input:focus {
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .search-icon {
            position: absolute;
            left: 13px;
            top: 50%;
            transform: translateY(-50%);
            color: var(--text-light);
            font-size: 16px;
        }

        .select-wrapper {
            position: relative;
        }

        /* select {
            padding: 5px 36px 10px 14px;
            border: 1px solid var(--border);
            border-radius: 8px;
            font-size: 14px;
            background: var(--bg-white);
            color: var(--text-dark);
            cursor: pointer;
            transition: all 0.2s;
            appearance: none;
            min-width: 160px;
        }

        select:hover {
            border-color: var(--primary);
        }

        select:focus {
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .select-arrow {
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
            pointer-events: none;
            color: var(--text-light);
            font-size: 12px;
        } */

        .btn-secondary {
            background: var(--bg-white);
            border: 1px solid var(--border);
            padding: 10px 18px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            color: var(--text-dark);
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .btn-secondary:hover {
            border-color: var(--primary);
            color: var(--primary);
            background: rgba(30, 93, 184, 0.02);
        }

        /* Vendors Section */
        .vendors-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 28px;
            flex-wrap: wrap;
            gap: 16px;
        }

        .vendors-count {
            font-size: 15px;
            color: var(--text-gray);
            font-weight: 500;
        }

        /* Vendor Grid */
        .vendors-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
            gap: 20px;
            margin-bottom: 60px;
        }

        /* Vendor Card */
        .vendor-card {
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 10px;
            overflow: hidden;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            display: flex;
            flex-direction: column;
            height: 100%;
            cursor: pointer;
        }

        .vendor-card:hover {
            box-shadow: 0 12px 32px rgba(0,0,0,0.12);
            border-color: var(--primary-light);
            transform: translateY(-4px);
        }

        .vendor-image {
            width: 100%;
            height: 160px;
            background: var(--bg-white);
            position: relative;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .vendor-logo {
            width: 80px;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            font-weight: 700;
            border-radius: 8px;
            color: white;
        }

        .logo-1 { background: linear-gradient(135deg, #FF6B6B, #FF8E72); }
        .logo-2 { background: linear-gradient(135deg, #4ECDC4, #44A08D); }
        .logo-3 { background: linear-gradient(135deg, #FFE66D, #FFC93C); }
        .logo-4 { background: linear-gradient(135deg, #95E1D3, #38A169); }
        .logo-5 { background: linear-gradient(135deg, #A8EDEA, #1D3557); }
        .logo-6 { background: linear-gradient(135deg, #FFB6B9, #FEC8D8); }
        .logo-7 { background: linear-gradient(135deg, #667BC6, #4A5BA8); }
        .logo-8 { background: linear-gradient(135deg, #FF9671, #FEC8C8); }
        .logo-9 { background: linear-gradient(135deg, #A0C4FF, #CAFFBF); }

        .vendor-badge {
            position: absolute;
            top: 12px;
            right: 12px;
            background: white;
            color: var(--text-dark);
            padding: 6px 12px;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.3px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .vendor-badge.verified {
            background: rgba(76, 175, 80, 0.15);
            color: var(--success);
        }

        .vendor-badge.partner {
            background: rgba(30, 93, 184, 0.15);
            color: var(--primary);
        }

        .vendor-badge.new {
            background: rgba(255, 152, 0, 0.15);
            color: var(--accent);
        }

        .vendor-body {
            padding: 16px;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        }

        .vendor-title {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 4px;
            color: var(--text-dark);
        }

        .vendor-subtitle {
            font-size: 13px;
            color: var(--text-gray);
            margin-bottom: 12px;
        }

        .vendor-info {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-bottom: 16px;
            font-size: 13px;
            flex-grow: 1;
        }

        .info-row {
            display: flex;
            justify-content: space-between;
            color: var(--text-gray);
        }

        .info-label {
            color: var(--text-light);
        }

        .info-value {
            font-weight: 600;
            color: var(--text-dark);
        }

        .rating {
            display: flex;
            align-items: center;
            gap: 4px;
            font-weight: 600;
            color: var(--text-dark);
        }

        .stars {
            color: var(--rating);
        }

        .vendor-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            margin-bottom: 16px;
            padding-bottom: 16px;
            border-bottom: 1px solid var(--border);
        }

        .tag {
            background: linear-gradient(135deg, rgba(30, 93, 184, 0.12), rgba(30, 93, 184, 0.08));
            color: var(--primary);
            padding: 4px 8px;
            border-radius: 5px;
            font-size: 11px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            border: 1px solid rgba(30, 93, 184, 0.2);
            text-transform: uppercase;
            letter-spacing: 0.2px;
        }

        .tag:hover {
            background: linear-gradient(135deg, rgba(30, 93, 184, 0.2), rgba(30, 93, 184, 0.15));
            border-color: var(--primary);
            transform: translateY(-2px);
        }

        /* Discount/Coupon Banner */
        .vendor-coupons {
            display: flex;
            flex-direction: column;
            gap: 6px;
            margin-bottom: 14px;
        }

        .coupon-badge {
            background: linear-gradient(135deg, #fff8e1, #ffecb3);
            border: 1px dashed #ff9800;
            color: #e65100;
            padding: 6px 12px;
            border-radius: 6px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
        }

        .coupon-left {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .coupon-icon {
            font-size: 14px;
        }

        .coupon-value {
            font-weight: 700;
            color: #e65100;
        }

        .coupon-label {
            color: #f57c00;
            font-size: 11px;
        }

        .coupon-code {
            background: white;
            border: 1px solid #ffcc80;
            padding: 8px 8px;
            border-radius: 4px;
            font-family: monospace;
            font-size: 13px;
            font-weight: 600;
            color: #e65100;
            cursor: pointer;
            transition: all 0.2s;
        }

        .coupon-code:hover {
            background: #fff3e0;
            border-color: #ff9800;
        }

        .coupon-code-copied {
            background: #e8f5e9 !important;
            border-color: #4caf50 !important;
            color: #2e7d32 !important;
        }

        .vendor-footer {
            display: flex;
            gap: 10px;
            border-top: 1px solid var(--border);
            padding-top: 16px;
            margin-top: auto;
        }

        .btn-outline {
            flex: 1 1;
            background: transparent;
            border: 1px solid var(--border);
            color: var(--text-dark);
            padding: 10px;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-outline:hover {
            border-color: var(--primary);
            color: var(--primary);
            background: rgba(30, 93, 184, 0.02);
        }

        .btn-action {
            flex: 1 1;
            background: var(--primary);
            border: none;
            color: white;
            padding: 10px;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-action:hover {
            background: var(--primary-dark);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(30, 93, 184, 0.25);
        }

        /* Overlay Pages (Catalog, Categories, Products) */
        /* .overlay-page {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: var(--bg-light);
            z-index: 999;
            overflow-y: auto;
        } */

        .overlay-page.active {
            display: block;
        }

        .overlay-page-header {
            background: var(--bg-white);
            border-bottom: 1px solid var(--border);
            padding: 20px 0;
            position: sticky;
            top: 0;
            z-index: 100;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        }

        .overlay-page-header-content {
            max-width: 1320px;
            margin: 0 auto;
            padding: 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .header-left {
            display: flex;
            align-items: center;
            gap: 16px;
        }

        .header-right {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .btn-header-details {
            padding: 11px 16px;
            background: var(--bg-white);
            border: 1px solid var(--border);
            color: var(--text-dark);
            border-radius: 6px;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-header-details:hover {
            border-color: var(--primary);
            color: var(--primary);
        }

        .btn-header-connect {
            padding: 8px 16px;
            background: var(--primary);
            border: none;
            color: white;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            gap: 6px;
        }

        .btn-header-connect:hover {
            background: var(--primary-dark);
        }

        .btn-header-requested {
            padding: 8px 16px;
            background: rgba(76, 175, 80, 0.1);
            border: 1px solid rgba(76, 175, 80, 0.3);
            color: var(--success);
            border-radius: 6px;
            font-size: 13px;
            font-weight: 600;
            cursor: default;
            display: flex;
            align-items: center;
            gap: 6px;
        }

        /* Vendor Info Card for inner pages */
        .vendor-info-card {
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 10px;
            padding: 16px 20px;
            margin-bottom: 24px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }

        .vendor-info-card-left {
            display: flex;
            align-items: center;
            gap: 14px;
        }

        .vendor-info-card-back {
            width: 38px;
            height: 38px;
            border: 1px solid var(--border);
            background: var(--bg-white);
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 16px;
            color: var(--text-gray);
            transition: all 0.2s;
        }

        .vendor-info-card-back:hover {
            border-color: var(--primary);
            color: var(--primary);
            background: rgba(30, 93, 184, 0.04);
        }

        .vendor-info-card-logo {
            width: 44px;
            height: 44px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-weight: 700;
            color: white;
        }

        .vendor-info-card-name {
            font-size: 16px;
            font-weight: 600;
            color: var(--text-dark);
        }

        .vendor-info-card-right {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .page-title-text {
            font-size: 16px;
            font-weight: 600;
            color: var(--text-dark);
        }

        /* Search and Filter Card */
        .search-filter-card {
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 10px;
            padding: 16px 20px;
            margin-bottom: 24px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
            flex-wrap: wrap;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }

        .search-filter-left {
            display: flex;
            align-items: center;
            gap: 12px;
            flex: 1 1;
            min-width: 250px;
        }

        .filter-search-input {
            flex: 1 1;
            max-width: 350px;
            position: relative;
        }

        .filter-search-input input {
            width: 100%;
            padding: 10px 14px 10px 40px;
            border: 1px solid var(--border);
            border-radius: 8px;
            font-size: 14px;
            background: var(--bg-light);
            transition: all 0.2s;
        }

        .filter-search-input input:focus {
            outline: none;
            border-color: var(--primary);
            background: var(--bg-white);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .filter-search-input .search-icon {
            position: absolute;
            left: 12px;
            top: 50%;
            transform: translateY(-50%);
            color: var(--text-light);
            font-size: 14px;
        }

        .search-filter-right {
            display: flex;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap;
        }

        .filter-label {
            font-size: 13px;
            color: var(--text-gray);
            font-weight: 500;
        }

        .filter-select {
            padding: 8px 32px 8px 12px;
            border: 1px solid var(--border);
            border-radius: 6px;
            font-size: 13px;
            color: var(--text-dark);
            background: var(--bg-white);
            cursor: pointer;
            appearance: none;
            background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
            background-repeat: no-repeat;
            background-position: right 10px center;
            transition: all 0.2s;
        }

        .filter-select:hover {
            border-color: var(--primary);
        }

        .filter-select:focus {
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .filter-btn {
            padding: 8px 14px;
            border: 1px solid var(--border);
            border-radius: 6px;
            font-size: 13px;
            font-weight: 500;
            color: var(--text-gray);
            background: var(--bg-white);
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 6px;
            transition: all 0.2s;
        }

        .filter-btn:hover {
            border-color: var(--primary);
            color: var(--primary);
        }

        .filter-btn.active {
            background: rgba(30, 93, 184, 0.08);
            border-color: var(--primary);
            color: var(--primary);
        }

        .filter-divider {
            width: 1px;
            height: 24px;
            background: var(--border);
        }

        .results-count {
            font-size: 13px;
            color: var(--text-gray);
        }

        .results-count strong {
            color: var(--text-dark);
        }

        @media (max-width: 768px) {
            .vendor-info-card {
                flex-direction: column;
                align-items: stretch;
                gap: 16px;
                padding: 14px 16px;
            }

            .vendor-info-card-left {
                min-width: 0;
            }

            .vendor-info-card-name {
                font-size: 15px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .vendor-info-card-right {
                flex-wrap: wrap;
                gap: 8px;
            }

            .vendor-info-card-right .btn-header-details,
            .vendor-info-card-right .btn-connect-header {
                flex: 1 1;
                min-width: 0;
                padding: 10px 14px;
                font-size: 14px;
            }

            .search-filter-card {
                flex-direction: column;
                align-items: stretch;
            }

            .search-filter-left {
                width: 100%;
            }

            .filter-search-input {
                max-width: none;
            }

            .search-filter-right {
                width: 100%;
                justify-content: flex-start;
            }
        }

        @media (max-width: 480px) {
            .vendor-info-card-right {
                flex-direction: column;
            }

            .vendor-info-card-right .btn-header-details,
            .vendor-info-card-right .btn-connect-header {
                width: 100%;
            }
        }

        .back1-btn {
            background: transparent;
            border: 1px solid var(--border);
            color: var(--text-dark);
            width: 40px;
            height: 40px;
            border-radius: 6px;
            font-size: 18px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s;
        }

        .back1-btn:hover {
            border-color: var(--primary);
            background: rgba(30, 93, 184, 0.05);
            color: var(--primary);
        }

        .page-vendor-info {
            display: flex;
            align-items: center;
            gap: 12px;
        }

        .page-vendor-logo {
            width: 40px;
            height: 40px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            font-weight: 700;
            color: white;
        }

        .page-vendor-name {
            font-size: 16px;
            font-weight: 700;
            color: var(--text-dark);
        }

        /* Breadcrumb */
        .breadcrumb {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 13px;
            color: var(--text-gray);
            margin-bottom: 24px;
        }

        .breadcrumb-item {
            cursor: pointer;
            transition: color 0.2s;
        }

        .breadcrumb-item:hover {
            color: var(--primary);
        }

        .breadcrumb-item.active {
            color: var(--text-dark);
            font-weight: 600;
            cursor: default;
        }

        .breadcrumb-separator {
            color: var(--text-light);
        }

        .overlay-page-content {
            max-width: 1419px;
            margin: 0 auto;
            padding: 40px 20px;
        }

        .page-title {
            font-size: 32px;
            font-weight: 700;
            margin-bottom: 12px;
            color: var(--text-dark);
        }

        .page-subtitle {
            font-size: 16px;
            color: var(--text-gray);
            margin-bottom: 40px;
        }

        .page-header-centered {
            text-align: center;
            margin-bottom: 40px;
        }

        .page-header-centered .page-title {
            margin-bottom: 12px;
        }

        .page-header-centered .page-subtitle {
            margin-bottom: 0;
        }

        .page-header-actions {
            display: flex;
            justify-content: center;
            gap: 12px;
            margin-top: 20px;
        }

        .btn-page-details {
            background: var(--bg-white);
            border: 1px solid var(--border);
            color: var(--text-dark);
            padding: 10px 24px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-page-details:hover {
            border-color: var(--primary);
            color: var(--primary);
        }

        .btn-page-connect {
            background: var(--primary);
            border: none;
            color: white;
            padding: 10px 24px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            gap: 6px;
        }

        .btn-page-connect:hover {
            background: var(--primary-dark);
        }

        .btn-page-requested {
            background: rgba(76, 175, 80, 0.1);
            border: 1px solid rgba(76, 175, 80, 0.3);
            color: var(--success);
            padding: 10px 24px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 600;
            cursor: default;
            display: flex;
            align-items: center;
            gap: 6px;
        }

        /* Page Search Bar */
        .page-search-wrapper {
            max-width: 500px;
            margin: 20px auto 0;
            position: relative;
        }

        .page-search-input {
            width: 100%;
            padding: 12px 16px 12px 44px;
            border: 1px solid var(--border);
            border-radius: 8px;
            font-size: 14px;
            background: var(--bg-white);
            transition: all 0.2s;
        }

        .page-search-input:focus {
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .page-search-input::placeholder {
            color: var(--text-light);
        }

        .page-search-icon {
            position: absolute;
            left: 14px;
            top: 50%;
            transform: translateY(-50%);
            color: var(--text-light);
            font-size: 16px;
            pointer-events: none;
        }

        /* Pagination Styles */
        /* .pagination-container {
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 10px;
            padding: 16px 24px;
            margin-top: 32px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 16px;
        } */

        .pagination-info {
            font-size: 14px;
            color: var(--text-gray);
        }

        .pagination-controls {
            display: flex;
            align-items: center;
            gap: 16px;
        }

        .pagination-rows {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            color: var(--text-gray);
        }

        .pagination-rows-select {
            padding: 8px 32px 8px 12px;
            border: 1px solid var(--border);
            border-radius: 6px;
            font-size: 14px;
            color: var(--text-dark);
            background: var(--bg-white);
            cursor: pointer;
            appearance: none;
            background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
            background-repeat: no-repeat;
            background-position: right 10px center;
        }

        .pagination-rows-select:focus {
            outline: none;
            border-color: var(--primary);
        }

        .pagination-nav {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .pagination-btn {
            padding: 8px 16px;
            border: 1px solid var(--border);
            border-radius: 6px;
            font-size: 13px;
            font-weight: 500;
            color: var(--text-gray);
            background: var(--bg-white);
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            gap: 4px;
        }

        .pagination-btn:hover:not(:disabled) {
            border-color: var(--primary);
            color: var(--primary);
        }

        .pagination-btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

        .pagination-pages {
            display: flex;
            align-items: center;
            gap: 4px;
        }

        .pagination-page {
            width: 36px;
            height: 36px;
            border: 1px solid var(--border);
            border-radius: 6px;
            font-size: 14px;
            font-weight: 600;
            color: var(--text-gray);
            background: var(--bg-white);
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .pagination-page:hover {
            border-color: var(--primary);
            color: var(--primary);
        }

        .pagination-page.active {
            background: var(--primary);
            border-color: var(--primary);
            color: white;
        }

        .pagination-ellipsis {
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: var(--text-light);
        }

        @media (max-width: 700px) {
            .pagination-container {
                flex-direction: column;
                align-items: stretch;
                text-align: center;
            }

            .pagination-controls {
                flex-direction: column;
                gap: 12px;
            }

            .pagination-nav {
                justify-content: center;
            }
        }

        /* Grid for cards */
        .card1-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            gap: 24px;
        }

        .card1 {
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 10px;
            overflow: hidden;
            transition: all 0.3s ease;
            display: flex;
            flex-direction: column;
            min-width: 0;
        }

        .card1:hover {
            box-shadow: 0 12px 32px rgba(0,0,0,0.12);
            border-color: var(--primary-light);
            transform: translateY(-4px);
        }

        .card1-header {
            background: var(--bg-white);
            height: 180px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
        }

        .card1-logo {
            width: 100px;
            height: 100px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 40px;
            font-weight: 700;
            color: white;
        }

        .card1-body {
            padding: 20px;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            min-width: 0;
        }

        .card1-name {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 8px;
            color: var(--text-dark);
            max-width: 100%;
            overflow-wrap: anywhere;
            word-break: break-word;
        }

        .card1-description {
            font-size: 13px;
            color: var(--text-gray);
            margin-bottom: 16px;
            max-width: 100%;
            overflow-wrap: anywhere;
            word-break: break-word;
        }

        .card1-stats {
            display: flex;
            flex-direction: column;
            gap: 10px;
            margin-bottom: 16px;
            padding-bottom: 16px;
            border-bottom: 1px solid var(--border);
            min-width: 0;
        }

        .card1-stat {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 12px;
            font-size: 13px;
            min-width: 0;
        }

        .card1-stat-label {
            color: var(--text-light);
            font-weight: 500;
            flex-shrink: 0;
        }

        .card1-stat-value {
            color: var(--text-dark);
            font-weight: 600;
            text-align: right;
            min-width: 0;
            max-width: 100%;
            overflow-wrap: anywhere;
            word-break: break-word;
        }

        .popular-items {
            margin-bottom: 16px;
        }

        .popular-items-title {
            font-size: 12px;
            font-weight: 700;
            color: var(--text-dark);
            text-transform: uppercase;
            margin-bottom: 8px;
            letter-spacing: 0.5px;
        }

        .popular-items-list {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
        }

        .popular-item {
            background: var(--bg-light);
            color: var(--text-gray);
            padding: 4px 10px;
            border-radius: 4px;
            font-size: 11px;
            font-weight: 500;
        }

        .card1-footer {
            display: flex;
            gap: 10px;
            margin-top: auto;
        }

        .btn-card-action {
            flex: 1 1;
            background: var(--primary);
            border: none;
            color: white;
            padding: 10px;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-card-action:hover {
            background: var(--primary-dark);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(30, 93, 184, 0.25);
        }

        /* Product Card specific styles */
        .product-card {
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 10px;
            overflow: hidden;
            transition: all 0.3s ease;
        }

        .product-card:hover {
            box-shadow: 0 12px 32px rgba(0,0,0,0.12);
            border-color: var(--primary-light);
            transform: translateY(-4px);
        }

        .product-image {
            background: var(--bg-white);
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 60px;
            position: relative;
        }

        .product-badge {
            position: absolute;
            top: 12px;
            right: 12px;
            background: var(--success);
            color: white;
            padding: 4px 10px;
            border-radius: 4px;
            font-size: 11px;
            font-weight: 600;
        }

        .product-body {
            padding: 20px;
        }

        .product-name {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 6px;
            color: var(--text-dark);
        }

        .product-sku {
            font-size: 12px;
            color: var(--text-light);
            margin-bottom: 12px;
        }

        .product-price {
            font-size: 20px;
            font-weight: 700;
            color: var(--primary);
            margin-bottom: 16px;
        }

        .product-specs {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-bottom: 16px;
            padding-bottom: 16px;
            border-bottom: 1px solid var(--border);
        }

        .product-spec {
            display: flex;
            justify-content: space-between;
            font-size: 13px;
        }

        .product-spec-label {
            color: var(--text-light);
        }

        .product-spec-value {
            color: var(--text-dark);
            font-weight: 500;
        }

        .product-footer {
            display: flex;
            gap: 10px;
        }

        .btn-product-view {
            flex: 1 1;
            background: var(--bg-white);
            border: 1px solid var(--border);
            color: var(--text-dark);
            padding: 12px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-product-view:hover {
            border-color: var(--primary);
            color: var(--primary);
        }

        .btn-add-cart {
            flex: 1 1;
            background: var(--primary);
            border: none;
            color: white;
            padding: 12px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-add-cart:hover {
            background: var(--primary-dark);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(30, 93, 184, 0.25);
        }

        /* Vendor Details Panel - Slide in from right */
        .details-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: 1000;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s ease;
        }

        .details-overlay.active {
            opacity: 1;
            visibility: visible;
        }

        .details-panel {
            position: fixed;
            top: 71px;
            right: 0;
            width: 800px;
            max-width: 100%;
            height: 104vh;
            background: var(--bg-light);
            z-index: 1001;
            transform: translateX(100%);
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            display: flex;
            flex-direction: column;
            box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);
            overflow: hidden;
        }

        .details-panel.active {
            transform: translateX(0);
        }

        .details-close-btn {
            width: 55px;
            height: 36px;
            border: 1px solid var(--border);
            background: var(--bg-white);
            font-size: 24px;
            color: var(--text-gray) !important;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
            transition: all 0.2s;
            flex-shrink: 0;
        }

        .details-close-btn:hover {
            background: var(--bg-light);
            color: var(--text-dark);
            border-color: var(--text-gray);
        }

        .details-panel-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 24px;
            background: var(--bg-white);
            border-bottom: 1px solid var(--border);
            flex-shrink: 0;
        }

        .details-panel-title {
            font-size: 16px;
            font-weight: 600;
            color: var(--text-dark);
        }

        .details-panel-fixed-header {
            flex-shrink: 0;
            padding: 0 24px 16px;
            background: var(--bg-light);
            overflow: hidden;
        }

        .details-panel-fixed-header .details-header {
            margin-bottom: 0;
        }

        .details-panel-content {
            flex: 1 1;
            min-height: 0;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 24px;
        }

        .details-panel-footer {
            flex-shrink: 0;
            background: var(--bg-white);
            border-top: 1px solid var(--border);
            padding: 16px 24px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
        }

        .details-footer-text {
            font-size: 14px;
            color: var(--text-gray);
        }

        .details-footer-actions {
            display: flex;
            gap: 12px;
        }

        .btn-close-panel {
            background: var(--bg-white);
            border: 1px solid var(--border);
            color: var(--text-dark);
            padding: 12px 24px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-close-panel:hover {
            border-color: var(--text-gray);
        }

        .btn-connect {
            background: var(--primary);
            border: none;
            color: white;
            padding: 12px 24px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-connect:hover {
            background: var(--primary-dark);
        }

        /* Details Panel Content Styles */
        .details-header {
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 12px;
            padding: 24px;
            margin-bottom: 16px;
        }

        .details-header-top {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 20px;
        }

        .details-header-left {
            display: flex;
            gap: 16px;
            align-items: flex-start;
        }

        .details-vendor-logo {
            width: 72px;
            height: 72px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            font-weight: 700;
            color: white;
            flex-shrink: 0;
        }

        .details-vendor-info h1 {
            font-size: 22px;
            font-weight: 700;
            color: var(--text-dark);
            margin-bottom: 4px;
        }

        .details-vendor-info p {
            font-size: 14px;
            color: var(--text-gray);
            margin-bottom: 12px;
        }

        .details-vendor-badges {
            display: flex;
            gap: 8px;
        }

        .detail-badge {
            padding: 8px 12px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 600;
        }

        .detail-badge.verified {
            background: rgba(76, 175, 80, 0.12);
            color: var(--success);
        }

        .detail-badge.partner {
            background: rgba(30, 93, 184, 0.12);
            color: var(--primary);
        }

        .detail-badge.new {
            background: rgba(255, 152, 0, 0.12);
            color: var(--accent);
        }

        .detail-badge.service {
            background: var(--bg-light);
            color: var(--text-dark);
            border: 1px solid var(--border);
        }

        .details-header-actions {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        .btn-connect-header {
            background: var(--primary);
            border: none;
            color: white;
            padding: 12px 28px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-connect-header:hover {
            background: var(--primary-dark);
        }

        .btn-favorite {
            background: var(--bg-white);
            border: 1px solid var(--border);
            color: var(--text-dark);
            padding: 10px 20px;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-favorite:hover {
            border-color: var(--primary);
            color: var(--primary);
        }

        .details-stats-row {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 16px;
            padding-top: 20px;
            border-top: 1px solid var(--border);
        }

        .details-stat-item {
            text-align: center;
        }

        .details-stat-label {
            font-size: 11px;
            color: var(--text-light);
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 4px;
        }

        .details-stat-value {
            font-size: 18px;
            font-weight: 700;
            color: var(--text-dark);
        }

        /* Two column layout */
        .details-two-column {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            margin-bottom: 16px;
        }

        .details-card {
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 12px;
            padding: 20px;
        }

        .details-card-title {
            font-size: 15px;
            font-weight: 700;
            color: var(--text-dark);
            margin-bottom: 16px;
        }

        .details-about-text {
            font-size: 14px;
            color: var(--text-gray);
            line-height: 1.6;
            padding-left: 12px;
            border-left: 3px solid var(--primary);
        }

        /* Performance Card */
        .performance-stars {
            display: flex;
            justify-content: center;
            gap: 4px;
            margin-bottom: 8px;
        }

        .performance-star {
            font-size: 28px;
            color: var(--rating);
        }

        .performance-rating {
            text-align: center;
            font-size: 14px;
            color: var(--text-gray);
            margin-bottom: 4px;
        }

        .performance-reviews {
            text-align: center;
            font-size: 12px;
            color: var(--text-light);
            margin-bottom: 20px;
        }

        .performance-bars {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }

        .performance-bar-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 13px;
        }

        .performance-bar-label {
            color: var(--text-gray);
        }

        .performance-bar-value {
            font-weight: 600;
            color: var(--text-dark);
        }

        /* Contact & Business Info */
        .contact-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
        }

        .contact-column-title {
            font-size: 13px;
            font-weight: 600;
            color: var(--text-dark);
            margin-bottom: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .contact-item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px 12px;
            background: var(--bg-light);
            border-radius: 6px;
            margin-bottom: 8px;
            font-size: 13px;
            color: var(--text-gray);
        }

        .contact-item-icon {
            font-size: 16px;
            width: 20px;
            text-align: center;
        }

        @media (min-width: 1421px) {
            .details-panel .details-card-title {
                font-size: 18px;
            }
            .details-panel .details-about-text {
                font-size: 16px;
            }
            .details-panel .performance-star {
                font-size: 32px;
            }
            .details-panel .performance-rating {
                font-size: 16px;
            }
            .details-panel .performance-reviews {
                font-size: 14px;
            }
            .details-panel .performance-bar-item {
                font-size: 15px;
            }
            .details-panel .contact-column-title {
                font-size: 15px;
            }
            .details-panel .contact-item {
                font-size: 15px;
                padding: 12px 14px;
            }
            .details-panel .contact-item-icon {
                font-size: 18px;
                width: 22px;
            }
            .details-panel .service-row {
                font-size: 15px;
                padding-bottom: 14px;
            }
            .details-panel .special-offer-heading {
                font-size: 14px;
                opacity: 0.9;
                margin-bottom: 4px;
            }
            .details-panel .special-offer-count {
                font-size: 16px;
                font-weight: 600;
            }
            .details-panel .coupon-badge {
                font-size: 14px;
                padding: 8px 14px;
            }
            .details-panel .coupon-label {
                font-size: 13px;
            }
            .details-panel .coupon-code {
                font-size: 15px;
            }
            .details-panel .btn-write-review {
                font-size: 15px;
            }
            .details-panel .no-reviews-title {
                font-size: 17px;
            }
            .details-panel .no-reviews-text {
                font-size: 15px;
            }
            .details-panel .reviews-avg-rating {
                font-size: 36px;
            }
            .details-panel .reviews-avg-stars {
                font-size: 18px;
            }
            .details-panel .reviews-count {
                font-size: 14px;
            }
            .details-panel .review-item-title {
                font-size: 16px;
            }
            .details-panel .review-item-text {
                font-size: 15px;
            }
            .details-panel .review-author-avatar {
                font-size: 16px;
                width: 40px;
                height: 40px;
            }
            .details-panel .review-author-info h5 {
                font-size: 16px;
            }
            .details-panel .review-author-info span {
                font-size: 14px;
            }
            .details-panel .review-rating-stars {
                font-size: 16px;
            }
            .details-panel .review-recommend-badge {
                font-size: 13px;
            }
        }

        /* Services Card */
        .services-list {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }

        .service-row {
            display: flex;
            justify-content: space-between;
            font-size: 13px;
            padding-bottom: 12px;
            border-bottom: 1px solid var(--border);
        }

        .service-row:last-child {
            border-bottom: none;
            padding-bottom: 0;
        }

        .service-label {
            color: var(--text-gray);
        }

        .service-value {
            font-weight: 600;
            color: var(--text-dark);
        }

        /* Special Offer Card */
        .special-offer-heading {
            font-size: 12px;
            opacity: 0.9;
            margin-bottom: 4px;
        }
        .special-offer-count {
            font-size: 14px;
            font-weight: 600;
        }
        .special-offer-card {
            background: linear-gradient(135deg, #ff9800, #ff8c00);
            border: none;
            color: white;
            text-align: center;
            padding: 24px;
            position: relative;
            overflow: hidden;
        }

        .special-offer-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: radial-gradient(circle at top right, rgba(255,255,255,0.2), transparent);
            pointer-events: none;
        }

        .special-offer-label {
            font-size: 12px;
            opacity: 0.9;
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
        }

        .special-offer-value {
            font-size: 32px;
            font-weight: 700;
            margin-bottom: 4px;
        }

        .special-offer-desc {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 4px;
        }

        .special-offer-terms {
            font-size: 11px;
            opacity: 0.8;
        }

        /* Reviews Card */
        .reviews-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
        }

        .btn-write-review {
            background: var(--bg-white);
            border: 1px solid var(--primary);
            color: var(--primary);
            padding: 8px 16px;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 6px;
            transition: all 0.2s;
        }

        .btn-write-review:hover {
            background: rgba(30, 93, 184, 0.05);
        }

        .no-reviews {
            text-align: center;
            padding: 40px 20px;
        }

        .no-reviews-icon {
            font-size: 48px;
            margin-bottom: 12px;
            opacity: 0.3;
        }

        .no-reviews-title {
            font-size: 15px;
            font-weight: 600;
            color: var(--text-dark);
            margin-bottom: 4px;
        }

        .no-reviews-text {
            font-size: 13px;
            color: var(--text-light);
        }

        @media (max-width: 800px) {
            .details-panel {
                width: 100%;
            }

            .details-two-column {
                grid-template-columns: 1fr;
            }

            .details-header-top {
                flex-direction: column;
                gap: 16px;
            }

            .details-header-actions {
                flex-direction: row;
                width: 100%;
            }

            .details-header-actions button {
                flex: 1 1;
            }

            .details-stats-row {
                grid-template-columns: repeat(2, 1fr);
            }

            .contact-grid {
                grid-template-columns: 1fr;
            }

            .details-panel-footer {
                flex-direction: column;
                text-align: center;
            }
        }

        /* Connect with Vendor Modal Styles */
        .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            z-index: 2000;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s ease;
        }

        .modal-overlay.active {
            opacity: 1;
            visibility: visible;
        }

        .connect-modal {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0.95);
            width: 600px;
            max-width: 95%;
            max-height: 90vh;
            background: var(--bg-white);
            border-radius: 16px;
            z-index: 2001;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            display: flex;
            flex-direction: column;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }

        .connect-modal.active {
            opacity: 1;
            visibility: visible;
            transform: translate(-50%, -50%) scale(1);
        }

        .connect-modal-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 24px 24px 16px;
            border-bottom: 1px solid var(--border);
        }

        .connect-modal-title-section {
            flex: 1 1;
        }

        .connect-modal-title {
            font-size: 20px;
            font-weight: 700;
            color: var(--text-dark);
            margin-bottom: 8px;
        }

        .connect-modal-vendor {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .connect-modal-vendor-logo {
            width: 32px;
            height: 32px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 700;
            color: white;
        }

        .connect-modal-vendor-name {
            font-size: 14px;
            font-weight: 600;
            color: var(--text-gray);
        }

        .modal-close-btn {
            width: 36px;
            height: 36px;
            border: 1px solid var(--border);
            background: var(--bg-white);
            font-size: 24px;
            color: var(--text-gray);
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
            transition: all 0.2s;
            flex-shrink: 0;
        }

        .modal-close-btn:hover {
            background: var(--bg-light);
            color: var(--text-dark);
            border-color: var(--text-gray);
        }

        .connect-modal-content {
            flex: 1 1;
            overflow-y: auto;
            padding: 24px;
        }

        .connect-intro {
            background: rgba(30, 93, 184, 0.06);
            border: 1px solid rgba(30, 93, 184, 0.15);
            border-radius: 8px;
            padding: 14px 16px;
            margin-bottom: 24px;
            font-size: 13px;
            color: var(--text-gray);
            line-height: 1.6;
        }

        .connect-intro-icon {
            color: var(--primary);
            margin-right: 6px;
        }

        .form-section {
            margin-bottom: 28px;
        }

        .form-section:last-child {
            margin-bottom: 0;
        }

        .form-section-title {
            font-size: 14px;
            font-weight: 700;
            color: var(--text-dark);
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .form-section-number {
            width: 22px;
            height: 22px;
            background: var(--primary);
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: 700;
        }

        .form-section-optional {
            font-weight: 400;
            color: var(--text-gray);
            margin-left: 6px;
        }

        .connect-volume-row {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 24px;
            align-items: start;
        }

        .connect-volume-row .form1-label-uppercase {
            text-transform: uppercase;
            letter-spacing: 0.3px;
        }

        .connect-services-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
        }

        .connect-services-grid .checkbox-item {
            margin: 0;
        }

        @media (max-width: 640px) {
            .connect-volume-row {
                grid-template-columns: 1fr;
            }
        }

        .form-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 14px;
        }

        .form-group {
            display: flex;
            flex-direction: column;
            gap: 6px;
        }

        .form-group.full-width {
            grid-column: 1 / -1;
        }

        .form1-label {
            font-size: 12px;
            font-weight: 600;
            color: var(--text-gray);
            text-transform: uppercase;
            letter-spacing: 0.3px;
        }

        .form-input {
            padding: 10px 14px;
            border: 1px solid var(--border);
            border-radius: 6px;
            font-size: 14px;
            color: var(--text-dark);
            background: var(--bg-white);
            transition: all 0.2s;
        }

        .form-input:focus {
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .form-input.readonly {
            background: var(--bg-light);
            color: var(--text-gray);
            cursor: not-allowed;
        }

        .form-input.readonly:focus {
            border-color: var(--border);
            box-shadow: none;
        }

        .form1-select {
            padding: 10px 14px;
            border: 1px solid var(--border);
            border-radius: 6px;
            font-size: 14px;
            color: var(--text-dark);
            background: var(--bg-white);
            cursor: pointer;
            transition: all 0.2s;
            appearance: none;
            background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
            background-repeat: no-repeat;
            background-position: right 12px center;
            padding-right: 36px;
        }

        .form1-select:focus {
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .form-textarea {
            width: 100%;
            box-sizing: border-box;
            padding: 12px 14px;
            border: 1px solid var(--border);
            border-radius: 6px;
            font-size: 14px;
            color: var(--text-dark);
            background: var(--bg-white);
            resize: vertical;
            min-height: 100px;
            font-family: inherit;
            transition: all 0.2s;
        }

        .form-textarea:focus {
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .checkbox-group {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        .checkbox-row {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
        }

        .checkbox-item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px 14px;
            border: 1px solid var(--border);
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.2s;
        }

        .checkbox-item:hover {
            border-color: var(--primary);
            background: rgba(30, 93, 184, 0.02);
        }

        .checkbox-item.checked {
            border-color: var(--primary);
            background: rgba(30, 93, 184, 0.06);
        }

        .checkbox-item input[type="checkbox"] {
            width: 18px;
            height: 18px;
            accent-color: var(--primary);
            cursor: pointer;
        }

        .checkbox-item label {
            font-size: 13px;
            color: var(--text-dark);
            cursor: pointer;
            flex: 1 1;
        }

        .form-submit-section {
            padding-top: 20px;
            border-top: 1px solid var(--border);
            margin-top: 8px;
        }

        .btn-submit-connect {
            width: 100%;
            background: var(--primary);
            border: none;
            color: white;
            padding: 14px 24px;
            border-radius: 8px;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            margin-bottom: 12px;
        }

        .btn-submit-connect:hover {
            background: var(--primary-dark);
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(30, 93, 184, 0.25);
        }

        .btn-submit-connect:disabled {
            background: var(--text-light);
            cursor: not-allowed;
            transform: none;
            box-shadow: none;
        }

        .form-helper-text {
            font-size: 12px;
            color: var(--text-light);
            text-align: center;
        }

        /* Success State */
        .connect-success {
            text-align: center;
            padding: 40px 20px;
        }

        .connect-success-icon {
            width: 64px;
            height: 64px;
            background: rgba(76, 175, 80, 0.12);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            margin: 0 auto 20px;
        }

        .connect-success-title {
            font-size: 20px;
            font-weight: 700;
            color: var(--text-dark);
            margin-bottom: 8px;
        }

        .connect-success-text {
            font-size: 14px;
            color: var(--text-gray);
            margin-bottom: 24px;
        }

        .btn-success-close {
            background: var(--primary);
            border: none;
            color: white;
            padding: 12px 32px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-success-close:hover {
            background: var(--primary-dark);
        }

        /* Requested Status Badge */
        .btn-requested {
            background: rgba(76, 175, 80, 0.1);
            border: 1px solid rgba(76, 175, 80, 0.3);
            color: var(--success);
            padding: 12px 24px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 600;
            cursor: default;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
        }

        .btn-requested-header {
            background: rgba(76, 175, 80, 0.1);
            border: 1px solid rgba(76, 175, 80, 0.3);
            color: var(--success);
            padding: 12px 28px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 600;
            cursor: default;
            display: flex;
            align-items: center;
            gap: 6px;
        }

        @media (max-width: 600px) {
            .connect-modal {
                width: 100%;
                max-width: 100%;
                height: 100%;
                max-height: 100%;
                border-radius: 0;
            }

            .form-grid {
                grid-template-columns: 1fr;
            }

            .checkbox-row {
                grid-template-columns: 1fr;
            }
        }

        /* Request Vendor Modal Styles */
        .request-vendor-subtitle {
            font-size: 14px;
            color: var(--text-gray);
            line-height: 1.5;
            margin-top: 4px;
        }

        .request-form-group {
            margin-bottom: 20px;
        }

        .request-form-label {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            font-weight: 600;
            color: var(--text-dark);
            margin-bottom: 10px;
        }

        .request-label-icon {
            font-size: 16px;
        }

        .required {
            color: #e53935;
        }

        .optional {
            font-weight: 400;
            color: var(--text-light);
            font-size: 13px;
        }

        .request-input-wrapper {
            position: relative;
            display: flex;
            align-items: center;
        }

        .request-input-icon {
            position: absolute;
            left: 14px;
            font-size: 16px;
            color: var(--text-light);
            pointer-events: none;
        }

        .request-form-input {
            width: 100%;
            padding: 12px 14px 12px 44px;
            border: 1px solid var(--border);
            border-radius: 8px;
            font-size: 14px;
            color: var(--text-dark);
            background: var(--bg-white);
            transition: all 0.2s;
        }

        .request-form-input:focus {
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .request-form-input::placeholder {
            color: var(--text-light);
        }

        .request-form-select {
            width: 100%;
            padding: 3px 14px 12px 44px;
            border: 1px solid var(--border);
            border-radius: 8px;
            font-size: 14px;
            color: var(--text-dark);
            background: var(--bg-white);
            cursor: pointer;
            transition: all 0.2s;
            appearance: none;
            background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
            background-repeat: no-repeat;
            background-position: right 14px center;
        }

        .request-form-select:focus {
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .request-textarea-wrapper {
            position: relative;
        }

        .request-form-textarea {
            width: 100%;
            padding: 14px;
            border: 1px solid var(--border);
            border-radius: 8px;
            font-size: 14px;
            color: var(--text-dark);
            background: var(--bg-white);
            resize: vertical;
            min-height: 100px;
            font-family: inherit;
            transition: all 0.2s;
        }

        .request-form-textarea:focus {
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .request-form-textarea::placeholder {
            color: var(--text-light);
        }

        .textarea-icon {
            position: absolute;
            bottom: 12px;
            left: 14px;
            font-size: 16px;
            color: var(--text-light);
            pointer-events: none;
        }

        .request-radio-group {
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-bottom: 24px;
        }

        .request-radio-item {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            padding: 14px 16px;
            border: 1px solid var(--border);
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s;
        }

        .request-radio-item:hover {
            border-color: var(--primary);
            background: rgba(30, 93, 184, 0.02);
        }

        .request-radio-item input[type="radio"] {
            width: 18px;
            height: 18px;
            margin-top: 2px;
            accent-color: var(--primary);
            cursor: pointer;
            flex-shrink: 0;
        }

        .radio-content {
            display: flex;
            flex-direction: column;
            gap: 2px;
        }

        .radio-title {
            font-size: 14px;
            font-weight: 600;
            color: var(--text-dark);
        }

        .radio-description {
            font-size: 12px;
            color: var(--text-light);
        }

        .request-form-actions {
            display: flex;
            justify-content: flex-end;
            gap: 12px;
            padding-top: 20px;
            border-top: 1px solid var(--border);
        }

        .btn-request-cancel {
            background: var(--bg-white);
            border: 1px solid var(--border);
            color: var(--text-dark);
            padding: 12px 24px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-request-cancel:hover {
            border-color: var(--text-gray);
            background: var(--bg-light);
        }

        .btn-request-submit {
            background: var(--primary);
            border: none;
            color: white;
            padding: 12px 24px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-request-submit:hover {
            background: var(--primary-dark);
        }

        /* Request Vendor Success */
        .request-success {
            text-align: center;
            padding: 40px 20px;
        }

        .request-success-icon {
            width: 64px;
            height: 64px;
            background: rgba(76, 175, 80, 0.12);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            margin: 0 auto 20px;
        }

        .request-success-title {
            font-size: 20px;
            font-weight: 700;
            color: var(--text-dark);
            margin-bottom: 8px;
        }

        .request-success-text {
            font-size: 14px;
            color: var(--text-gray);
            margin-bottom: 24px;
            line-height: 1.5;
        }

        /* Add to Cart Modal Styles */
        .cart-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: 3000;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s ease;
        }

        .cart-modal-overlay.active {
            opacity: 1;
            visibility: visible;
        }

        .cart-modal {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0.95);
            width: 500px;
            max-width: 95%;
            background: var(--bg-white);
            border-radius: 12px;
            z-index: 3001;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
            overflow: hidden;
        }

        .cart-modal.active {
            opacity: 1;
            visibility: visible;
            transform: translate(-50%, -50%) scale(1);
        }

        @media (min-width: 1022px) {
            .cart-modal {
                width: 56%;
                max-width: 56%;
            }
        }

        .cart-modal-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 20px 24px;
            border-bottom: 1px solid var(--border);
            background: var(--bg-light);
        }

        .cart-modal-header-content {
            display: flex;
            align-items: flex-start;
            gap: 12px;
        }

        .cart-success-icon {
            width: 24px;
            height: 24px;
            background: var(--success);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 14px;
            flex-shrink: 0;
            margin-top: 2px;
        }

        .cart-modal-title {
            font-size: 16px;
            font-weight: 700;
            color: var(--text-dark);
            margin-bottom: 4px;
        }

        .cart-modal-subtitle {
            font-size: 13px;
            color: var(--text-gray);
        }

        .cart-modal-close {
            width: 32px;
            height: 32px;
            border: none;
            background: transparent;
            font-size: 22px;
            color: var(--text-gray);
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            transition: all 0.2s;
        }

        .cart-modal-close:hover {
            background: var(--bg-white);
            color: var(--text-dark);
        }

        .cart-modal-body {
            padding: 24px;
        }

        .cart-product-label {
            font-size: 13px;
            font-weight: 600;
            color: var(--text-dark);
            margin-bottom: 16px;
        }

        .cart-product-details {
            display: flex;
            gap: 16px;
            margin-bottom: 20px;
            min-width: 0;
        }

        .cart-product-image {
            width: 80px;
            height: 80px;
            background: var(--bg-light);
            border: 1px solid var(--border);
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 36px;
            flex-shrink: 0;
        }

        .cart-product-info {
            flex: 1 1;
            min-width: 0;
        }

        .cart-product-name {
            font-size: 14px;
            font-weight: 600;
            color: var(--primary);
            margin-bottom: 10px;
            line-height: 1.4;
            max-width: 100%;
            overflow-wrap: anywhere;
            word-break: break-word;
        }

        .cart-product-meta {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }

        .cart-product-meta-first-row {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 16px 24px;
            font-size: 13px;
        }

        .cart-product-meta-first-row .cart-meta-group {
            display: flex;
            align-items: center;
            gap: 6px;
        }

        .cart-product-meta-row {
            display: flex;
            gap: 24px;
            font-size: 13px;
        }

        .cart-meta-label {
            color: var(--text-gray);
        }

        .cart-meta-value {
            font-weight: 600;
            color: var(--text-dark);
        }

        .cart-meta-price {
            font-weight: 700;
            color: var(--success);
        }

        .cart-product-sku {
            font-size: 12px;
            color: var(--text-light);
            align-items: flex-start;
            flex-wrap: wrap;
            gap: 6px 12px;
            min-width: 0;
        }

        .cart-product-sku .cart-meta-label {
            flex-shrink: 0;
        }

        .cart-product-sku .cart-meta-value {
            flex: 1 1;
            min-width: 0;
            max-width: 100%;
            overflow-wrap: anywhere;
            word-break: break-word;
        }

        .cart-subtotal {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: 16px;
            border-top: 1px solid var(--border);
        }

        .cart-subtotal-label {
            font-size: 14px;
            font-weight: 600;
            color: var(--text-dark);
        }

        .cart-subtotal-value {
            font-size: 18px;
            font-weight: 700;
            color: var(--text-dark);
        }

        .cart-modal-actions {
            display: flex;
            gap: 12px;
            padding: 20px 24px;
            border-top: 1px solid var(--border);
            background: var(--bg-white);
        }

        .btn-continue-shopping {
            flex: 1 1;
            background: var(--bg-white);
            border: 1px solid var(--border);
            color: var(--text-dark);
            padding: 12px 20px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-continue-shopping:hover {
            border-color: var(--primary);
            color: var(--primary);
        }

        .btn-proceed-checkout {
            flex: 1 1;
            background: var(--primary);
            border: none;
            color: white;
            padding: 12px 20px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-proceed-checkout:hover {
            background: var(--primary-dark);
        }

        /* Write Review Modal Styles */
        .review-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: 3000;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s ease;
        }

        .review-modal-overlay.active {
            opacity: 1;
            visibility: visible;
        }

        .review-modal {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0.95);
            width: 500px;
            max-width: 95%;
            max-height: 90vh;
            background: var(--bg-white);
            border-radius: 12px;
            z-index: 3001;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
            display: flex;
            flex-direction: column;
        }

        .review-modal.active {
            opacity: 1;
            visibility: visible;
            transform: translate(-50%, -50%) scale(1);
        }

        .review-modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px 24px;
            border-bottom: 1px solid var(--border);
        }

        .review-modal-title {
            font-size: 18px;
            font-weight: 700;
            color: var(--text-dark);
        }

        .review-modal-close {
            width: 32px;
            height: 32px;
            border: none;
            background: transparent;
            font-size: 22px;
            color: var(--text-gray);
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            transition: all 0.2s;
        }

        .review-modal-close:hover {
            background: var(--bg-light);
            color: var(--text-dark);
        }

        .review-modal-content {
            flex: 1 1;
            overflow-y: auto;
            padding: 24px;
        }

        .review-vendor-info {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 16px;
            background: var(--bg-light);
            border-radius: 8px;
            margin-bottom: 24px;
        }

        .review-vendor-logo {
            width: 48px;
            height: 48px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            font-weight: 700;
            color: white;
        }

        .review-vendor-details h4 {
            font-size: 15px;
            font-weight: 600;
            color: var(--text-dark);
            margin-bottom: 2px;
        }

        .review-vendor-details span {
            font-size: 13px;
            color: var(--text-gray);
        }

        .review-form-group {
            margin-bottom: 20px;
        }

        .review-form-label {
            display: block;
            font-size: 14px;
            font-weight: 600;
            color: var(--text-dark);
            margin-bottom: 8px;
        }

        .review-form-label .required {
            color: #e53935;
        }

        .star-rating {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .star-rating-stars {
            display: flex;
            gap: 4px;
        }

        .star-rating-star {
            font-size: 28px;
            color: #ddd;
            cursor: pointer;
            transition: all 0.2s;
        }

        .star-rating-star:hover,
        .star-rating-star.active {
            color: var(--rating);
            transform: scale(1.1);
        }

        .star-rating-text {
            font-size: 13px;
            color: var(--text-gray);
        }

        .review-form-input {
            width: 100%;
            padding: 12px 14px;
            border: 1px solid var(--border);
            border-radius: 8px;
            font-size: 14px;
            color: var(--text-dark);
            transition: all 0.2s;
        }

        .review-form-input:focus {
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .review-form-textarea {
            width: 100%;
            padding: 12px 14px;
            border: 1px solid var(--border);
            border-radius: 8px;
            font-size: 14px;
            color: var(--text-dark);
            resize: vertical;
            min-height: 120px;
            font-family: inherit;
            transition: all 0.2s;
        }

        .review-form-textarea:focus {
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);
        }

        .review-char-count {
            font-size: 12px;
            color: var(--text-light);
            margin-top: 6px;
        }

        .review-recommend {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 14px 16px;
            background: var(--bg-light);
            border-radius: 8px;
            cursor: pointer;
        }

        .review-recommend input[type="checkbox"] {
            width: 18px;
            height: 18px;
            accent-color: var(--primary);
        }

        .review-recommend span {
            font-size: 14px;
            color: var(--text-dark);
        }

        .review-modal-footer {
            display: flex;
            gap: 12px;
            padding: 20px 24px;
            border-top: 1px solid var(--border);
        }

        .btn-review-cancel {
            flex: 1 1;
            background: var(--bg-light);
            border: none;
            color: var(--text-dark);
            padding: 12px 20px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-review-cancel:hover {
            background: #e0e0e0;
        }

        .btn-review-submit {
            flex: 1.5 1;
            background: var(--primary);
            border: none;
            color: white;
            padding: 12px 20px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-review-submit:hover {
            background: var(--primary-dark);
        }

        /* Customer Reviews List Styles */
        .reviews-list {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        .review-item {
            padding: 16px;
            background: var(--bg-light);
            border-radius: 8px;
        }

        .review-item-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 10px;
        }

        .review-author {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .review-author-avatar {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background: var(--primary);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 600;
        }

        .review-author-info h5 {
            font-size: 14px;
            font-weight: 600;
            color: var(--text-dark);
            margin-bottom: 2px;
        }

        .review-author-info span {
            font-size: 12px;
            color: var(--text-light);
        }

        .review-rating-stars {
            color: var(--rating);
            font-size: 14px;
        }

        .review-item-title {
            font-size: 14px;
            font-weight: 600;
            color: var(--text-dark);
            margin-bottom: 8px;
        }

        .review-item-text {
            font-size: 13px;
            color: var(--text-gray);
            line-height: 1.6;
            margin-bottom: 10px;
        }

        .review-recommend-badge {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 12px;
            color: var(--success);
            background: rgba(76, 175, 80, 0.1);
            padding: 4px 10px;
            border-radius: 4px;
        }

        .reviews-summary {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 16px;
            margin-bottom: 16px;
            border-bottom: 1px solid var(--border);
        }

        .reviews-summary-left {
            display: flex;
            align-items: center;
            gap: 12px;
        }

        .reviews-avg-rating {
            font-size: 32px;
            font-weight: 700;
            color: var(--text-dark);
        }

        .reviews-avg-info {
            display: flex;
            flex-direction: column;
            gap: 2px;
        }

        .reviews-avg-stars {
            color: var(--rating);
            font-size: 16px;
        }

        .reviews-count {
            font-size: 12px;
            color: var(--text-gray);
        }

        /* Shopping Cart Page Styles */
        .cart-page {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: var(--bg-light);
            z-index: 999;
            overflow-y: auto;
        }

        .cart-page.active {
            display: block;
        }

        .cart-page-header {
            background: var(--bg-white);
            border-bottom: 1px solid var(--border);
            padding: 16px 0;
            position: sticky;
            top: 0;
            z-index: 100;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        }

        .cart-page-header-content {
            max-width: 1320px;
            margin: 0 auto;
            padding: 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .cart-back-link {
            display: flex;
            align-items: center;
            gap: 8px;
            color: var(--text-gray);
            font-size: 14px;
            cursor: pointer;
            transition: color 0.2s;
        }

        .cart-back-link:hover {
            color: var(--primary);
        }

        .cart-header-right {
            display: flex;
            align-items: center;
            gap: 20px;
        }

        .cart-header-icon {
            position: relative;
            font-size: 20px;
            color: var(--text-gray);
            cursor: pointer;
        }

        .cart-header-icon:hover {
            color: var(--primary);
        }

        .cart-badge {
            position: absolute;
            top: -8px;
            right: -8px;
            background: #e53935;
            color: white;
            font-size: 10px;
            font-weight: 700;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .cart-user-info {
            display: flex;
            align-items: center;
            gap: 10px;
            cursor: pointer;
        }

        .cart-user-avatar {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background: linear-gradient(135deg, #667BC6, #4A5BA8);
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 14px;
            font-weight: 600;
        }

        .cart-user-name {
            font-size: 14px;
            font-weight: 600;
            color: var(--text-dark);
        }

        .cart-user-role {
            font-size: 12px;
            color: var(--text-light);
        }

        .cart-page-content {
            max-width: 1320px;
            margin: 0 auto;
            padding: 30px 20px;
        }

        .cart-page-title {
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 24px;
            font-weight: 700;
            color: var(--text-dark);
            margin-bottom: 8px;
        }

        .cart-page-title-icon {
            font-size: 22px;
        }

        .cart-item-count {
            font-size: 14px;
            color: var(--text-gray);
            margin-bottom: 24px;
        }

        .cart-layout {
            display: grid;
            grid-template-columns: 1fr 380px;
            gap: 24px;
            align-items: start;
        }

        /* Cart Items Section */
        .cart-items-section {
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 12px;
            overflow-x: auto;
        }

        .cart-items-header {
            display: grid;
            grid-template-columns: minmax(0, 1.25fr) 64px 88px 64px 72px 32px;
            gap: 8px;
            padding: 12px 14px;
            background: var(--bg-light);
            border-bottom: 1px solid var(--border);
            font-size: 11px;
            font-weight: 600;
            color: var(--text-gray);
            text-transform: uppercase;
            letter-spacing: 0.4px;
            min-width: 620px;
        }

        .cart-items-header > div:not(:first-child) {
            text-align: center;
        }

        .cart-item {
            display: grid;
            grid-template-columns: minmax(0, 1.25fr) 64px 88px 64px 72px 32px;
            gap: 8px;
            padding: 12px 14px;
            border-bottom: 1px solid var(--border);
            align-items: center;
            min-width: 620px;
        }

        .cart-item:last-child {
            border-bottom: none;
        }

        .cart-item-info {
            display: flex;
            gap: 10px;
            align-items: center;
            min-width: 0;
        }

        .cart-item-image {
            width: 56px;
            height: 56px;
            /* background: var(--bg-light);
            border: 1px solid var(--border);
            border-radius: 8px; */
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            flex-shrink: 0;
        }

        .cart-item-details h4 {
            font-size: 13px;
            font-weight: 600;
            color: var(--text-dark);
            margin-bottom: 4px;
            line-height: 1.35;
        }

        .cart-item-meta {
            font-size: 12px;
            color: var(--text-gray);
            display: flex;
            flex-direction: column;
            gap: 2px;
        }

        .cart-item-meta span {
            display: flex;
            gap: 4px;
        }

        .cart-item-meta strong {
            color: var(--text-dark);
        }

        .cart-quantity {
            display: flex;
            align-items: center;
            gap: 0;
            border: 1px solid var(--border);
            border-radius: 6px;
            overflow: hidden;
            width: fit-content;
            justify-self: center;
        }

        .cart-qty-btn {
            width: 26px;
            height: 28px;
            border: none;
            background: var(--bg-light);
            color: var(--text-dark);
            font-size: 14px;
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .cart-qty-btn:hover {
            background: var(--primary);
            color: white;
        }

        .cart-qty-input {
            width: 32px;
            height: 28px;
            border: none;
            border-left: 1px solid var(--border);
            border-right: 1px solid var(--border);
            text-align: center;
            font-size: 13px;
            font-weight: 600;
            color: var(--text-dark);
            padding: 0;
        }

        .cart-qty-input:focus {
            outline: none;
        }

        .cart-item-price {
            font-size: 13px;
            font-weight: 600;
            color: var(--text-dark);
            text-align: center;
            white-space: nowrap;
        }

        .cart-item-discount {
            font-size: 13px;
            text-align: center;
            white-space: nowrap;
        }

        .cart-item-subtotal {
            font-size: 13px;
            font-weight: 700;
            color: var(--text-dark);
            text-align: center;
            white-space: nowrap;
        }

        .cart-item-action {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .cart-item-remove {
            width: 28px;
            height: 28px;
            border: none;
            background: transparent;
            color: var(--text-light);
            font-size: 18px;
            cursor: pointer;
            border-radius: 6px;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .cart-item-remove .cart-item-remove-icon {
            font-size: 22px;
        }

        .cart-item-remove:hover {
            background: #ffebee;
            color: #e53935;
        }

        /* Order Summary Section */
        .order-summary {
            background: var(--bg-white);
            border: 1px solid var(--border);
            border-radius: 12px;
            padding: 24px;
            position: sticky;
            top: 100px;
        }

        .order-summary-title {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 16px;
            font-weight: 700;
            color: var(--text-dark);
            margin-bottom: 20px;
            padding-bottom: 16px;
            border-bottom: 1px solid var(--border);
        }

        .order-summary-rows {
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-bottom: 16px;
        }

        .order-summary-row {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
        }

        .order-summary-row .label {
            color: var(--text-gray);
        }

        .order-summary-row .value {
            color: var(--text-dark);
            font-weight: 500;
        }

        .order-summary-row.discount .label {
            color: var(--success);
        }

        .order-summary-row.discount .value {
            color: var(--success);
        }

        .order-summary-row.tbd .value {
            color: var(--text-light);
            font-size: 13px;
        }

        .order-summary-total {
            display: flex;
            justify-content: space-between;
            padding-top: 16px;
            border-top: 1px solid var(--border);
            margin-bottom: 20px;
        }

        .order-summary-total .label {
            font-size: 15px;
            font-weight: 600;
            color: var(--text-dark);
        }

        .order-summary-total .value {
            font-size: 20px;
            font-weight: 700;
            color: var(--text-dark);
        }

        .discount-code-section {
            margin-bottom: 16px;
        }

        .btn-apply-discount {
            width: 100%;
            padding: 12px;
            border: 1px dashed var(--primary);
            background: rgba(30, 93, 184, 0.04);
            color: var(--primary);
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            transition: all 0.2s;
        }

        .btn-apply-discount:hover {
            background: rgba(30, 93, 184, 0.08);
        }

        .discount-input-group {
            display: none;
            gap: 8px;
            margin-top: 12px;
        }

        .discount-input-group.active {
            display: flex;
        }

        .discount-input {
            flex: 1 1;
            padding: 10px 14px;
            border: 1px solid var(--border);
            border-radius: 6px;
            font-size: 14px;
        }

        .discount-input:focus {
            outline: none;
            border-color: var(--primary);
        }

        .btn-apply-code {
            padding: 10px 16px;
            background: var(--primary);
            border: none;
            color: white;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
        }

        .btn-apply-code:hover {
            background: var(--primary-dark);
        }

        .applied-discount {
            display: none;
            align-items: center;
            justify-content: space-between;
            padding: 10px 14px;
            background: rgba(76, 175, 80, 0.08);
            border: 1px solid rgba(76, 175, 80, 0.3);
            border-radius: 8px;
            margin-top: 12px;
        }

        .applied-discount.active {
            display: flex;
        }

        .applied-discount-info {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 13px;
            color: var(--success);
            font-weight: 600;
        }

        .applied-discount-remove {
            background: none;
            border: none;
            color: var(--text-gray);
            cursor: pointer;
            font-size: 16px;
        }

        .applied-discount-remove:hover {
            color: #e53935;
        }

        .special-fees-section {
            margin-bottom: 20px;
            padding: 14px;
            border: 1px solid var(--border);
            border-radius: 8px;
        }

        .special-fees-title {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 13px;
            font-weight: 600;
            color: var(--text-dark);
            margin-bottom: 8px;
        }

        .special-fees-empty {
            font-size: 12px;
            color: var(--text-light);
        }

        .order-summary-actions {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }

        .btn-checkout {
            width: 100%;
            padding: 14px;
            background: var(--primary);
            border: none;
            color: white;
            border-radius: 8px;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            transition: all 0.2s;
        }

        .btn-checkout:hover {
            background: var(--primary-dark);
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(30, 93, 184, 0.25);
        }

        .btn-continue-shopping-cart {
            width: 100%;
            padding: 12px;
            background: var(--bg-white);
            border: 1px solid var(--border);
            color: var(--text-dark);
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-continue-shopping-cart:hover {
            border-color: var(--primary);
            color: var(--primary);
        }

        .secure-checkout-text {
            text-align: center;
            font-size: 11px;
            color: var(--text-light);
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            margin-top: 16px;
            }

        /* Empty Cart State */
        .empty-cart {
            text-align: center;
            padding: 60px 20px;
        }

        .empty-cart-icon {
            font-size: 64px;
            margin-bottom: 20px;
            opacity: 0.3;
        }

        .empty-cart-title {
            font-size: 20px;
            font-weight: 700;
            color: var(--text-dark);
            margin-bottom: 8px;
        }

        .empty-cart-text {
            font-size: 14px;
            color: var(--text-gray);
            margin-bottom: 24px;
        }

        .btn-start-shopping {
            padding: 12px 32px;
            background: var(--primary);
            border: none;
            color: white;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
        }

        .btn-start-shopping:hover {
            background: var(--primary-dark);
        }

        /* Cart Savings Banner */
        .cart-savings-banner {
            background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(76, 175, 80, 0.05));
            border: 1px solid rgba(76, 175, 80, 0.2);
            border-radius: 8px;
            padding: 12px 16px;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .cart-savings-icon {
            font-size: 20px;
        }

        .cart-savings-text {
            font-size: 13px;
            color: var(--success);
            font-weight: 500;
        }

        .cart-savings-amount {
            font-weight: 700;
        }

        @media (max-width: 900px) {
            .cart-layout {
                grid-template-columns: 1fr;
            }

            .order-summary {
                position: static;
            }

            .cart-items-header {
                display: grid;
            }

            .cart-item {
                grid-template-columns: minmax(0, 1.25fr) 64px 88px 64px 72px 32px;
            }

            .cart-item-info {
                flex-direction: row;
                align-items: center;
            }
        }

        @keyframes slideUp {
            from {
                opacity: 0;
                transform: translateY(20px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        .vendor-card {
            animation: slideUp 0.5s ease-out forwards;
        }

        .vendor-card:nth-child(1) { animation-delay: 0.05s; }
        .vendor-card:nth-child(2) { animation-delay: 0.1s; }
        .vendor-card:nth-child(3) { animation-delay: 0.15s; }
        .vendor-card:nth-child(4) { animation-delay: 0.2s; }
        .vendor-card:nth-child(5) { animation-delay: 0.25s; }
        .vendor-card:nth-child(6) { animation-delay: 0.3s; }
        .vendor-card:nth-child(7) { animation-delay: 0.35s; }
        .vendor-card:nth-child(8) { animation-delay: 0.4s; }
        .vendor-card:nth-child(9) { animation-delay: 0.45s; }

        @media (max-width: 900px) {
            .cta-section {
                grid-template-columns: 1fr;
                gap: 24px;
            }

            .hero h1 {
                font-size: 28px;
            }

            .controls {
                flex-direction: column;
            }

            .search-wrapper {
                min-width: 100%;
            }

            .vendors-grid {
                grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
            }
        }

        @media (max-width: 600px) {
            .main {
                padding: 24px 16px;
            }

            .hero h1 {
                font-size: 24px;
            }

            .vendors-grid {
                grid-template-columns: 1fr;
            }

            .vendor-image {
                height: 140px;
            }

            .cta-section {
                padding: 20px;
            }
          }

          /* Shared datatable (pp-table) — used by ordercheckoutpop and ProductSelectionModal */
          .pp-table-container {
            flex: 1 1;
            max-height: 520px;
            overflow-y: auto;
            overflow-x: auto;
          }
          .pp-table {
            width: 100%;
            border-collapse: collapse;
          }
          .pp-table thead {
            position: sticky;
            top: 0;
            z-index: 10;
            background: #fff;
          }
          .pp-table thead tr {
            border-bottom: 2px solid #e5e7eb;
          }
          .pp-table th {
            padding: 16px 20px;
            text-align: left;
            font-size: 13px;
            font-weight: 600;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            background: #f9fafb;
            white-space: nowrap;
          }
          .pp-table td {
            padding: 24px 20px;
            font-size: 14px;
            color: #374151;
            vertical-align: middle;
          }
          .pp-table tbody tr {
            border-bottom: 1px solid #f3f4f6;
            transition: all 0.2s;
          }
          .pp-table tbody tr:hover {
            background: #fafbfc;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
          }

          /* ProductSelectionModal: no horizontal scroll, product name truncate */
          .psm-table-container {
            overflow-x: hidden;
          }
          .psm-products-table td:nth-child(2) {
            overflow: hidden;
          }
          .psm-products-table .table-cells-product-name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            min-width: 0;
          }
         .list-group-item {
  background: transparent !important;
}

/* Order cart page table — keeps Product/Price/Qty/Discount/Subtotal/Action on one row */
.order-cart-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.order-cart-table thead th {
  padding: 12px 10px;
  background: var(--bg-light, #f8f9fa);
  border-bottom: 1px solid var(--border, #e0e0e0);
  font-size: 11px;
  font-weight: 600;
  color: var(--text-gray, #666);
  text-transform: uppercase;
  letter-spacing: 0.4px;
  text-align: center;
  vertical-align: middle;
}

.order-cart-table thead th:first-child {
  text-align: left;
  padding-left: 14px;
}

.order-cart-table tbody td {
  padding: 12px 10px;
  border-bottom: 1px solid var(--border, #e0e0e0);
  vertical-align: middle;
  text-align: center;
}

.order-cart-table tbody td:first-child {
  text-align: left;
  padding-left: 14px;
}

.order-cart-table tbody tr:last-child td {
  border-bottom: none;
}

.order-cart-col-product { width: 36%; }
.order-cart-col-price { width: 12%; }
.order-cart-col-qty { width: 16%; }
.order-cart-col-discount { width: 12%; }
.order-cart-col-subtotal { width: 14%; }
.order-cart-col-action { width: 10%; }

.order-cart-table .cart-item-info {
  display: flex;
  gap: 10px;
  align-items: center;
  min-width: 0;
}

.order-cart-table .cart-item-details {
  min-width: 0;
  flex: 1 1;
}

.order-cart-table .cart-item-details h4 {
  font-size: 13px;
  margin-bottom: 4px;
  word-break: break-word;
}

.order-cart-table .custom-fields-container {
  max-width: 100%;
}

.order-cart-table .cart-quantity {
  margin: 0 auto;
}

.order-cart-table tbody td.cart-item-action {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  padding: 12px 8px;
}

.order-cart-table tbody td.cart-item-action .cart-item-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  margin: 0;
  line-height: 1;
}

.order-cart-table tbody td.cart-item-action .cart-item-remove-icon {
  display: block;
  line-height: 1;
}

@media (max-width: 900px) {
  .cart-items-section {
    overflow-x: auto;
  }

  .order-cart-table {
    min-width: 640px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/SignageOrders.css"],"names":[],"mappings":"AAAA,aAAa,kBAAkB,EAAE,WAAW,EAAE,iBAAiB,EAAE;;AAEjE,iDAAiD;AACjD;8BAC8B,sBAAsB,EAAE,kBAAkB,EAAE;;AAE1E;EACE;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU,CAAC,UAAU,CAAC,iBAAiB;EACvC,mBAAmB,CAAC,kBAAkB,CAAC,sBAAsB;EAC7D,cAAc;AAChB;AACA,cAAc,kBAAkB,EAAE,aAAa,EAAE,EAAE,YAAY;AAC/D,cAAc,kBAAkB,EAAE,aAAa,EAAE,EAAE,UAAU;;;AAG7D;EACE,8DAA8D;EAC9D,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,+BAA+B;;AAEjC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,+BAA+B;;AAEjC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;;AAEA,uCAAuC;AACvC;EACE,gCAAgC;AAClC;;AAEA,kEAAkE;AAClE;;;EAGE,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,2BAA2B;AAC7B;;AAEA,+CAA+C;AAC/C;EACE,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA,+CAA+C;AAC/C;;;;;;EAME,kBAAkB;EAClB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB,YAAY,gDAAgD;EAC9E,4BAA4B,EAAE,kCAAkC;AAClE;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB,EAAE,yBAAyB;AAChD;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;AACrB;AACA,sCAAsC;AACtC;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;;;;EAInC;YACU,kBAAkB;YAClB,wBAAwB;YACxB,uBAAuB;YACvB,iBAAiB;YACjB,oBAAoB;YACpB,oBAAoB;YACpB,qBAAqB;YACrB,mBAAmB;YACnB,mBAAmB;YACnB,iBAAiB;YACjB,kBAAkB;YAClB,iBAAiB;YACjB,sBAAsB;YACtB,qBAAqB;QACzB;;QAEA;YACI,iCAAiC;YACjC,2BAA2B;YAC3B,uBAAuB;YACvB,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA,oBAAoB;QACpB;YACI,eAAe;YACf,MAAM;YACN,OAAO;YACP,QAAQ;YACR,4BAA4B;YAC5B,2BAA2B;YAC3B,sCAAsC;YACtC,aAAa;YACb,mBAAmB;YACnB,8BAA8B;YAC9B,eAAe;YACf,aAAa;QACjB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,QAAQ;YACR,gBAAgB;YAChB,YAAY;YACZ,eAAe;YACf,YAAY;QAChB;;QAEA;YACI,cAAc;YACd,WAAW;YACX,WAAW;YACX,4BAA4B;YAC5B,kBAAkB;YAClB,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,4DAA4D;YAC5D,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,YAAY;YACZ,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,SAAO;YACP,gBAAgB;YAChB,cAAc;QAClB;;QAEA;YACI,kBAAkB;YAClB,aAAa;YACb,mBAAmB;QACvB;;QAEA;YACI,kBAAkB;YAClB,UAAU;YACV,eAAe;YACf,wBAAwB;QAC5B;;QAEA;YACI,WAAW;YACX,4BAA4B;YAC5B,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,2BAA2B;YAC3B,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,2BAA2B;YAC3B,4CAA4C;QAChD;;QAEA;YACI,kBAAkB;YAClB,WAAW;YACX,gBAAgB;YAChB,2BAA2B;YAC3B,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,wBAAwB;QAC5B;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,YAAY;YACZ,uBAAuB;YACvB,kBAAkB;YAClB,eAAe;YACf,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,kBAAkB;YAClB,oBAAoB;QACxB;;QAEA;YACI,2BAA2B;QAC/B;;QAEA;YACI,kBAAkB;QACtB;;QAEA;YACI,kBAAkB;YAClB,QAAQ;YACR,UAAU;YACV,WAAW;YACX,YAAY;YACZ,mBAAmB;YACnB,YAAY;YACZ,eAAe;YACf,gBAAgB;YAChB,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;QAC3B;;QAEA;YACI,UAAU;YACV,YAAY;YACZ,yBAAyB;YACzB,aAAa;QACjB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,yBAAyB;YACzB,kBAAkB;YAClB,eAAe;YACf,oBAAoB;YACpB,kBAAkB;QACtB;;QAEA;YACI,2BAA2B;QAC/B;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,qDAAqD;YACrD,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,YAAY;YACZ,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,aAAa;YACb,sBAAsB;QAC1B;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,wBAAwB;QAC5B;;QAEA;YACI,eAAe;YACf,wBAAwB;QAC5B;;QAEA;YACI,kBAAkB;YAClB,SAAS;YACT,QAAQ;YACR,eAAe;YACf,YAAY;YACZ,2BAA2B;YAC3B,+BAA+B;YAC/B,mBAAmB;YACnB,2CAA2C;YAC3C,UAAU;YACV,kBAAkB;YAClB,4BAA4B;YAC5B,oBAAoB;YACpB,aAAa;QACjB;;QAEA;YACI,UAAU;YACV,mBAAmB;YACnB,wBAAwB;QAC5B;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,aAAa;QACjB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,qDAAqD;YACrD,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,YAAY;YACZ,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,WAAW;YACX,yBAAyB;YACzB,aAAa;QACjB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,kBAAkB;YAClB,uBAAuB;YACvB,qBAAqB;YACrB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,2BAA2B;QAC/B;;QAEA;YACI,cAAc;QAClB;;QAEA,sBAAsB;QACtB;YACI,eAAe;YACf,yBAAyB;YACzB,OAAO;YACP,SAAS;YACT,2BAA2B;YAC3B,2BAA2B;YAC3B,qCAAqC;YACrC,aAAa;YACb,sBAAsB;YACtB,YAAY;YACZ,+BAA+B;QACnC;;QAEA;YACI,SAAO;YACP,kBAAkB;YAClB,gBAAgB;QACpB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,wBAAwB;YACxB,yBAAyB;YACzB,qBAAqB;YACrB,eAAe;YACf,kBAAkB;QACtB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,kBAAkB;YAClB,kBAAkB;YAClB,uBAAuB;YACvB,qBAAqB;YACrB,eAAe;YACf,gBAAgB;YAChB,oBAAoB;YACpB,kBAAkB;QACtB;;QAEA;YACI,2BAA2B;YAC3B,uBAAuB;QAC3B;;QAEA;YACI,mCAAmC;YACnC,qBAAqB;QACzB;;QAEA;YACI,eAAe;YACf,WAAW;YACX,kBAAkB;QACtB;;QAEA;YACI,SAAO;QACX;;QAEA;YACI,gBAAgB;YAChB,0BAA0B;YAC1B,YAAY;YACZ,eAAe;YACf,gBAAgB;YAChB,mBAAmB;QACvB;;QAEA;YACI,gBAAgB;YAChB,2BAA2B;YAC3B,uBAAuB;YACvB,eAAe;YACf,gBAAgB;YAChB,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,mCAAmC;QACvC;;QAEA;YACI,qDAAqD;YACrD,yCAAyC;YACzC,mBAAmB;YACnB,aAAa;YACb,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,kBAAkB;QACtB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,cAAc;YACd,eAAe;YACf,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;QACnC;;QAEA;YACI,eAAe;QACnB;;QAEA,yBAAyB;QACzB;YACI,iCAAiC;YACjC,gCAAgC;YAChC,8CAA8C;QAClD;;QAEA;YACI,aAAa;QACjB;;QAEA,uBAAuB;QACvB;YACI;gBACI,aAAa;YACjB;;YAEA;gBACI,4BAA4B;YAChC;;YAEA;gBACI,wBAAwB;YAC5B;;YAEA;gBACI,cAAc;YAClB;;YAEA;gBACI,aAAa;YACjB;QACJ;;QAEA;YACI;gBACI,aAAa;YACjB;;YAEA;gBACI,aAAa;YACjB;QACJ;;QAEA,wBAAwB;QACxB;YACI,aAAa;QACjB;;QAEA;YACI,iBAAiB;YACjB,cAAc;YACd,eAAe;YACf,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,sBAAsB;YACtB,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kEAAkE;YAClE,kBAAkB;QACtB;;QAEA;YACI,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;YAC/B,2BAA2B;YAC3B,8CAA8C;QAClD;;QAEA,SAAS;QACT;YACI,iBAAiB;YACjB,cAAc;YACd,kBAAkB;QACtB;;QAEA;YACI,mBAAmB;YACnB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,mBAAmB;YACnB,uBAAuB;YACvB,sBAAsB;QAC1B;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,gBAAgB;YAChB,gBAAgB;YAChB,cAAc;QAClB;;QAEA,eAAe;QACf;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,mBAAmB;YACnB,aAAa;YACb,mBAAmB;YACnB,aAAa;YACb,+BAA+B;YAC/B,SAAS;YACT,mBAAmB;YACnB,sCAAsC;QAC1C;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,mBAAmB;YACnB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,gBAAgB;YAChB,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,0BAA0B;YAC1B,YAAY;YACZ,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,iBAAiB;YACjB,cAAc;QAClB;;QAEA;YACI,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;YACpB,mBAAmB;QACvB;;QAEA;YACI,+BAA+B;YAC/B,2BAA2B;YAC3B,8CAA8C;QAClD;;QAEA,aAAa;QACb;YACI,aAAa;YACb,SAAS;YACT,mBAAmB;YACnB,mBAAmB;YACnB,eAAe;YACf,yBAAyB;QAC7B;;QAEA;YACI,gBAAgB;YAChB,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,WAAW;YACX,4BAA4B;YAC5B,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,2BAA2B;YAC3B,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,4CAA4C;QAChD;;QAEA;YACI,kBAAkB;YAClB,UAAU;YACV,QAAQ;YACR,2BAA2B;YAC3B,wBAAwB;YACxB,eAAe;QACnB;;QAEA;YACI,kBAAkB;QACtB;;QAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;WA+BG;;QAEH;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,eAAe;YACf,oBAAoB;YACpB,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,4BAA4B;YAC5B,qBAAqB;YACrB,mCAAmC;QACvC;;QAEA,oBAAoB;QACpB;YACI,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,mBAAmB;YACnB,eAAe;YACf,SAAS;QACb;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,gBAAgB;QACpB;;QAEA,gBAAgB;QAChB;YACI,aAAa;YACb,4DAA4D;YAC5D,SAAS;YACT,mBAAmB;QACvB;;QAEA,gBAAgB;QAChB;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,mBAAmB;YACnB,gBAAgB;YAChB,iDAAiD;YACjD,aAAa;YACb,sBAAsB;YACtB,YAAY;YACZ,eAAe;QACnB;;QAEA;YACI,wCAAwC;YACxC,kCAAkC;YAClC,2BAA2B;QAC/B;;QAEA;YACI,WAAW;YACX,aAAa;YACb,2BAA2B;YAC3B,kBAAkB;YAClB,gBAAgB;YAChB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;QAC3B;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,gBAAgB;YAChB,kBAAkB;YAClB,YAAY;QAChB;;QAEA,UAAU,qDAAqD,EAAE;QACjE,UAAU,qDAAqD,EAAE;QACjE,UAAU,qDAAqD,EAAE;QACjE,UAAU,qDAAqD,EAAE;QACjE,UAAU,qDAAqD,EAAE;QACjE,UAAU,qDAAqD,EAAE;QACjE,UAAU,qDAAqD,EAAE;QACjE,UAAU,qDAAqD,EAAE;QACjE,UAAU,qDAAqD,EAAE;;QAEjE;YACI,kBAAkB;YAClB,SAAS;YACT,WAAW;YACX,iBAAiB;YACjB,uBAAuB;YACvB,iBAAiB;YACjB,mBAAmB;YACnB,eAAe;YACf,gBAAgB;YAChB,yBAAyB;YACzB,qBAAqB;YACrB,qCAAqC;QACzC;;QAEA;YACI,mCAAmC;YACnC,qBAAqB;QACzB;;QAEA;YACI,mCAAmC;YACnC,qBAAqB;QACzB;;QAEA;YACI,mCAAmC;YACnC,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,aAAa;YACb,sBAAsB;YACtB,YAAY;QAChB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,kBAAkB;YAClB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,QAAQ;YACR,mBAAmB;YACnB,eAAe;YACf,YAAY;QAChB;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,uBAAuB;QAC3B;;QAEA;YACI,wBAAwB;QAC5B;;QAEA;YACI,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,eAAe;YACf,QAAQ;YACR,mBAAmB;YACnB,oBAAoB;YACpB,sCAAsC;QAC1C;;QAEA;YACI,qFAAqF;YACrF,qBAAqB;YACrB,gBAAgB;YAChB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;YACpB,wCAAwC;YACxC,yBAAyB;YACzB,qBAAqB;QACzB;;QAEA;YACI,oFAAoF;YACpF,4BAA4B;YAC5B,2BAA2B;QAC/B;;QAEA,2BAA2B;QAC3B;YACI,aAAa;YACb,sBAAsB;YACtB,QAAQ;YACR,mBAAmB;QACvB;;QAEA;YACI,qDAAqD;YACrD,0BAA0B;YAC1B,cAAc;YACd,iBAAiB;YACjB,kBAAkB;YAClB,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,eAAe;QACnB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,eAAe;QACnB;;QAEA;YACI,gBAAgB;YAChB,cAAc;QAClB;;QAEA;YACI,cAAc;YACd,eAAe;QACnB;;QAEA;YACI,iBAAiB;YACjB,yBAAyB;YACzB,gBAAgB;YAChB,kBAAkB;YAClB,sBAAsB;YACtB,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,mBAAmB;YACnB,qBAAqB;QACzB;;QAEA;YACI,8BAA8B;YAC9B,gCAAgC;YAChC,yBAAyB;QAC7B;;QAEA;YACI,aAAa;YACb,SAAS;YACT,mCAAmC;YACnC,iBAAiB;YACjB,gBAAgB;QACpB;;QAEA;YACI,SAAO;YACP,uBAAuB;YACvB,+BAA+B;YAC/B,uBAAuB;YACvB,aAAa;YACb,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;YAC5B,qBAAqB;YACrB,mCAAmC;QACvC;;QAEA;YACI,SAAO;YACP,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,aAAa;YACb,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;YAC/B,2BAA2B;YAC3B,8CAA8C;QAClD;;QAEA,kDAAkD;QAClD;;;;;;;;;;WAUG;;QAEH;YACI,cAAc;QAClB;;QAEA;YACI,2BAA2B;YAC3B,sCAAsC;YACtC,eAAe;YACf,gBAAgB;YAChB,MAAM;YACN,YAAY;YACZ,sCAAsC;QAC1C;;QAEA;YACI,iBAAiB;YACjB,cAAc;YACd,eAAe;YACf,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,kBAAkB;YAClB,2BAA2B;YAC3B,+BAA+B;YAC/B,uBAAuB;YACvB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;YAC5B,qBAAqB;QACzB;;QAEA;YACI,iBAAiB;YACjB,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;YACpB,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,+BAA+B;QACnC;;QAEA;YACI,iBAAiB;YACjB,kCAAkC;YAClC,wCAAwC;YACxC,qBAAqB;YACrB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA,qCAAqC;QACrC;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,mBAAmB;YACnB,kBAAkB;YAClB,mBAAmB;YACnB,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,yCAAyC;QAC7C;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,+BAA+B;YAC/B,2BAA2B;YAC3B,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,eAAe;YACf,uBAAuB;YACvB,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;YAC5B,qBAAqB;YACrB,mCAAmC;QACvC;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,mBAAmB;YACnB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,gBAAgB;YAChB,YAAY;QAChB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA,2BAA2B;QAC3B;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,mBAAmB;YACnB,kBAAkB;YAClB,mBAAmB;YACnB,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,SAAS;YACT,eAAe;YACf,yCAAyC;QAC7C;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,SAAO;YACP,gBAAgB;QACpB;;QAEA;YACI,SAAO;YACP,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,WAAW;YACX,4BAA4B;YAC5B,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,2BAA2B;YAC3B,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,2BAA2B;YAC3B,4CAA4C;QAChD;;QAEA;YACI,kBAAkB;YAClB,UAAU;YACV,QAAQ;YACR,2BAA2B;YAC3B,wBAAwB;YACxB,eAAe;QACnB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,eAAe;QACnB;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,gBAAgB;QACpB;;QAEA;YACI,0BAA0B;YAC1B,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,uBAAuB;YACvB,2BAA2B;YAC3B,eAAe;YACf,gBAAgB;YAChB,yDAAuL;YACvL,4BAA4B;YAC5B,sCAAsC;YACtC,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;QAChC;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,4CAA4C;QAChD;;QAEA;YACI,iBAAiB;YACjB,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,2BAA2B;YAC3B,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;YAC5B,qBAAqB;QACzB;;QAEA;YACI,mCAAmC;YACnC,4BAA4B;YAC5B,qBAAqB;QACzB;;QAEA;YACI,UAAU;YACV,YAAY;YACZ,yBAAyB;QAC7B;;QAEA;YACI,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,uBAAuB;QAC3B;;QAEA;YACI;gBACI,sBAAsB;gBACtB,oBAAoB;gBACpB,SAAS;gBACT,kBAAkB;YACtB;;YAEA;gBACI,YAAY;YAChB;;YAEA;gBACI,eAAe;gBACf,gBAAgB;gBAChB,uBAAuB;gBACvB,mBAAmB;YACvB;;YAEA;gBACI,eAAe;gBACf,QAAQ;YACZ;;YAEA;;gBAEI,SAAO;gBACP,YAAY;gBACZ,kBAAkB;gBAClB,eAAe;YACnB;;YAEA;gBACI,sBAAsB;gBACtB,oBAAoB;YACxB;;YAEA;gBACI,WAAW;YACf;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,WAAW;gBACX,2BAA2B;YAC/B;QACJ;;QAEA;YACI;gBACI,sBAAsB;YAC1B;;YAEA;;gBAEI,WAAW;YACf;QACJ;;QAEA;YACI,uBAAuB;YACvB,+BAA+B;YAC/B,uBAAuB;YACvB,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,eAAe;YACf,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;YAC5B,mCAAmC;YACnC,qBAAqB;QACzB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,gBAAgB;YAChB,YAAY;QAChB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA,eAAe;QACf;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,eAAe;YACf,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,sBAAsB;QAC1B;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,uBAAuB;YACvB,gBAAgB;YAChB,eAAe;QACnB;;QAEA;YACI,wBAAwB;QAC5B;;QAEA;YACI,iBAAiB;YACjB,cAAc;YACd,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,mBAAmB;YACnB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,kBAAkB;YAClB,mBAAmB;QACvB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI,aAAa;YACb,uBAAuB;YACvB,SAAS;YACT,gBAAgB;QACpB;;QAEA;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,uBAAuB;YACvB,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;YAC5B,qBAAqB;QACzB;;QAEA;YACI,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;YACpB,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,+BAA+B;QACnC;;QAEA;YACI,kCAAkC;YAClC,wCAAwC;YACxC,qBAAqB;YACrB,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA,oBAAoB;QACpB;YACI,gBAAgB;YAChB,mBAAmB;YACnB,kBAAkB;QACtB;;QAEA;YACI,WAAW;YACX,4BAA4B;YAC5B,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,2BAA2B;YAC3B,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,4CAA4C;QAChD;;QAEA;YACI,wBAAwB;QAC5B;;QAEA;YACI,kBAAkB;YAClB,UAAU;YACV,QAAQ;YACR,2BAA2B;YAC3B,wBAAwB;YACxB,eAAe;YACf,oBAAoB;QACxB;;QAEA,sBAAsB;QACtB;;;;;;;;;;;WAWG;;QAEH;YACI,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,0BAA0B;YAC1B,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,uBAAuB;YACvB,2BAA2B;YAC3B,eAAe;YACf,gBAAgB;YAChB,yDAAuL;YACvL,4BAA4B;YAC5B,sCAAsC;QAC1C;;QAEA;YACI,aAAa;YACb,4BAA4B;QAChC;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,iBAAiB;YACjB,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,2BAA2B;YAC3B,eAAe;YACf,oBAAoB;YACpB,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,4BAA4B;YAC5B,qBAAqB;QACzB;;QAEA;YACI,YAAY;YACZ,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,2BAA2B;YAC3B,eAAe;YACf,oBAAoB;YACpB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;QAC3B;;QAEA;YACI,4BAA4B;YAC5B,qBAAqB;QACzB;;QAEA;YACI,0BAA0B;YAC1B,4BAA4B;YAC5B,YAAY;QAChB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,wBAAwB;QAC5B;;QAEA;YACI;gBACI,sBAAsB;gBACtB,oBAAoB;gBACpB,kBAAkB;YACtB;;YAEA;gBACI,sBAAsB;gBACtB,SAAS;YACb;;YAEA;gBACI,uBAAuB;YAC3B;QACJ;;QAEA,mBAAmB;QACnB;YACI,aAAa;YACb,4DAA4D;YAC5D,SAAS;QACb;;QAEA;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,mBAAmB;YACnB,gBAAgB;YAChB,yBAAyB;YACzB,aAAa;YACb,sBAAsB;YACtB,YAAY;QAChB;;QAEA;YACI,wCAAwC;YACxC,kCAAkC;YAClC,2BAA2B;QAC/B;;QAEA;YACI,2BAA2B;YAC3B,aAAa;YACb,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,YAAY;YACZ,aAAa;YACb,mBAAmB;YACnB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,gBAAgB;YAChB,YAAY;QAChB;;QAEA;YACI,aAAa;YACb,aAAa;YACb,sBAAsB;YACtB,YAAY;YACZ,YAAY;QAChB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,kBAAkB;YAClB,uBAAuB;YACvB,eAAe;YACf,uBAAuB;YACvB,sBAAsB;QAC1B;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,mBAAmB;YACnB,eAAe;YACf,uBAAuB;YACvB,sBAAsB;QAC1B;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;YACT,mBAAmB;YACnB,oBAAoB;YACpB,sCAAsC;YACtC,YAAY;QAChB;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,uBAAuB;YACvB,SAAS;YACT,eAAe;YACf,YAAY;QAChB;;QAEA;YACI,wBAAwB;YACxB,gBAAgB;YAChB,cAAc;QAClB;;QAEA;YACI,uBAAuB;YACvB,gBAAgB;YAChB,iBAAiB;YACjB,YAAY;YACZ,eAAe;YACf,uBAAuB;YACvB,sBAAsB;QAC1B;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,yBAAyB;YACzB,kBAAkB;YAClB,qBAAqB;QACzB;;QAEA;YACI,aAAa;YACb,eAAe;YACf,QAAQ;QACZ;;QAEA;YACI,2BAA2B;YAC3B,uBAAuB;YACvB,iBAAiB;YACjB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,aAAa;YACb,SAAS;YACT,gBAAgB;QACpB;;QAEA;YACI,SAAO;YACP,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,aAAa;YACb,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;YAC/B,2BAA2B;YAC3B,8CAA8C;QAClD;;QAEA,iCAAiC;QACjC;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,mBAAmB;YACnB,gBAAgB;YAChB,yBAAyB;QAC7B;;QAEA;YACI,wCAAwC;YACxC,kCAAkC;YAClC,2BAA2B;QAC/B;;QAEA;YACI,2BAA2B;YAC3B,aAAa;YACb,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,kBAAkB;QACtB;;QAEA;YACI,kBAAkB;YAClB,SAAS;YACT,WAAW;YACX,0BAA0B;YAC1B,YAAY;YACZ,iBAAiB;YACjB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,aAAa;QACjB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,kBAAkB;YAClB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,wBAAwB;YACxB,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,qBAAqB;YACrB,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,QAAQ;YACR,mBAAmB;YACnB,oBAAoB;YACpB,sCAAsC;QAC1C;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,eAAe;QACnB;;QAEA;YACI,wBAAwB;QAC5B;;QAEA;YACI,uBAAuB;YACvB,gBAAgB;QACpB;;QAEA;YACI,aAAa;YACb,SAAS;QACb;;QAEA;YACI,SAAO;YACP,2BAA2B;YAC3B,+BAA+B;YAC/B,uBAAuB;YACvB,aAAa;YACb,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;YAC5B,qBAAqB;QACzB;;QAEA;YACI,SAAO;YACP,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,aAAa;YACb,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;YAC/B,2BAA2B;YAC3B,8CAA8C;QAClD;;QAEA,+CAA+C;QAC/C;YACI,eAAe;YACf,MAAM;YACN,OAAO;YACP,QAAQ;YACR,SAAS;YACT,8BAA8B;YAC9B,aAAa;YACb,UAAU;YACV,kBAAkB;YAClB,yBAAyB;QAC7B;;QAEA;YACI,UAAU;YACV,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,SAAS;YACT,QAAQ;YACR,YAAY;YACZ,eAAe;YACf,aAAa;YACb,2BAA2B;YAC3B,aAAa;YACb,2BAA2B;YAC3B,uDAAuD;YACvD,aAAa;YACb,sBAAsB;YACtB,2CAA2C;YAC3C,gBAAgB;QACpB;;QAEA;YACI,wBAAwB;QAC5B;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,+BAA+B;YAC/B,2BAA2B;YAC3B,eAAe;YACf,kCAAkC;YAClC,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,kBAAkB;YAClB,oBAAoB;YACpB,cAAc;QAClB;;QAEA;YACI,2BAA2B;YAC3B,uBAAuB;YACvB,8BAA8B;QAClC;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,kBAAkB;YAClB,2BAA2B;YAC3B,sCAAsC;YACtC,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,cAAc;YACd,oBAAoB;YACpB,2BAA2B;YAC3B,gBAAgB;QACpB;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI,SAAO;YACP,aAAa;YACb,gBAAgB;YAChB,kBAAkB;YAClB,aAAa;QACjB;;QAEA;YACI,cAAc;YACd,2BAA2B;YAC3B,mCAAmC;YACnC,kBAAkB;YAClB,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,aAAa;YACb,SAAS;QACb;;QAEA;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,uBAAuB;YACvB,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,8BAA8B;QAClC;;QAEA;YACI,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;QACnC;;QAEA,iCAAiC;QACjC;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,mBAAmB;YACnB,aAAa;YACb,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,SAAS;YACT,uBAAuB;QAC3B;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,mBAAmB;YACnB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,gBAAgB;YAChB,YAAY;YACZ,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,QAAQ;QACZ;;QAEA;YACI,iBAAiB;YACjB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,mCAAmC;YACnC,qBAAqB;QACzB;;QAEA;YACI,mCAAmC;YACnC,qBAAqB;QACzB;;QAEA;YACI,mCAAmC;YACnC,oBAAoB;QACxB;;QAEA;YACI,2BAA2B;YAC3B,uBAAuB;YACvB,+BAA+B;QACnC;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;QACb;;QAEA;YACI,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;QACnC;;QAEA;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,uBAAuB;YACvB,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;YAC5B,qBAAqB;QACzB;;QAEA;YACI,aAAa;YACb,qCAAqC;YACrC,SAAS;YACT,iBAAiB;YACjB,mCAAmC;QACvC;;QAEA;YACI,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,wBAAwB;YACxB,yBAAyB;YACzB,qBAAqB;YACrB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA,sBAAsB;QACtB;YACI,aAAa;YACb,8BAA8B;YAC9B,SAAS;YACT,mBAAmB;QACvB;;QAEA;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,mBAAmB;YACnB,aAAa;QACjB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,gBAAgB;YAChB,kBAAkB;YAClB,qCAAqC;QACzC;;QAEA,qBAAqB;QACrB;YACI,aAAa;YACb,uBAAuB;YACvB,QAAQ;YACR,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,kBAAkB;YAClB,eAAe;YACf,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,kBAAkB;YAClB,eAAe;YACf,wBAAwB;YACxB,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,eAAe;QACnB;;QAEA;YACI,uBAAuB;QAC3B;;QAEA;YACI,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA,4BAA4B;QAC5B;YACI,aAAa;YACb,8BAA8B;YAC9B,SAAS;QACb;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,mBAAmB;YACnB,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,kBAAkB;YAClB,2BAA2B;YAC3B,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,WAAW;YACX,kBAAkB;QACtB;;QAEA;YACI;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;gBACf,kBAAkB;YACtB;YACA;gBACI,eAAe;gBACf,WAAW;YACf;YACA;gBACI,eAAe;gBACf,oBAAoB;YACxB;YACA;gBACI,eAAe;gBACf,YAAY;gBACZ,kBAAkB;YACtB;YACA;gBACI,eAAe;gBACf,gBAAgB;YACpB;YACA;gBACI,eAAe;gBACf,iBAAiB;YACrB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;gBACf,WAAW;gBACX,YAAY;YAChB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;YACA;gBACI,eAAe;YACnB;QACJ;;QAEA,kBAAkB;QAClB;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,eAAe;YACf,oBAAoB;YACpB,sCAAsC;QAC1C;;QAEA;YACI,mBAAmB;YACnB,iBAAiB;QACrB;;QAEA;YACI,uBAAuB;QAC3B;;QAEA;YACI,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA,uBAAuB;QACvB;YACI,eAAe;YACf,YAAY;YACZ,kBAAkB;QACtB;QACA;YACI,eAAe;YACf,gBAAgB;QACpB;QACA;YACI,qDAAqD;YACrD,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,aAAa;YACb,kBAAkB;YAClB,gBAAgB;QACpB;;QAEA;YACI,WAAW;YACX,kBAAkB;YAClB,MAAM;YACN,OAAO;YACP,QAAQ;YACR,SAAS;YACT,oFAAoF;YACpF,oBAAoB;QACxB;;QAEA;YACI,eAAe;YACf,YAAY;YACZ,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,QAAQ;QACZ;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,YAAY;QAChB;;QAEA,iBAAiB;QACjB;YACI,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,mBAAmB;QACvB;;QAEA;YACI,2BAA2B;YAC3B,gCAAgC;YAChC,qBAAqB;YACrB,iBAAiB;YACjB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,oBAAoB;QACxB;;QAEA;YACI,mCAAmC;QACvC;;QAEA;YACI,kBAAkB;YAClB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,mBAAmB;YACnB,YAAY;QAChB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,wBAAwB;QAC5B;;QAEA;YACI;gBACI,WAAW;YACf;;YAEA;gBACI,0BAA0B;YAC9B;;YAEA;gBACI,sBAAsB;gBACtB,SAAS;YACb;;YAEA;gBACI,mBAAmB;gBACnB,WAAW;YACf;;YAEA;gBACI,SAAO;YACX;;YAEA;gBACI,qCAAqC;YACzC;;YAEA;gBACI,0BAA0B;YAC9B;;YAEA;gBACI,sBAAsB;gBACtB,kBAAkB;YACtB;QACJ;;QAEA,qCAAqC;QACrC;YACI,eAAe;YACf,MAAM;YACN,OAAO;YACP,QAAQ;YACR,SAAS;YACT,8BAA8B;YAC9B,aAAa;YACb,UAAU;YACV,kBAAkB;YAClB,yBAAyB;QAC7B;;QAEA;YACI,UAAU;YACV,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,QAAQ;YACR,SAAS;YACT,4CAA4C;YAC5C,YAAY;YACZ,cAAc;YACd,gBAAgB;YAChB,2BAA2B;YAC3B,mBAAmB;YACnB,aAAa;YACb,UAAU;YACV,kBAAkB;YAClB,iDAAiD;YACjD,aAAa;YACb,sBAAsB;YACtB,0CAA0C;QAC9C;;QAEA;YACI,UAAU;YACV,mBAAmB;YACnB,yCAAyC;QAC7C;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,uBAAuB;YACvB,uBAAuB;YACvB,sCAAsC;QAC1C;;QAEA;YACI,SAAO;QACX;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,gBAAgB;YAChB,YAAY;QAChB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,+BAA+B;YAC/B,2BAA2B;YAC3B,eAAe;YACf,uBAAuB;YACvB,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,kBAAkB;YAClB,oBAAoB;YACpB,cAAc;QAClB;;QAEA;YACI,2BAA2B;YAC3B,uBAAuB;YACvB,8BAA8B;QAClC;;QAEA;YACI,SAAO;YACP,gBAAgB;YAChB,aAAa;QACjB;;QAEA;YACI,mCAAmC;YACnC,yCAAyC;YACzC,kBAAkB;YAClB,kBAAkB;YAClB,mBAAmB;YACnB,eAAe;YACf,uBAAuB;YACvB,gBAAgB;QACpB;;QAEA;YACI,qBAAqB;YACrB,iBAAiB;QACrB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,mBAAmB;YACnB,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,0BAA0B;YAC1B,YAAY;YACZ,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,gBAAgB;YAChB,uBAAuB;YACvB,gBAAgB;QACpB;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,SAAS;YACT,kBAAkB;QACtB;;QAEA;YACI,yBAAyB;YACzB,qBAAqB;QACzB;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,SAAS;QACb;;QAEA;YACI,SAAS;QACb;;QAEA;YACI;gBACI,0BAA0B;YAC9B;QACJ;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,SAAS;QACb;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,QAAQ;QACZ;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,yBAAyB;YACzB,qBAAqB;QACzB;;QAEA;YACI,kBAAkB;YAClB,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,uBAAuB;YACvB,2BAA2B;YAC3B,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,4CAA4C;QAChD;;QAEA;YACI,2BAA2B;YAC3B,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,2BAA2B;YAC3B,gBAAgB;QACpB;;QAEA;YACI,kBAAkB;YAClB,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,uBAAuB;YACvB,2BAA2B;YAC3B,eAAe;YACf,oBAAoB;YACpB,gBAAgB;YAChB,yDAAuL;YACvL,4BAA4B;YAC5B,sCAAsC;YACtC,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,4CAA4C;QAChD;;QAEA;YACI,WAAW;YACX,sBAAsB;YACtB,kBAAkB;YAClB,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,uBAAuB;YACvB,2BAA2B;YAC3B,gBAAgB;YAChB,iBAAiB;YACjB,oBAAoB;YACpB,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,4CAA4C;QAChD;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,SAAS;QACb;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,kBAAkB;YAClB,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;YAC5B,mCAAmC;QACvC;;QAEA;YACI,4BAA4B;YAC5B,mCAAmC;QACvC;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,4BAA4B;YAC5B,eAAe;QACnB;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,eAAe;YACf,SAAO;QACX;;QAEA;YACI,iBAAiB;YACjB,mCAAmC;YACnC,eAAe;QACnB;;QAEA;YACI,WAAW;YACX,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;YACpB,mBAAmB;QACvB;;QAEA;YACI,+BAA+B;YAC/B,2BAA2B;YAC3B,8CAA8C;QAClD;;QAEA;YACI,6BAA6B;YAC7B,mBAAmB;YACnB,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,eAAe;YACf,wBAAwB;YACxB,kBAAkB;QACtB;;QAEA,kBAAkB;QAClB;YACI,kBAAkB;YAClB,kBAAkB;QACtB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,mCAAmC;YACnC,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;QACnC;;QAEA,2BAA2B;QAC3B;YACI,kCAAkC;YAClC,wCAAwC;YACxC,qBAAqB;YACrB,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,QAAQ;QACZ;;QAEA;YACI,kCAAkC;YAClC,wCAAwC;YACxC,qBAAqB;YACrB,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI;gBACI,WAAW;gBACX,eAAe;gBACf,YAAY;gBACZ,gBAAgB;gBAChB,gBAAgB;YACpB;;YAEA;gBACI,0BAA0B;YAC9B;;YAEA;gBACI,0BAA0B;YAC9B;QACJ;;QAEA,gCAAgC;QAChC;YACI,eAAe;YACf,uBAAuB;YACvB,gBAAgB;YAChB,eAAe;QACnB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,eAAe;QACnB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,gBAAgB;YAChB,wBAAwB;YACxB,eAAe;QACnB;;QAEA;YACI,kBAAkB;YAClB,aAAa;YACb,mBAAmB;QACvB;;QAEA;YACI,kBAAkB;YAClB,UAAU;YACV,eAAe;YACf,wBAAwB;YACxB,oBAAoB;QACxB;;QAEA;YACI,WAAW;YACX,4BAA4B;YAC5B,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,uBAAuB;YACvB,2BAA2B;YAC3B,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,4CAA4C;QAChD;;QAEA;YACI,wBAAwB;QAC5B;;QAEA;YACI,WAAW;YACX,2BAA2B;YAC3B,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,uBAAuB;YACvB,2BAA2B;YAC3B,eAAe;YACf,oBAAoB;YACpB,gBAAgB;YAChB,yDAAuL;YACvL,4BAA4B;YAC5B,sCAAsC;QAC1C;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,4CAA4C;QAChD;;QAEA;YACI,kBAAkB;QACtB;;QAEA;YACI,WAAW;YACX,aAAa;YACb,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,uBAAuB;YACvB,2BAA2B;YAC3B,gBAAgB;YAChB,iBAAiB;YACjB,oBAAoB;YACpB,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,4CAA4C;QAChD;;QAEA;YACI,wBAAwB;QAC5B;;QAEA;YACI,kBAAkB;YAClB,YAAY;YACZ,UAAU;YACV,eAAe;YACf,wBAAwB;YACxB,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;YACT,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,uBAAuB;YACvB,SAAS;YACT,kBAAkB;YAClB,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;YAC5B,mCAAmC;QACvC;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,eAAe;YACf,4BAA4B;YAC5B,eAAe;YACf,cAAc;QAClB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,QAAQ;QACZ;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,wBAAwB;QAC5B;;QAEA;YACI,aAAa;YACb,yBAAyB;YACzB,SAAS;YACT,iBAAiB;YACjB,mCAAmC;QACvC;;QAEA;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,uBAAuB;YACvB,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,8BAA8B;YAC9B,2BAA2B;QAC/B;;QAEA;YACI,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;QACnC;;QAEA,2BAA2B;QAC3B;YACI,kBAAkB;YAClB,kBAAkB;QACtB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,mCAAmC;YACnC,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,mBAAmB;YACnB,gBAAgB;QACpB;;QAEA,6BAA6B;QAC7B;YACI,eAAe;YACf,MAAM;YACN,OAAO;YACP,QAAQ;YACR,SAAS;YACT,8BAA8B;YAC9B,aAAa;YACb,UAAU;YACV,kBAAkB;YAClB,yBAAyB;QAC7B;;QAEA;YACI,UAAU;YACV,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,QAAQ;YACR,SAAS;YACT,4CAA4C;YAC5C,YAAY;YACZ,cAAc;YACd,2BAA2B;YAC3B,mBAAmB;YACnB,aAAa;YACb,UAAU;YACV,kBAAkB;YAClB,iDAAiD;YACjD,0CAA0C;YAC1C,gBAAgB;QACpB;;QAEA;YACI,UAAU;YACV,mBAAmB;YACnB,yCAAyC;QAC7C;;QAEA;YACI;gBACI,UAAU;gBACV,cAAc;YAClB;QACJ;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,uBAAuB;YACvB,kBAAkB;YAClB,sCAAsC;YACtC,2BAA2B;QAC/B;;QAEA;YACI,aAAa;YACb,uBAAuB;YACvB,SAAS;QACb;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,0BAA0B;YAC1B,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,YAAY;YACZ,eAAe;YACf,cAAc;YACd,eAAe;QACnB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,YAAY;YACZ,uBAAuB;YACvB,eAAe;YACf,uBAAuB;YACvB,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,kBAAkB;YAClB,oBAAoB;QACxB;;QAEA;YACI,2BAA2B;YAC3B,uBAAuB;QAC3B;;QAEA;YACI,aAAa;QACjB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,SAAS;YACT,mBAAmB;YACnB,YAAY;QAChB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,2BAA2B;YAC3B,+BAA+B;YAC/B,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,cAAc;QAClB;;QAEA;YACI,SAAO;YACP,YAAY;QAChB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,qBAAqB;YACrB,mBAAmB;YACnB,gBAAgB;YAChB,eAAe;YACf,uBAAuB;YACvB,sBAAsB;QAC1B;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,QAAQ;QACZ;;QAEA;YACI,aAAa;YACb,eAAe;YACf,mBAAmB;YACnB,cAAc;YACd,eAAe;QACnB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,aAAa;YACb,SAAS;YACT,eAAe;QACnB;;QAEA;YACI,uBAAuB;QAC3B;;QAEA;YACI,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,gBAAgB;YAChB,qBAAqB;QACzB;;QAEA;YACI,eAAe;YACf,wBAAwB;YACxB,uBAAuB;YACvB,eAAe;YACf,aAAa;YACb,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,SAAW;YACX,YAAY;YACZ,eAAe;YACf,uBAAuB;YACvB,sBAAsB;QAC1B;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,iBAAiB;YACjB,mCAAmC;QACvC;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,aAAa;YACb,SAAS;YACT,kBAAkB;YAClB,mCAAmC;YACnC,2BAA2B;QAC/B;;QAEA;YACI,SAAO;YACP,2BAA2B;YAC3B,+BAA+B;YAC/B,uBAAuB;YACvB,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;YAC5B,qBAAqB;QACzB;;QAEA;YACI,SAAO;YACP,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;QACnC;;QAEA,8BAA8B;QAC9B;YACI,eAAe;YACf,MAAM;YACN,OAAO;YACP,QAAQ;YACR,SAAS;YACT,8BAA8B;YAC9B,aAAa;YACb,UAAU;YACV,kBAAkB;YAClB,yBAAyB;QAC7B;;QAEA;YACI,UAAU;YACV,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,QAAQ;YACR,SAAS;YACT,4CAA4C;YAC5C,YAAY;YACZ,cAAc;YACd,gBAAgB;YAChB,2BAA2B;YAC3B,mBAAmB;YACnB,aAAa;YACb,UAAU;YACV,kBAAkB;YAClB,iDAAiD;YACjD,0CAA0C;YAC1C,aAAa;YACb,sBAAsB;QAC1B;;QAEA;YACI,UAAU;YACV,mBAAmB;YACnB,yCAAyC;QAC7C;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,kBAAkB;YAClB,sCAAsC;QAC1C;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,YAAY;YACZ,uBAAuB;YACvB,eAAe;YACf,uBAAuB;YACvB,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,kBAAkB;YAClB,oBAAoB;QACxB;;QAEA;YACI,2BAA2B;YAC3B,uBAAuB;QAC3B;;QAEA;YACI,SAAO;YACP,gBAAgB;YAChB,aAAa;QACjB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,aAAa;YACb,2BAA2B;YAC3B,kBAAkB;YAClB,mBAAmB;QACvB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,gBAAgB;YAChB,YAAY;QAChB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,cAAc;YACd,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,aAAa;YACb,QAAQ;QACZ;;QAEA;YACI,eAAe;YACf,WAAW;YACX,eAAe;YACf,oBAAoB;QACxB;;QAEA;;YAEI,oBAAoB;YACpB,qBAAqB;QACzB;;QAEA;YACI,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,WAAW;YACX,kBAAkB;YAClB,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,uBAAuB;YACvB,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,4CAA4C;QAChD;;QAEA;YACI,WAAW;YACX,kBAAkB;YAClB,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;YACf,uBAAuB;YACvB,gBAAgB;YAChB,iBAAiB;YACjB,oBAAoB;YACpB,oBAAoB;QACxB;;QAEA;YACI,aAAa;YACb,4BAA4B;YAC5B,4CAA4C;QAChD;;QAEA;YACI,eAAe;YACf,wBAAwB;YACxB,eAAe;QACnB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,kBAAkB;YAClB,2BAA2B;YAC3B,kBAAkB;YAClB,eAAe;QACnB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,4BAA4B;QAChC;;QAEA;YACI,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,aAAa;YACb,SAAS;YACT,kBAAkB;YAClB,mCAAmC;QACvC;;QAEA;YACI,SAAO;YACP,2BAA2B;YAC3B,YAAY;YACZ,uBAAuB;YACvB,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,WAAS;YACT,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;QACnC;;QAEA,iCAAiC;QACjC;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,2BAA2B;YAC3B,kBAAkB;QACtB;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,0BAA0B;YAC1B,YAAY;YACZ,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,wBAAwB;QAC5B;;QAEA;YACI,oBAAoB;YACpB,eAAe;QACnB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,gBAAgB;YAChB,mBAAmB;QACvB;;QAEA;YACI,oBAAoB;YACpB,mBAAmB;YACnB,QAAQ;YACR,eAAe;YACf,qBAAqB;YACrB,kCAAkC;YAClC,iBAAiB;YACjB,kBAAkB;QACtB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,8BAA8B;YAC9B,oBAAoB;YACpB,mBAAmB;YACnB,sCAAsC;QAC1C;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,QAAQ;QACZ;;QAEA;YACI,oBAAoB;YACpB,eAAe;QACnB;;QAEA;YACI,eAAe;YACf,uBAAuB;QAC3B;;QAEA,8BAA8B;QAC9B;YACI,aAAa;YACb,eAAe;YACf,MAAM;YACN,OAAO;YACP,QAAQ;YACR,SAAS;YACT,2BAA2B;YAC3B,YAAY;YACZ,gBAAgB;QACpB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,2BAA2B;YAC3B,sCAAsC;YACtC,eAAe;YACf,gBAAgB;YAChB,MAAM;YACN,YAAY;YACZ,sCAAsC;QAC1C;;QAEA;YACI,iBAAiB;YACjB,cAAc;YACd,eAAe;YACf,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,uBAAuB;YACvB,eAAe;YACf,eAAe;YACf,sBAAsB;QAC1B;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,kBAAkB;YAClB,eAAe;YACf,uBAAuB;YACvB,eAAe;QACnB;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,kBAAkB;YAClB,SAAS;YACT,WAAW;YACX,mBAAmB;YACnB,YAAY;YACZ,eAAe;YACf,gBAAgB;YAChB,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;QAC3B;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,eAAe;QACnB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,qDAAqD;YACrD,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,YAAY;YACZ,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,wBAAwB;QAC5B;;QAEA;YACI,iBAAiB;YACjB,cAAc;YACd,kBAAkB;QACtB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,eAAe;QACnB;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,gCAAgC;YAChC,SAAS;YACT,kBAAkB;QACtB;;QAEA,uBAAuB;QACvB;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,mBAAmB;YACnB,gBAAgB;QACpB;;QAEA;YACI,aAAa;YACb,iEAAiE;YACjE,QAAQ;YACR,kBAAkB;YAClB,2BAA2B;YAC3B,sCAAsC;YACtC,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,yBAAyB;YACzB,qBAAqB;YACrB,gBAAgB;QACpB;;QAEA;YACI,kBAAkB;QACtB;;QAEA;YACI,aAAa;YACb,iEAAiE;YACjE,QAAQ;YACR,kBAAkB;YAClB,sCAAsC;YACtC,mBAAmB;YACnB,gBAAgB;QACpB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,SAAS;YACT,mBAAmB;YACnB,YAAY;QAChB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ;;iCAEqB;YACrB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;YAClB,iBAAiB;QACrB;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,aAAa;YACb,sBAAsB;YACtB,QAAQ;QACZ;;QAEA;YACI,aAAa;YACb,QAAQ;QACZ;;QAEA;YACI,uBAAuB;QAC3B;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,MAAM;YACN,+BAA+B;YAC/B,kBAAkB;YAClB,gBAAgB;YAChB,kBAAkB;YAClB,oBAAoB;QACxB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,YAAY;YACZ,2BAA2B;YAC3B,uBAAuB;YACvB,eAAe;YACf,eAAe;YACf,oBAAoB;YACpB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;QAC3B;;QAEA;YACI,0BAA0B;YAC1B,YAAY;QAChB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,YAAY;YACZ,oCAAoC;YACpC,qCAAqC;YACrC,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,UAAU;QACd;;QAEA;YACI,aAAa;QACjB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;YAClB,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,kBAAkB;YAClB,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;YAClB,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,uBAAuB;QAC3B;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,YAAY;YACZ,uBAAuB;YACvB,wBAAwB;YACxB,eAAe;YACf,eAAe;YACf,kBAAkB;YAClB,oBAAoB;YACpB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;QAC3B;QACA;YACI,eAAe;QACnB;;QAEA;YACI,mBAAmB;YACnB,cAAc;QAClB;;QAEA,0BAA0B;QAC1B;YACI,2BAA2B;YAC3B,+BAA+B;YAC/B,mBAAmB;YACnB,aAAa;YACb,gBAAgB;YAChB,UAAU;QACd;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,mBAAmB;YACnB,oBAAoB;YACpB,sCAAsC;QAC1C;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;YACT,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,eAAe;QACnB;;QAEA;YACI,uBAAuB;QAC3B;;QAEA;YACI,uBAAuB;YACvB,gBAAgB;QACpB;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,wBAAwB;YACxB,eAAe;QACnB;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,iBAAiB;YACjB,mCAAmC;YACnC,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,WAAW;YACX,aAAa;YACb,iCAAiC;YACjC,mCAAmC;YACnC,qBAAqB;YACrB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,QAAQ;YACR,oBAAoB;QACxB;;QAEA;YACI,mCAAmC;QACvC;;QAEA;YACI,aAAa;YACb,QAAQ;YACR,gBAAgB;QACpB;;QAEA;YACI,aAAa;QACjB;;QAEA;YACI,SAAO;YACP,kBAAkB;YAClB,+BAA+B;YAC/B,kBAAkB;YAClB,eAAe;QACnB;;QAEA;YACI,aAAa;YACb,4BAA4B;QAChC;;QAEA;YACI,kBAAkB;YAClB,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;QACnB;;QAEA;YACI,+BAA+B;QACnC;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,8BAA8B;YAC9B,kBAAkB;YAClB,mCAAmC;YACnC,wCAAwC;YACxC,kBAAkB;YAClB,gBAAgB;QACpB;;QAEA;YACI,aAAa;QACjB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,eAAe;YACf,qBAAqB;YACrB,gBAAgB;QACpB;;QAEA;YACI,gBAAgB;YAChB,YAAY;YACZ,uBAAuB;YACvB,eAAe;YACf,eAAe;QACnB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,mBAAmB;YACnB,aAAa;YACb,+BAA+B;YAC/B,kBAAkB;QACtB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,wBAAwB;QAC5B;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;QACb;;QAEA;YACI,WAAW;YACX,aAAa;YACb,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,QAAQ;YACR,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;YAC/B,2BAA2B;YAC3B,8CAA8C;QAClD;;QAEA;YACI,WAAW;YACX,aAAa;YACb,2BAA2B;YAC3B,+BAA+B;YAC/B,uBAAuB;YACvB,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,4BAA4B;YAC5B,qBAAqB;QACzB;;QAEA;YACI,kBAAkB;YAClB,eAAe;YACf,wBAAwB;YACxB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,QAAQ;YACR,gBAAgB;YAChB;;QAEJ,qBAAqB;QACrB;YACI,kBAAkB;YAClB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,mBAAmB;YACnB,YAAY;QAChB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,kBAAkB;YAClB,0BAA0B;YAC1B,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,eAAe;QACnB;;QAEA;YACI,+BAA+B;QACnC;;QAEA,wBAAwB;QACxB;YACI,oFAAoF;YACpF,wCAAwC;YACxC,kBAAkB;YAClB,kBAAkB;YAClB,mBAAmB;YACnB,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,eAAe;QACnB;;QAEA;YACI,eAAe;YACf,qBAAqB;YACrB,gBAAgB;QACpB;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI;gBACI,0BAA0B;YAC9B;;YAEA;gBACI,gBAAgB;YACpB;;YAEA;gBACI,aAAa;YACjB;;YAEA;gBACI,iEAAiE;YACrE;;YAEA;gBACI,mBAAmB;gBACnB,mBAAmB;YACvB;QACJ;;QAEA;YACI;gBACI,UAAU;gBACV,2BAA2B;YAC/B;YACA;gBACI,UAAU;gBACV,wBAAwB;YAC5B;QACJ;;QAEA;YACI,yCAAyC;QAC7C;;QAEA,4BAA4B,sBAAsB,EAAE;QACpD,4BAA4B,qBAAqB,EAAE;QACnD,4BAA4B,sBAAsB,EAAE;QACpD,4BAA4B,qBAAqB,EAAE;QACnD,4BAA4B,sBAAsB,EAAE;QACpD,4BAA4B,qBAAqB,EAAE;QACnD,4BAA4B,sBAAsB,EAAE;QACpD,4BAA4B,qBAAqB,EAAE;QACnD,4BAA4B,sBAAsB,EAAE;;QAEpD;YACI;gBACI,0BAA0B;gBAC1B,SAAS;YACb;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,sBAAsB;YAC1B;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,4DAA4D;YAChE;QACJ;;QAEA;YACI;gBACI,kBAAkB;YACtB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,0BAA0B;YAC9B;;YAEA;gBACI,aAAa;YACjB;;YAEA;gBACI,aAAa;YACjB;UACF;;UAEA,qFAAqF;UACrF;YACE,SAAO;YACP,iBAAiB;YACjB,gBAAgB;YAChB,gBAAgB;UAClB;UACA;YACE,WAAW;YACX,yBAAyB;UAC3B;UACA;YACE,gBAAgB;YAChB,MAAM;YACN,WAAW;YACX,gBAAgB;UAClB;UACA;YACE,gCAAgC;UAClC;UACA;YACE,kBAAkB;YAClB,gBAAgB;YAChB,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,yBAAyB;YACzB,sBAAsB;YACtB,mBAAmB;YACnB,mBAAmB;UACrB;UACA;YACE,kBAAkB;YAClB,eAAe;YACf,cAAc;YACd,sBAAsB;UACxB;UACA;YACE,gCAAgC;YAChC,oBAAoB;UACtB;UACA;YACE,mBAAmB;YACnB,yCAAyC;UAC3C;;UAEA,uEAAuE;UACvE;YACE,kBAAkB;UACpB;UACA;YACE,gBAAgB;UAClB;UACA;YACE,gBAAgB;YAChB,uBAAuB;YACvB,mBAAmB;YACnB,YAAY;UACd;SACD;EACP,kCAAkC;AACpC;;AAEA,wFAAwF;AACxF;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B,UAAU,EAAE;AACtC,wBAAwB,UAAU,EAAE;AACpC,sBAAsB,UAAU,EAAE;AAClC,2BAA2B,UAAU,EAAE;AACvC,2BAA2B,UAAU,EAAE;AACvC,yBAAyB,UAAU,EAAE;;AAErC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".rs-anchor { position: relative; width: 100%; overflow: visible; }\n\n/* ensure the menu expands to the control width */\n.rs-anchor .rs__menu,\n.rs-anchor .rs__menu-portal { width: 100% !important; left: 0 !important; }\n\n@media screen and (min-width: 1022px) {\n  #SalesOrder-popup {\n    width: 70% !important;\n    left: 70px !important;\n  }\n\n  #checkoutpopup {\n    left: 24% !important;\n    width: 114% !important;\n  }\n}\n\n@media screen and (max-width: 1021px) {\n  #SalesOrder-popup {\n    width: 96% !important;\n    /* left: 70px !important; */\n  }\n\n  #checkoutpopup {\n    left: 3% !important;\n  }\n}\n\n.icon-chip{\n  width:32px;height:32x;border-radius:8px;\n  display:inline-flex;align-items:center;justify-content:center;\n  font-size:16px;\n}\n.chip-orange{ background:#FFF3E6; color:#E17100; } /* product */\n.chip-blue  { background:#EEF5FF; color:#0d6efd; } /* order */\n\n\n.order-card {\n  box-shadow: 0 4px 6px -1px #0000001a, 0 2px 4px -1px #0000000f;\n  background-color: #fff;\n  border-radius: .625rem;\n  border-width: 1px;\n}\n\n.order-tittle {\n  font-size: 0.875rem;\n  color: #111827;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  font-weight: 500 !important;\n}\n\n.order-card-title {\n  font-size: 0.875rem;\n  color: #111827;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  font-weight: 500 !important;\n}\n\n.order-card-cells {\n  font-size: 0.875rem;\n  color: #111827;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n\n}\n\n.order-card-log {\n  font-size: 12px;\n  color: #111827;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n\n}\n.card{\n  margin-bottom: 7px;\n}\n#right-column{\n  padding-left: 1px !important;\n}\n#left-column{\n  padding-right: 3px !important;\n}\n\n/* Scope everything to ONLY this card */\n.product-table-card .card-header {\n  border-bottom: 1px solid #edf1f5;\n}\n\n/* Remove ALL table borders from Bootstrap (header + body cells) */\n.product-table-card .ps-table,\n.product-table-card .ps-table th,\n.product-table-card .ps-table td {\n  border: 0 !important;\n  border-color: transparent !important;\n}\n\n.product-table-card .ps-table> :not(caption)>*>* {\n  border-bottom-width: 0 !important;\n  /* BS5 reset */\n  box-shadow: none !important;\n}\n\n/* Header look (light background + bold text) */\n.product-table-card .ps-table thead.sticky-top {\n  top: 0;\n  z-index: 2;\n}\n\n.product-table-card .ps-table thead th {\n  background: #f6f8fb !important;\n  /* soft grey */\n  color: #111827;\n  font-weight: 600;\n}\n\n/* Soft row divider (no vertical grid lines) */\n.product-table-card .ps-table tbody tr {\n  border-bottom: 1px solid #eef2f7;\n}\n\n.product-table-card .ps-table tbody tr:last-child {\n  border-bottom: 0;\n}\n\n/* Image cell: small rounded preview */\n.product-table-card .ps-table td:first-child>div {\n  width: 56px !important;\n  height: 56px !important;\n  flex-shrink: 0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.product-table-card .ps-table td:first-child img {\n  width: 56px !important;\n  height: 56px !important;\n  object-fit: cover;\n  border: none !important;\n  border-radius: 10px;\n}\n\n/* Product name + subtext styling */\n.product-table-card .ps-table td:nth-child(2) .fw-semibold {\n  font-size: 14px;\n  letter-spacing: .2px;\n}\n\n.product-table-card .ps-table td:nth-child(2) .custom-fields-container {\n  font-size: 12px;\n  color: #6b7280;\n  /* muted lines under title */\n}\n\n/* Center numeric columns like the screenshot */\n.product-table-card .ps-table th:nth-child(3),\n.product-table-card .ps-table th:nth-child(4),\n.product-table-card .ps-table th:nth-child(5),\n.product-table-card .ps-table td:nth-child(3),\n.product-table-card .ps-table td:nth-child(4),\n.product-table-card .ps-table td:nth-child(5) {\n  text-align: center;\n  white-space: nowrap;\n}\n/* vertical scroll container */\n.ps-wrap {\n  max-height: 350px;\n  overflow-y: auto;\n  position: relative;           /* required so sticky anchors to THIS scroller */\n  overscroll-behavior: contain; /* prevents body scroll takeover */\n}\n\n/* keep table tight inside */\n.ps-wrap .table {\n  margin-bottom: 0;\n}\n\n/* sticky header that stays visible while body scrolls */\n.ps-wrap thead .ps-head th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f8f9fa; /* same as .table-light */\n}\n\n/* optional: if you use .table-light, you can keep it */\n.ps-wrap thead .ps-head th.table-light {\n  background: #f8f9fa;\n}\n/* Smooth scrollbar only when needed */\n.product-table-card .ps-wrap {\n  scrollbar-gutter: stable;\n  /* avoids layout jump when scrollbar appears */\n}\n\n.css-dn1p29 {\n  min-height: 0 !important;\n}\n\n.css-19bb58m {\n  margin: 0 !important;\n  padding-top: 0 !important;\n}\n\n.css-xorh0z {\n  display: block !important;\n}\n\n/* brokerage agent side custom css  */\n\n\n\n  :root {\n            --primary: #1e5db8;\n            --primary-light: #2a6dc4;\n            --primary-dark: #1548a0;\n            --accent: #ff9800;\n            --text-dark: #1a1a1a;\n            --text-gray: #666666;\n            --text-light: #999999;\n            --bg-white: #ffffff;\n            --bg-light: #f8f9fa;\n            --border: #e0e0e0;\n            --success: #4caf50;\n            --rating: #ffc107;\n            --sidebar-width: 260px;\n            --header-height: 64px;\n        }\n\n        body {\n            font-family: 'Roboto', sans-serif;\n            background: var(--bg-light);\n            color: var(--text-dark);\n            line-height: 1.6;\n            overflow-x: hidden;\n        }\n\n        /* SaaS Top Header */\n        .saas-header {\n            position: fixed;\n            top: 0;\n            left: 0;\n            right: 0;\n            height: var(--header-height);\n            background: var(--bg-white);\n            border-bottom: 1px solid var(--border);\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding: 0 20px;\n            z-index: 1000;\n        }\n\n        .saas-header-left {\n            display: flex;\n            align-items: center;\n            gap: 16px;\n        }\n\n        .sidebar-toggle {\n            display: none;\n            flex-direction: column;\n            gap: 4px;\n            background: none;\n            border: none;\n            cursor: pointer;\n            padding: 8px;\n        }\n\n        .sidebar-toggle span {\n            display: block;\n            width: 20px;\n            height: 2px;\n            background: var(--text-gray);\n            border-radius: 2px;\n            transition: all 0.3s;\n        }\n\n        .saas-logo {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n        }\n\n        .saas-logo-mark {\n            width: 36px;\n            height: 36px;\n            background: linear-gradient(135deg, var(--primary), #3b82f6);\n            border-radius: 8px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: white;\n            font-size: 18px;\n            font-weight: 700;\n        }\n\n        .saas-logo-text {\n            font-size: 20px;\n            font-weight: 700;\n            color: var(--text-dark);\n        }\n\n        .saas-header-center {\n            flex: 1;\n            max-width: 500px;\n            margin: 0 40px;\n        }\n\n        .global-search {\n            position: relative;\n            display: flex;\n            align-items: center;\n        }\n\n        .global-search-icon {\n            position: absolute;\n            left: 14px;\n            font-size: 14px;\n            color: var(--text-light);\n        }\n\n        .global-search-input {\n            width: 100%;\n            padding: 10px 70px 10px 40px;\n            border: 1px solid var(--border);\n            border-radius: 8px;\n            font-size: 14px;\n            background: var(--bg-light);\n            transition: all 0.2s;\n        }\n\n        .global-search-input:focus {\n            outline: none;\n            border-color: var(--primary);\n            background: var(--bg-white);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .global-search-shortcut {\n            position: absolute;\n            right: 12px;\n            padding: 4px 8px;\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 4px;\n            font-size: 11px;\n            color: var(--text-light);\n        }\n\n        .saas-header-right {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n        }\n\n        .header-icon-btn {\n            width: 40px;\n            height: 40px;\n            border: none;\n            background: transparent;\n            border-radius: 8px;\n            font-size: 18px;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            position: relative;\n            transition: all 0.2s;\n        }\n\n        .header-icon-btn:hover {\n            background: var(--bg-light);\n        }\n\n        .notification-btn {\n            position: relative;\n        }\n\n        .notification-badge {\n            position: absolute;\n            top: 4px;\n            right: 4px;\n            width: 18px;\n            height: 18px;\n            background: #e53935;\n            color: white;\n            font-size: 10px;\n            font-weight: 700;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n\n        .header-divider {\n            width: 1px;\n            height: 32px;\n            background: var(--border);\n            margin: 0 8px;\n        }\n\n        .user-menu {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            padding: 6px 12px 6px 6px;\n            border-radius: 8px;\n            cursor: pointer;\n            transition: all 0.2s;\n            position: relative;\n        }\n\n        .user-menu:hover {\n            background: var(--bg-light);\n        }\n\n        .user-avatar {\n            width: 36px;\n            height: 36px;\n            border-radius: 50%;\n            background: linear-gradient(135deg, #667BC6, #4A5BA8);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: white;\n            font-size: 13px;\n            font-weight: 600;\n        }\n\n        .user-info {\n            display: flex;\n            flex-direction: column;\n        }\n\n        .user-name {\n            font-size: 13px;\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        .user-role {\n            font-size: 11px;\n            color: var(--text-light);\n        }\n\n        .user-dropdown-icon {\n            font-size: 10px;\n            color: var(--text-light);\n        }\n\n        .user-dropdown {\n            position: absolute;\n            top: 100%;\n            right: 0;\n            margin-top: 8px;\n            width: 260px;\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 12px;\n            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n            opacity: 0;\n            visibility: hidden;\n            transform: translateY(-10px);\n            transition: all 0.2s;\n            z-index: 1001;\n        }\n\n        .user-dropdown.active {\n            opacity: 1;\n            visibility: visible;\n            transform: translateY(0);\n        }\n\n        .user-dropdown-header {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            padding: 16px;\n        }\n\n        .user-avatar-large {\n            width: 48px;\n            height: 48px;\n            border-radius: 50%;\n            background: linear-gradient(135deg, #667BC6, #4A5BA8);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: white;\n            font-size: 16px;\n            font-weight: 600;\n        }\n\n        .user-dropdown-name {\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        .user-dropdown-email {\n            font-size: 12px;\n            color: var(--text-gray);\n        }\n\n        .user-dropdown-divider {\n            height: 1px;\n            background: var(--border);\n            margin: 4px 0;\n        }\n\n        .user-dropdown-item {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            padding: 10px 16px;\n            color: var(--text-dark);\n            text-decoration: none;\n            font-size: 13px;\n            transition: all 0.2s;\n        }\n\n        .user-dropdown-item:hover {\n            background: var(--bg-light);\n        }\n\n        .user-dropdown-item.logout {\n            color: #e53935;\n        }\n\n        /* SaaS Left Sidebar */\n        .saas-sidebar {\n            position: fixed;\n            top: var(--header-height);\n            left: 0;\n            bottom: 0;\n            width: var(--sidebar-width);\n            background: var(--bg-white);\n            border-right: 1px solid var(--border);\n            display: flex;\n            flex-direction: column;\n            z-index: 999;\n            transition: transform 0.3s ease;\n        }\n\n        .sidebar-nav {\n            flex: 1;\n            padding: 20px 12px;\n            overflow-y: auto;\n        }\n\n        .sidebar-section {\n            margin-bottom: 24px;\n        }\n\n        .sidebar-section-title {\n            font-size: 11px;\n            font-weight: 600;\n            color: var(--text-light);\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n            padding: 0 12px;\n            margin-bottom: 8px;\n        }\n\n        .sidebar-item {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            padding: 10px 12px;\n            border-radius: 8px;\n            color: var(--text-gray);\n            text-decoration: none;\n            font-size: 14px;\n            font-weight: 500;\n            transition: all 0.2s;\n            margin-bottom: 2px;\n        }\n\n        .sidebar-item:hover {\n            background: var(--bg-light);\n            color: var(--text-dark);\n        }\n\n        .sidebar-item.active {\n            background: rgba(30, 93, 184, 0.08);\n            color: var(--primary);\n        }\n\n        .sidebar-icon {\n            font-size: 18px;\n            width: 24px;\n            text-align: center;\n        }\n\n        .sidebar-text {\n            flex: 1;\n        }\n\n        .sidebar-badge {\n            padding: 2px 8px;\n            background: var(--primary);\n            color: white;\n            font-size: 10px;\n            font-weight: 600;\n            border-radius: 10px;\n        }\n\n        .sidebar-count {\n            padding: 2px 8px;\n            background: var(--bg-light);\n            color: var(--text-gray);\n            font-size: 11px;\n            font-weight: 600;\n            border-radius: 10px;\n        }\n\n        .sidebar-footer {\n            padding: 12px;\n            border-top: 1px solid var(--border);\n        }\n\n        .sidebar-upgrade-card {\n            background: linear-gradient(135deg, #f0f7ff, #e8f4fd);\n            border: 1px solid rgba(30, 93, 184, 0.15);\n            border-radius: 10px;\n            padding: 14px;\n            margin-bottom: 12px;\n        }\n\n        .upgrade-icon {\n            font-size: 20px;\n            margin-bottom: 8px;\n        }\n\n        .upgrade-text {\n            margin-bottom: 12px;\n        }\n\n        .upgrade-text strong {\n            display: block;\n            font-size: 13px;\n            color: var(--text-dark);\n            margin-bottom: 2px;\n        }\n\n        .upgrade-text span {\n            font-size: 12px;\n            color: var(--text-gray);\n        }\n\n        .btn-upgrade {\n            width: 100%;\n            padding: 8px;\n            background: var(--primary);\n            border: none;\n            color: white;\n            border-radius: 6px;\n            font-size: 12px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-upgrade:hover {\n            background: var(--primary-dark);\n        }\n\n        .sidebar-help {\n            margin-top: 8px;\n        }\n\n        /* Main Content Wrapper */\n        .saas-main-wrapper {\n            margin-left: var(--sidebar-width);\n            margin-top: var(--header-height);\n            min-height: calc(100vh - var(--header-height));\n        }\n\n        .saas-main {\n            padding: 24px;\n        }\n\n        /* Responsive Sidebar */\n        @media (max-width: 1024px) {\n            .sidebar-toggle {\n                display: flex;\n            }\n\n            .saas-sidebar {\n                transform: translateX(-100%);\n            }\n\n            .saas-sidebar.active {\n                transform: translateX(0);\n            }\n\n            .saas-main-wrapper {\n                margin-left: 0;\n            }\n\n            .saas-header-center {\n                display: none;\n            }\n        }\n\n        @media (max-width: 768px) {\n            .user-info {\n                display: none;\n            }\n\n            .user-dropdown-icon {\n                display: none;\n            }\n        }\n\n        /* Old Header - Hidden */\n        .header {\n            display: none;\n        }\n\n        .header-content {\n            max-width: 1320px;\n            margin: 0 auto;\n            padding: 0 20px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n        }\n\n        .logo {\n            font-size: 20px;\n            font-weight: 700;\n            letter-spacing: -0.3px;\n            display: flex;\n            align-items: center;\n            gap: 10px;\n        }\n\n        .logo-mark {\n            width: 28px;\n            height: 28px;\n            background: linear-gradient(135deg, var(--accent), var(--primary));\n            border-radius: 6px;\n        }\n\n        .btn-request {\n            background: var(--primary);\n            color: white;\n            border: none;\n            padding: 10px 20px;\n            border-radius: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-request:hover {\n            background: var(--primary-dark);\n            transform: translateY(-2px);\n            box-shadow: 0 4px 12px rgba(30, 93, 184, 0.25);\n        }\n\n        /* Main */\n        .main {\n            max-width: 1320px;\n            margin: 0 auto;\n            padding: 40px 20px;\n        }\n\n        .hero {\n            margin-bottom: 60px;\n            text-align: center;\n        }\n\n        .hero h1 {\n            font-size: 36px;\n            font-weight: 700;\n            margin-bottom: 12px;\n            color: var(--text-dark);\n            letter-spacing: -0.5px;\n        }\n\n        .hero p {\n            font-size: 16px;\n            color: var(--text-gray);\n            max-width: 700px;\n            line-height: 1.6;\n            margin: 0 auto;\n        }\n\n        /* CTA Banner */\n        .cta-section {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 12px;\n            padding: 32px;\n            margin-bottom: 50px;\n            display: grid;\n            grid-template-columns: 1fr auto;\n            gap: 40px;\n            align-items: center;\n            box-shadow: 0 2px 8px rgba(0,0,0,0.04);\n        }\n\n        .cta-content h2 {\n            font-size: 22px;\n            font-weight: 700;\n            margin-bottom: 12px;\n            color: var(--text-dark);\n        }\n\n        .cta-content p {\n            font-size: 15px;\n            color: var(--text-gray);\n            line-height: 1.6;\n            margin-bottom: 16px;\n        }\n\n        .cta-features {\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n        }\n\n        .cta-feature {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            font-size: 14px;\n            color: var(--text-gray);\n        }\n\n        .check-icon {\n            width: 20px;\n            height: 20px;\n            border-radius: 50%;\n            background: var(--success);\n            color: white;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 12px;\n            font-weight: bold;\n            flex-shrink: 0;\n        }\n\n        .btn-primary1 {\n            background: var(--primary);\n            color: white;\n            border: none;\n            padding: 14px 28px;\n            border-radius: 8px;\n            font-size: 15px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n            white-space: nowrap;\n        }\n\n        .btn-primary1:hover {\n            background: var(--primary-dark);\n            transform: translateY(-2px);\n            box-shadow: 0 6px 16px rgba(30, 93, 184, 0.25);\n        }\n\n        /* Controls */\n        .controls {\n            display: flex;\n            gap: 16px;\n            margin-bottom: 40px;\n            align-items: center;\n            flex-wrap: wrap;\n            justify-content: flex-end;\n        }\n\n        .search-wrapper {\n            min-width: 280px;\n            max-width: 380px;\n            position: relative;\n        }\n\n        .search-wrapper input {\n            width: 100%;\n            padding: 12px 16px 12px 40px;\n            border: 1px solid var(--border);\n            border-radius: 8px;\n            font-size: 14px;\n            background: var(--bg-white);\n            transition: all 0.2s;\n        }\n\n        .search-wrapper input:focus {\n            outline: none;\n            border-color: var(--primary);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .search-icon {\n            position: absolute;\n            left: 13px;\n            top: 50%;\n            transform: translateY(-50%);\n            color: var(--text-light);\n            font-size: 16px;\n        }\n\n        .select-wrapper {\n            position: relative;\n        }\n\n        /* select {\n            padding: 5px 36px 10px 14px;\n            border: 1px solid var(--border);\n            border-radius: 8px;\n            font-size: 14px;\n            background: var(--bg-white);\n            color: var(--text-dark);\n            cursor: pointer;\n            transition: all 0.2s;\n            appearance: none;\n            min-width: 160px;\n        }\n\n        select:hover {\n            border-color: var(--primary);\n        }\n\n        select:focus {\n            outline: none;\n            border-color: var(--primary);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .select-arrow {\n            position: absolute;\n            right: 12px;\n            top: 50%;\n            transform: translateY(-50%);\n            pointer-events: none;\n            color: var(--text-light);\n            font-size: 12px;\n        } */\n\n        .btn-secondary {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            padding: 10px 18px;\n            border-radius: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--text-dark);\n            cursor: pointer;\n            transition: all 0.2s;\n            display: flex;\n            align-items: center;\n            gap: 8px;\n        }\n\n        .btn-secondary:hover {\n            border-color: var(--primary);\n            color: var(--primary);\n            background: rgba(30, 93, 184, 0.02);\n        }\n\n        /* Vendors Section */\n        .vendors-header {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            margin-bottom: 28px;\n            flex-wrap: wrap;\n            gap: 16px;\n        }\n\n        .vendors-count {\n            font-size: 15px;\n            color: var(--text-gray);\n            font-weight: 500;\n        }\n\n        /* Vendor Grid */\n        .vendors-grid {\n            display: grid;\n            grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n            gap: 20px;\n            margin-bottom: 60px;\n        }\n\n        /* Vendor Card */\n        .vendor-card {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 10px;\n            overflow: hidden;\n            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            cursor: pointer;\n        }\n\n        .vendor-card:hover {\n            box-shadow: 0 12px 32px rgba(0,0,0,0.12);\n            border-color: var(--primary-light);\n            transform: translateY(-4px);\n        }\n\n        .vendor-image {\n            width: 100%;\n            height: 160px;\n            background: var(--bg-white);\n            position: relative;\n            overflow: hidden;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n\n        .vendor-logo {\n            width: 80px;\n            height: 80px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 32px;\n            font-weight: 700;\n            border-radius: 8px;\n            color: white;\n        }\n\n        .logo-1 { background: linear-gradient(135deg, #FF6B6B, #FF8E72); }\n        .logo-2 { background: linear-gradient(135deg, #4ECDC4, #44A08D); }\n        .logo-3 { background: linear-gradient(135deg, #FFE66D, #FFC93C); }\n        .logo-4 { background: linear-gradient(135deg, #95E1D3, #38A169); }\n        .logo-5 { background: linear-gradient(135deg, #A8EDEA, #1D3557); }\n        .logo-6 { background: linear-gradient(135deg, #FFB6B9, #FEC8D8); }\n        .logo-7 { background: linear-gradient(135deg, #667BC6, #4A5BA8); }\n        .logo-8 { background: linear-gradient(135deg, #FF9671, #FEC8C8); }\n        .logo-9 { background: linear-gradient(135deg, #A0C4FF, #CAFFBF); }\n\n        .vendor-badge {\n            position: absolute;\n            top: 12px;\n            right: 12px;\n            background: white;\n            color: var(--text-dark);\n            padding: 6px 12px;\n            border-radius: 20px;\n            font-size: 12px;\n            font-weight: 700;\n            text-transform: uppercase;\n            letter-spacing: 0.3px;\n            box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n        }\n\n        .vendor-badge.verified {\n            background: rgba(76, 175, 80, 0.15);\n            color: var(--success);\n        }\n\n        .vendor-badge.partner {\n            background: rgba(30, 93, 184, 0.15);\n            color: var(--primary);\n        }\n\n        .vendor-badge.new {\n            background: rgba(255, 152, 0, 0.15);\n            color: var(--accent);\n        }\n\n        .vendor-body {\n            padding: 16px;\n            display: flex;\n            flex-direction: column;\n            flex-grow: 1;\n        }\n\n        .vendor-title {\n            font-size: 16px;\n            font-weight: 700;\n            margin-bottom: 4px;\n            color: var(--text-dark);\n        }\n\n        .vendor-subtitle {\n            font-size: 13px;\n            color: var(--text-gray);\n            margin-bottom: 12px;\n        }\n\n        .vendor-info {\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n            margin-bottom: 16px;\n            font-size: 13px;\n            flex-grow: 1;\n        }\n\n        .info-row {\n            display: flex;\n            justify-content: space-between;\n            color: var(--text-gray);\n        }\n\n        .info-label {\n            color: var(--text-light);\n        }\n\n        .info-value {\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        .rating {\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        .stars {\n            color: var(--rating);\n        }\n\n        .vendor-tags {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 6px;\n            margin-bottom: 16px;\n            padding-bottom: 16px;\n            border-bottom: 1px solid var(--border);\n        }\n\n        .tag {\n            background: linear-gradient(135deg, rgba(30, 93, 184, 0.12), rgba(30, 93, 184, 0.08));\n            color: var(--primary);\n            padding: 4px 8px;\n            border-radius: 5px;\n            font-size: 11px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n            border: 1px solid rgba(30, 93, 184, 0.2);\n            text-transform: uppercase;\n            letter-spacing: 0.2px;\n        }\n\n        .tag:hover {\n            background: linear-gradient(135deg, rgba(30, 93, 184, 0.2), rgba(30, 93, 184, 0.15));\n            border-color: var(--primary);\n            transform: translateY(-2px);\n        }\n\n        /* Discount/Coupon Banner */\n        .vendor-coupons {\n            display: flex;\n            flex-direction: column;\n            gap: 6px;\n            margin-bottom: 14px;\n        }\n\n        .coupon-badge {\n            background: linear-gradient(135deg, #fff8e1, #ffecb3);\n            border: 1px dashed #ff9800;\n            color: #e65100;\n            padding: 6px 12px;\n            border-radius: 6px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            font-size: 12px;\n        }\n\n        .coupon-left {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n        }\n\n        .coupon-icon {\n            font-size: 14px;\n        }\n\n        .coupon-value {\n            font-weight: 700;\n            color: #e65100;\n        }\n\n        .coupon-label {\n            color: #f57c00;\n            font-size: 11px;\n        }\n\n        .coupon-code {\n            background: white;\n            border: 1px solid #ffcc80;\n            padding: 8px 8px;\n            border-radius: 4px;\n            font-family: monospace;\n            font-size: 13px;\n            font-weight: 600;\n            color: #e65100;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .coupon-code:hover {\n            background: #fff3e0;\n            border-color: #ff9800;\n        }\n\n        .coupon-code-copied {\n            background: #e8f5e9 !important;\n            border-color: #4caf50 !important;\n            color: #2e7d32 !important;\n        }\n\n        .vendor-footer {\n            display: flex;\n            gap: 10px;\n            border-top: 1px solid var(--border);\n            padding-top: 16px;\n            margin-top: auto;\n        }\n\n        .btn-outline {\n            flex: 1;\n            background: transparent;\n            border: 1px solid var(--border);\n            color: var(--text-dark);\n            padding: 10px;\n            border-radius: 6px;\n            font-size: 13px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-outline:hover {\n            border-color: var(--primary);\n            color: var(--primary);\n            background: rgba(30, 93, 184, 0.02);\n        }\n\n        .btn-action {\n            flex: 1;\n            background: var(--primary);\n            border: none;\n            color: white;\n            padding: 10px;\n            border-radius: 6px;\n            font-size: 13px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-action:hover {\n            background: var(--primary-dark);\n            transform: translateY(-2px);\n            box-shadow: 0 4px 12px rgba(30, 93, 184, 0.25);\n        }\n\n        /* Overlay Pages (Catalog, Categories, Products) */\n        /* .overlay-page {\n            display: none;\n            position: fixed;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background: var(--bg-light);\n            z-index: 999;\n            overflow-y: auto;\n        } */\n\n        .overlay-page.active {\n            display: block;\n        }\n\n        .overlay-page-header {\n            background: var(--bg-white);\n            border-bottom: 1px solid var(--border);\n            padding: 20px 0;\n            position: sticky;\n            top: 0;\n            z-index: 100;\n            box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n        }\n\n        .overlay-page-header-content {\n            max-width: 1320px;\n            margin: 0 auto;\n            padding: 0 20px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n        }\n\n        .header-left {\n            display: flex;\n            align-items: center;\n            gap: 16px;\n        }\n\n        .header-right {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n        }\n\n        .btn-header-details {\n            padding: 11px 16px;\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            color: var(--text-dark);\n            border-radius: 6px;\n            font-size: 13px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-header-details:hover {\n            border-color: var(--primary);\n            color: var(--primary);\n        }\n\n        .btn-header-connect {\n            padding: 8px 16px;\n            background: var(--primary);\n            border: none;\n            color: white;\n            border-radius: 6px;\n            font-size: 13px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n        }\n\n        .btn-header-connect:hover {\n            background: var(--primary-dark);\n        }\n\n        .btn-header-requested {\n            padding: 8px 16px;\n            background: rgba(76, 175, 80, 0.1);\n            border: 1px solid rgba(76, 175, 80, 0.3);\n            color: var(--success);\n            border-radius: 6px;\n            font-size: 13px;\n            font-weight: 600;\n            cursor: default;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n        }\n\n        /* Vendor Info Card for inner pages */\n        .vendor-info-card {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 10px;\n            padding: 16px 20px;\n            margin-bottom: 24px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n        }\n\n        .vendor-info-card-left {\n            display: flex;\n            align-items: center;\n            gap: 14px;\n        }\n\n        .vendor-info-card-back {\n            width: 38px;\n            height: 38px;\n            border: 1px solid var(--border);\n            background: var(--bg-white);\n            border-radius: 8px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            font-size: 16px;\n            color: var(--text-gray);\n            transition: all 0.2s;\n        }\n\n        .vendor-info-card-back:hover {\n            border-color: var(--primary);\n            color: var(--primary);\n            background: rgba(30, 93, 184, 0.04);\n        }\n\n        .vendor-info-card-logo {\n            width: 44px;\n            height: 44px;\n            border-radius: 10px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 16px;\n            font-weight: 700;\n            color: white;\n        }\n\n        .vendor-info-card-name {\n            font-size: 16px;\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        .vendor-info-card-right {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n        }\n\n        .page-title-text {\n            font-size: 16px;\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        /* Search and Filter Card */\n        .search-filter-card {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 10px;\n            padding: 16px 20px;\n            margin-bottom: 24px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            gap: 16px;\n            flex-wrap: wrap;\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n        }\n\n        .search-filter-left {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            flex: 1;\n            min-width: 250px;\n        }\n\n        .filter-search-input {\n            flex: 1;\n            max-width: 350px;\n            position: relative;\n        }\n\n        .filter-search-input input {\n            width: 100%;\n            padding: 10px 14px 10px 40px;\n            border: 1px solid var(--border);\n            border-radius: 8px;\n            font-size: 14px;\n            background: var(--bg-light);\n            transition: all 0.2s;\n        }\n\n        .filter-search-input input:focus {\n            outline: none;\n            border-color: var(--primary);\n            background: var(--bg-white);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .filter-search-input .search-icon {\n            position: absolute;\n            left: 12px;\n            top: 50%;\n            transform: translateY(-50%);\n            color: var(--text-light);\n            font-size: 14px;\n        }\n\n        .search-filter-right {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            flex-wrap: wrap;\n        }\n\n        .filter-label {\n            font-size: 13px;\n            color: var(--text-gray);\n            font-weight: 500;\n        }\n\n        .filter-select {\n            padding: 8px 32px 8px 12px;\n            border: 1px solid var(--border);\n            border-radius: 6px;\n            font-size: 13px;\n            color: var(--text-dark);\n            background: var(--bg-white);\n            cursor: pointer;\n            appearance: none;\n            background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\n            background-repeat: no-repeat;\n            background-position: right 10px center;\n            transition: all 0.2s;\n        }\n\n        .filter-select:hover {\n            border-color: var(--primary);\n        }\n\n        .filter-select:focus {\n            outline: none;\n            border-color: var(--primary);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .filter-btn {\n            padding: 8px 14px;\n            border: 1px solid var(--border);\n            border-radius: 6px;\n            font-size: 13px;\n            font-weight: 500;\n            color: var(--text-gray);\n            background: var(--bg-white);\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            transition: all 0.2s;\n        }\n\n        .filter-btn:hover {\n            border-color: var(--primary);\n            color: var(--primary);\n        }\n\n        .filter-btn.active {\n            background: rgba(30, 93, 184, 0.08);\n            border-color: var(--primary);\n            color: var(--primary);\n        }\n\n        .filter-divider {\n            width: 1px;\n            height: 24px;\n            background: var(--border);\n        }\n\n        .results-count {\n            font-size: 13px;\n            color: var(--text-gray);\n        }\n\n        .results-count strong {\n            color: var(--text-dark);\n        }\n\n        @media (max-width: 768px) {\n            .vendor-info-card {\n                flex-direction: column;\n                align-items: stretch;\n                gap: 16px;\n                padding: 14px 16px;\n            }\n\n            .vendor-info-card-left {\n                min-width: 0;\n            }\n\n            .vendor-info-card-name {\n                font-size: 15px;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n            }\n\n            .vendor-info-card-right {\n                flex-wrap: wrap;\n                gap: 8px;\n            }\n\n            .vendor-info-card-right .btn-header-details,\n            .vendor-info-card-right .btn-connect-header {\n                flex: 1;\n                min-width: 0;\n                padding: 10px 14px;\n                font-size: 14px;\n            }\n\n            .search-filter-card {\n                flex-direction: column;\n                align-items: stretch;\n            }\n\n            .search-filter-left {\n                width: 100%;\n            }\n\n            .filter-search-input {\n                max-width: none;\n            }\n\n            .search-filter-right {\n                width: 100%;\n                justify-content: flex-start;\n            }\n        }\n\n        @media (max-width: 480px) {\n            .vendor-info-card-right {\n                flex-direction: column;\n            }\n\n            .vendor-info-card-right .btn-header-details,\n            .vendor-info-card-right .btn-connect-header {\n                width: 100%;\n            }\n        }\n\n        .back1-btn {\n            background: transparent;\n            border: 1px solid var(--border);\n            color: var(--text-dark);\n            width: 40px;\n            height: 40px;\n            border-radius: 6px;\n            font-size: 18px;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            transition: all 0.2s;\n        }\n\n        .back1-btn:hover {\n            border-color: var(--primary);\n            background: rgba(30, 93, 184, 0.05);\n            color: var(--primary);\n        }\n\n        .page-vendor-info {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n        }\n\n        .page-vendor-logo {\n            width: 40px;\n            height: 40px;\n            border-radius: 6px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 20px;\n            font-weight: 700;\n            color: white;\n        }\n\n        .page-vendor-name {\n            font-size: 16px;\n            font-weight: 700;\n            color: var(--text-dark);\n        }\n\n        /* Breadcrumb */\n        .breadcrumb {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            font-size: 13px;\n            color: var(--text-gray);\n            margin-bottom: 24px;\n        }\n\n        .breadcrumb-item {\n            cursor: pointer;\n            transition: color 0.2s;\n        }\n\n        .breadcrumb-item:hover {\n            color: var(--primary);\n        }\n\n        .breadcrumb-item.active {\n            color: var(--text-dark);\n            font-weight: 600;\n            cursor: default;\n        }\n\n        .breadcrumb-separator {\n            color: var(--text-light);\n        }\n\n        .overlay-page-content {\n            max-width: 1419px;\n            margin: 0 auto;\n            padding: 40px 20px;\n        }\n\n        .page-title {\n            font-size: 32px;\n            font-weight: 700;\n            margin-bottom: 12px;\n            color: var(--text-dark);\n        }\n\n        .page-subtitle {\n            font-size: 16px;\n            color: var(--text-gray);\n            margin-bottom: 40px;\n        }\n\n        .page-header-centered {\n            text-align: center;\n            margin-bottom: 40px;\n        }\n\n        .page-header-centered .page-title {\n            margin-bottom: 12px;\n        }\n\n        .page-header-centered .page-subtitle {\n            margin-bottom: 0;\n        }\n\n        .page-header-actions {\n            display: flex;\n            justify-content: center;\n            gap: 12px;\n            margin-top: 20px;\n        }\n\n        .btn-page-details {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            color: var(--text-dark);\n            padding: 10px 24px;\n            border-radius: 6px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-page-details:hover {\n            border-color: var(--primary);\n            color: var(--primary);\n        }\n\n        .btn-page-connect {\n            background: var(--primary);\n            border: none;\n            color: white;\n            padding: 10px 24px;\n            border-radius: 6px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n        }\n\n        .btn-page-connect:hover {\n            background: var(--primary-dark);\n        }\n\n        .btn-page-requested {\n            background: rgba(76, 175, 80, 0.1);\n            border: 1px solid rgba(76, 175, 80, 0.3);\n            color: var(--success);\n            padding: 10px 24px;\n            border-radius: 6px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: default;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n        }\n\n        /* Page Search Bar */\n        .page-search-wrapper {\n            max-width: 500px;\n            margin: 20px auto 0;\n            position: relative;\n        }\n\n        .page-search-input {\n            width: 100%;\n            padding: 12px 16px 12px 44px;\n            border: 1px solid var(--border);\n            border-radius: 8px;\n            font-size: 14px;\n            background: var(--bg-white);\n            transition: all 0.2s;\n        }\n\n        .page-search-input:focus {\n            outline: none;\n            border-color: var(--primary);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .page-search-input::placeholder {\n            color: var(--text-light);\n        }\n\n        .page-search-icon {\n            position: absolute;\n            left: 14px;\n            top: 50%;\n            transform: translateY(-50%);\n            color: var(--text-light);\n            font-size: 16px;\n            pointer-events: none;\n        }\n\n        /* Pagination Styles */\n        /* .pagination-container {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 10px;\n            padding: 16px 24px;\n            margin-top: 32px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            flex-wrap: wrap;\n            gap: 16px;\n        } */\n\n        .pagination-info {\n            font-size: 14px;\n            color: var(--text-gray);\n        }\n\n        .pagination-controls {\n            display: flex;\n            align-items: center;\n            gap: 16px;\n        }\n\n        .pagination-rows {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            font-size: 14px;\n            color: var(--text-gray);\n        }\n\n        .pagination-rows-select {\n            padding: 8px 32px 8px 12px;\n            border: 1px solid var(--border);\n            border-radius: 6px;\n            font-size: 14px;\n            color: var(--text-dark);\n            background: var(--bg-white);\n            cursor: pointer;\n            appearance: none;\n            background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\n            background-repeat: no-repeat;\n            background-position: right 10px center;\n        }\n\n        .pagination-rows-select:focus {\n            outline: none;\n            border-color: var(--primary);\n        }\n\n        .pagination-nav {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n        }\n\n        .pagination-btn {\n            padding: 8px 16px;\n            border: 1px solid var(--border);\n            border-radius: 6px;\n            font-size: 13px;\n            font-weight: 500;\n            color: var(--text-gray);\n            background: var(--bg-white);\n            cursor: pointer;\n            transition: all 0.2s;\n            display: flex;\n            align-items: center;\n            gap: 4px;\n        }\n\n        .pagination-btn:hover:not(:disabled) {\n            border-color: var(--primary);\n            color: var(--primary);\n        }\n\n        .pagination-btn:disabled {\n            opacity: 0.5;\n            cursor: not-allowed;\n        }\n\n        .pagination-pages {\n            display: flex;\n            align-items: center;\n            gap: 4px;\n        }\n\n        .pagination-page {\n            width: 36px;\n            height: 36px;\n            border: 1px solid var(--border);\n            border-radius: 6px;\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--text-gray);\n            background: var(--bg-white);\n            cursor: pointer;\n            transition: all 0.2s;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n\n        .pagination-page:hover {\n            border-color: var(--primary);\n            color: var(--primary);\n        }\n\n        .pagination-page.active {\n            background: var(--primary);\n            border-color: var(--primary);\n            color: white;\n        }\n\n        .pagination-ellipsis {\n            width: 36px;\n            height: 36px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 14px;\n            color: var(--text-light);\n        }\n\n        @media (max-width: 700px) {\n            .pagination-container {\n                flex-direction: column;\n                align-items: stretch;\n                text-align: center;\n            }\n\n            .pagination-controls {\n                flex-direction: column;\n                gap: 12px;\n            }\n\n            .pagination-nav {\n                justify-content: center;\n            }\n        }\n\n        /* Grid for cards */\n        .card1-grid {\n            display: grid;\n            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n            gap: 24px;\n        }\n\n        .card1 {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 10px;\n            overflow: hidden;\n            transition: all 0.3s ease;\n            display: flex;\n            flex-direction: column;\n            min-width: 0;\n        }\n\n        .card1:hover {\n            box-shadow: 0 12px 32px rgba(0,0,0,0.12);\n            border-color: var(--primary-light);\n            transform: translateY(-4px);\n        }\n\n        .card1-header {\n            background: var(--bg-white);\n            height: 180px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            position: relative;\n        }\n\n        .card1-logo {\n            width: 100px;\n            height: 100px;\n            border-radius: 10px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 40px;\n            font-weight: 700;\n            color: white;\n        }\n\n        .card1-body {\n            padding: 20px;\n            display: flex;\n            flex-direction: column;\n            flex-grow: 1;\n            min-width: 0;\n        }\n\n        .card1-name {\n            font-size: 16px;\n            font-weight: 700;\n            margin-bottom: 8px;\n            color: var(--text-dark);\n            max-width: 100%;\n            overflow-wrap: anywhere;\n            word-break: break-word;\n        }\n\n        .card1-description {\n            font-size: 13px;\n            color: var(--text-gray);\n            margin-bottom: 16px;\n            max-width: 100%;\n            overflow-wrap: anywhere;\n            word-break: break-word;\n        }\n\n        .card1-stats {\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n            margin-bottom: 16px;\n            padding-bottom: 16px;\n            border-bottom: 1px solid var(--border);\n            min-width: 0;\n        }\n\n        .card1-stat {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-start;\n            gap: 12px;\n            font-size: 13px;\n            min-width: 0;\n        }\n\n        .card1-stat-label {\n            color: var(--text-light);\n            font-weight: 500;\n            flex-shrink: 0;\n        }\n\n        .card1-stat-value {\n            color: var(--text-dark);\n            font-weight: 600;\n            text-align: right;\n            min-width: 0;\n            max-width: 100%;\n            overflow-wrap: anywhere;\n            word-break: break-word;\n        }\n\n        .popular-items {\n            margin-bottom: 16px;\n        }\n\n        .popular-items-title {\n            font-size: 12px;\n            font-weight: 700;\n            color: var(--text-dark);\n            text-transform: uppercase;\n            margin-bottom: 8px;\n            letter-spacing: 0.5px;\n        }\n\n        .popular-items-list {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 6px;\n        }\n\n        .popular-item {\n            background: var(--bg-light);\n            color: var(--text-gray);\n            padding: 4px 10px;\n            border-radius: 4px;\n            font-size: 11px;\n            font-weight: 500;\n        }\n\n        .card1-footer {\n            display: flex;\n            gap: 10px;\n            margin-top: auto;\n        }\n\n        .btn-card-action {\n            flex: 1;\n            background: var(--primary);\n            border: none;\n            color: white;\n            padding: 10px;\n            border-radius: 6px;\n            font-size: 13px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-card-action:hover {\n            background: var(--primary-dark);\n            transform: translateY(-2px);\n            box-shadow: 0 4px 12px rgba(30, 93, 184, 0.25);\n        }\n\n        /* Product Card specific styles */\n        .product-card {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 10px;\n            overflow: hidden;\n            transition: all 0.3s ease;\n        }\n\n        .product-card:hover {\n            box-shadow: 0 12px 32px rgba(0,0,0,0.12);\n            border-color: var(--primary-light);\n            transform: translateY(-4px);\n        }\n\n        .product-image {\n            background: var(--bg-white);\n            height: 200px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 60px;\n            position: relative;\n        }\n\n        .product-badge {\n            position: absolute;\n            top: 12px;\n            right: 12px;\n            background: var(--success);\n            color: white;\n            padding: 4px 10px;\n            border-radius: 4px;\n            font-size: 11px;\n            font-weight: 600;\n        }\n\n        .product-body {\n            padding: 20px;\n        }\n\n        .product-name {\n            font-size: 16px;\n            font-weight: 700;\n            margin-bottom: 6px;\n            color: var(--text-dark);\n        }\n\n        .product-sku {\n            font-size: 12px;\n            color: var(--text-light);\n            margin-bottom: 12px;\n        }\n\n        .product-price {\n            font-size: 20px;\n            font-weight: 700;\n            color: var(--primary);\n            margin-bottom: 16px;\n        }\n\n        .product-specs {\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n            margin-bottom: 16px;\n            padding-bottom: 16px;\n            border-bottom: 1px solid var(--border);\n        }\n\n        .product-spec {\n            display: flex;\n            justify-content: space-between;\n            font-size: 13px;\n        }\n\n        .product-spec-label {\n            color: var(--text-light);\n        }\n\n        .product-spec-value {\n            color: var(--text-dark);\n            font-weight: 500;\n        }\n\n        .product-footer {\n            display: flex;\n            gap: 10px;\n        }\n\n        .btn-product-view {\n            flex: 1;\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            color: var(--text-dark);\n            padding: 12px;\n            border-radius: 6px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-product-view:hover {\n            border-color: var(--primary);\n            color: var(--primary);\n        }\n\n        .btn-add-cart {\n            flex: 1;\n            background: var(--primary);\n            border: none;\n            color: white;\n            padding: 12px;\n            border-radius: 6px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-add-cart:hover {\n            background: var(--primary-dark);\n            transform: translateY(-2px);\n            box-shadow: 0 4px 12px rgba(30, 93, 184, 0.25);\n        }\n\n        /* Vendor Details Panel - Slide in from right */\n        .details-overlay {\n            position: fixed;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background: rgba(0, 0, 0, 0.5);\n            z-index: 1000;\n            opacity: 0;\n            visibility: hidden;\n            transition: all 0.3s ease;\n        }\n\n        .details-overlay.active {\n            opacity: 1;\n            visibility: visible;\n        }\n\n        .details-panel {\n            position: fixed;\n            top: 71px;\n            right: 0;\n            width: 800px;\n            max-width: 100%;\n            height: 104vh;\n            background: var(--bg-light);\n            z-index: 1001;\n            transform: translateX(100%);\n            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n            display: flex;\n            flex-direction: column;\n            box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);\n            overflow: hidden;\n        }\n\n        .details-panel.active {\n            transform: translateX(0);\n        }\n\n        .details-close-btn {\n            width: 55px;\n            height: 36px;\n            border: 1px solid var(--border);\n            background: var(--bg-white);\n            font-size: 24px;\n            color: var(--text-gray) !important;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 8px;\n            transition: all 0.2s;\n            flex-shrink: 0;\n        }\n\n        .details-close-btn:hover {\n            background: var(--bg-light);\n            color: var(--text-dark);\n            border-color: var(--text-gray);\n        }\n\n        .details-panel-header {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            padding: 16px 24px;\n            background: var(--bg-white);\n            border-bottom: 1px solid var(--border);\n            flex-shrink: 0;\n        }\n\n        .details-panel-title {\n            font-size: 16px;\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        .details-panel-fixed-header {\n            flex-shrink: 0;\n            padding: 0 24px 16px;\n            background: var(--bg-light);\n            overflow: hidden;\n        }\n\n        .details-panel-fixed-header .details-header {\n            margin-bottom: 0;\n        }\n\n        .details-panel-content {\n            flex: 1;\n            min-height: 0;\n            overflow-y: auto;\n            overflow-x: hidden;\n            padding: 24px;\n        }\n\n        .details-panel-footer {\n            flex-shrink: 0;\n            background: var(--bg-white);\n            border-top: 1px solid var(--border);\n            padding: 16px 24px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            gap: 16px;\n        }\n\n        .details-footer-text {\n            font-size: 14px;\n            color: var(--text-gray);\n        }\n\n        .details-footer-actions {\n            display: flex;\n            gap: 12px;\n        }\n\n        .btn-close-panel {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            color: var(--text-dark);\n            padding: 12px 24px;\n            border-radius: 6px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-close-panel:hover {\n            border-color: var(--text-gray);\n        }\n\n        .btn-connect {\n            background: var(--primary);\n            border: none;\n            color: white;\n            padding: 12px 24px;\n            border-radius: 6px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-connect:hover {\n            background: var(--primary-dark);\n        }\n\n        /* Details Panel Content Styles */\n        .details-header {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 12px;\n            padding: 24px;\n            margin-bottom: 16px;\n        }\n\n        .details-header-top {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-start;\n            margin-bottom: 20px;\n        }\n\n        .details-header-left {\n            display: flex;\n            gap: 16px;\n            align-items: flex-start;\n        }\n\n        .details-vendor-logo {\n            width: 72px;\n            height: 72px;\n            border-radius: 12px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 28px;\n            font-weight: 700;\n            color: white;\n            flex-shrink: 0;\n        }\n\n        .details-vendor-info h1 {\n            font-size: 22px;\n            font-weight: 700;\n            color: var(--text-dark);\n            margin-bottom: 4px;\n        }\n\n        .details-vendor-info p {\n            font-size: 14px;\n            color: var(--text-gray);\n            margin-bottom: 12px;\n        }\n\n        .details-vendor-badges {\n            display: flex;\n            gap: 8px;\n        }\n\n        .detail-badge {\n            padding: 8px 12px;\n            border-radius: 4px;\n            font-size: 12px;\n            font-weight: 600;\n        }\n\n        .detail-badge.verified {\n            background: rgba(76, 175, 80, 0.12);\n            color: var(--success);\n        }\n\n        .detail-badge.partner {\n            background: rgba(30, 93, 184, 0.12);\n            color: var(--primary);\n        }\n\n        .detail-badge.new {\n            background: rgba(255, 152, 0, 0.12);\n            color: var(--accent);\n        }\n\n        .detail-badge.service {\n            background: var(--bg-light);\n            color: var(--text-dark);\n            border: 1px solid var(--border);\n        }\n\n        .details-header-actions {\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n        }\n\n        .btn-connect-header {\n            background: var(--primary);\n            border: none;\n            color: white;\n            padding: 12px 28px;\n            border-radius: 6px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-connect-header:hover {\n            background: var(--primary-dark);\n        }\n\n        .btn-favorite {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            color: var(--text-dark);\n            padding: 10px 20px;\n            border-radius: 6px;\n            font-size: 13px;\n            font-weight: 500;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-favorite:hover {\n            border-color: var(--primary);\n            color: var(--primary);\n        }\n\n        .details-stats-row {\n            display: grid;\n            grid-template-columns: repeat(4, 1fr);\n            gap: 16px;\n            padding-top: 20px;\n            border-top: 1px solid var(--border);\n        }\n\n        .details-stat-item {\n            text-align: center;\n        }\n\n        .details-stat-label {\n            font-size: 11px;\n            color: var(--text-light);\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n            margin-bottom: 4px;\n        }\n\n        .details-stat-value {\n            font-size: 18px;\n            font-weight: 700;\n            color: var(--text-dark);\n        }\n\n        /* Two column layout */\n        .details-two-column {\n            display: grid;\n            grid-template-columns: 1fr 1fr;\n            gap: 16px;\n            margin-bottom: 16px;\n        }\n\n        .details-card {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 12px;\n            padding: 20px;\n        }\n\n        .details-card-title {\n            font-size: 15px;\n            font-weight: 700;\n            color: var(--text-dark);\n            margin-bottom: 16px;\n        }\n\n        .details-about-text {\n            font-size: 14px;\n            color: var(--text-gray);\n            line-height: 1.6;\n            padding-left: 12px;\n            border-left: 3px solid var(--primary);\n        }\n\n        /* Performance Card */\n        .performance-stars {\n            display: flex;\n            justify-content: center;\n            gap: 4px;\n            margin-bottom: 8px;\n        }\n\n        .performance-star {\n            font-size: 28px;\n            color: var(--rating);\n        }\n\n        .performance-rating {\n            text-align: center;\n            font-size: 14px;\n            color: var(--text-gray);\n            margin-bottom: 4px;\n        }\n\n        .performance-reviews {\n            text-align: center;\n            font-size: 12px;\n            color: var(--text-light);\n            margin-bottom: 20px;\n        }\n\n        .performance-bars {\n            display: flex;\n            flex-direction: column;\n            gap: 12px;\n        }\n\n        .performance-bar-item {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            font-size: 13px;\n        }\n\n        .performance-bar-label {\n            color: var(--text-gray);\n        }\n\n        .performance-bar-value {\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        /* Contact & Business Info */\n        .contact-grid {\n            display: grid;\n            grid-template-columns: 1fr 1fr;\n            gap: 16px;\n        }\n\n        .contact-column-title {\n            font-size: 13px;\n            font-weight: 600;\n            color: var(--text-dark);\n            margin-bottom: 12px;\n            display: flex;\n            align-items: center;\n            gap: 8px;\n        }\n\n        .contact-item {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            padding: 10px 12px;\n            background: var(--bg-light);\n            border-radius: 6px;\n            margin-bottom: 8px;\n            font-size: 13px;\n            color: var(--text-gray);\n        }\n\n        .contact-item-icon {\n            font-size: 16px;\n            width: 20px;\n            text-align: center;\n        }\n\n        @media (min-width: 1421px) {\n            .details-panel .details-card-title {\n                font-size: 18px;\n            }\n            .details-panel .details-about-text {\n                font-size: 16px;\n            }\n            .details-panel .performance-star {\n                font-size: 32px;\n            }\n            .details-panel .performance-rating {\n                font-size: 16px;\n            }\n            .details-panel .performance-reviews {\n                font-size: 14px;\n            }\n            .details-panel .performance-bar-item {\n                font-size: 15px;\n            }\n            .details-panel .contact-column-title {\n                font-size: 15px;\n            }\n            .details-panel .contact-item {\n                font-size: 15px;\n                padding: 12px 14px;\n            }\n            .details-panel .contact-item-icon {\n                font-size: 18px;\n                width: 22px;\n            }\n            .details-panel .service-row {\n                font-size: 15px;\n                padding-bottom: 14px;\n            }\n            .details-panel .special-offer-heading {\n                font-size: 14px;\n                opacity: 0.9;\n                margin-bottom: 4px;\n            }\n            .details-panel .special-offer-count {\n                font-size: 16px;\n                font-weight: 600;\n            }\n            .details-panel .coupon-badge {\n                font-size: 14px;\n                padding: 8px 14px;\n            }\n            .details-panel .coupon-label {\n                font-size: 13px;\n            }\n            .details-panel .coupon-code {\n                font-size: 15px;\n            }\n            .details-panel .btn-write-review {\n                font-size: 15px;\n            }\n            .details-panel .no-reviews-title {\n                font-size: 17px;\n            }\n            .details-panel .no-reviews-text {\n                font-size: 15px;\n            }\n            .details-panel .reviews-avg-rating {\n                font-size: 36px;\n            }\n            .details-panel .reviews-avg-stars {\n                font-size: 18px;\n            }\n            .details-panel .reviews-count {\n                font-size: 14px;\n            }\n            .details-panel .review-item-title {\n                font-size: 16px;\n            }\n            .details-panel .review-item-text {\n                font-size: 15px;\n            }\n            .details-panel .review-author-avatar {\n                font-size: 16px;\n                width: 40px;\n                height: 40px;\n            }\n            .details-panel .review-author-info h5 {\n                font-size: 16px;\n            }\n            .details-panel .review-author-info span {\n                font-size: 14px;\n            }\n            .details-panel .review-rating-stars {\n                font-size: 16px;\n            }\n            .details-panel .review-recommend-badge {\n                font-size: 13px;\n            }\n        }\n\n        /* Services Card */\n        .services-list {\n            display: flex;\n            flex-direction: column;\n            gap: 12px;\n        }\n\n        .service-row {\n            display: flex;\n            justify-content: space-between;\n            font-size: 13px;\n            padding-bottom: 12px;\n            border-bottom: 1px solid var(--border);\n        }\n\n        .service-row:last-child {\n            border-bottom: none;\n            padding-bottom: 0;\n        }\n\n        .service-label {\n            color: var(--text-gray);\n        }\n\n        .service-value {\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        /* Special Offer Card */\n        .special-offer-heading {\n            font-size: 12px;\n            opacity: 0.9;\n            margin-bottom: 4px;\n        }\n        .special-offer-count {\n            font-size: 14px;\n            font-weight: 600;\n        }\n        .special-offer-card {\n            background: linear-gradient(135deg, #ff9800, #ff8c00);\n            border: none;\n            color: white;\n            text-align: center;\n            padding: 24px;\n            position: relative;\n            overflow: hidden;\n        }\n\n        .special-offer-card::before {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background: radial-gradient(circle at top right, rgba(255,255,255,0.2), transparent);\n            pointer-events: none;\n        }\n\n        .special-offer-label {\n            font-size: 12px;\n            opacity: 0.9;\n            margin-bottom: 8px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 6px;\n        }\n\n        .special-offer-value {\n            font-size: 32px;\n            font-weight: 700;\n            margin-bottom: 4px;\n        }\n\n        .special-offer-desc {\n            font-size: 14px;\n            font-weight: 600;\n            margin-bottom: 4px;\n        }\n\n        .special-offer-terms {\n            font-size: 11px;\n            opacity: 0.8;\n        }\n\n        /* Reviews Card */\n        .reviews-header {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            margin-bottom: 20px;\n        }\n\n        .btn-write-review {\n            background: var(--bg-white);\n            border: 1px solid var(--primary);\n            color: var(--primary);\n            padding: 8px 16px;\n            border-radius: 6px;\n            font-size: 13px;\n            font-weight: 600;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            transition: all 0.2s;\n        }\n\n        .btn-write-review:hover {\n            background: rgba(30, 93, 184, 0.05);\n        }\n\n        .no-reviews {\n            text-align: center;\n            padding: 40px 20px;\n        }\n\n        .no-reviews-icon {\n            font-size: 48px;\n            margin-bottom: 12px;\n            opacity: 0.3;\n        }\n\n        .no-reviews-title {\n            font-size: 15px;\n            font-weight: 600;\n            color: var(--text-dark);\n            margin-bottom: 4px;\n        }\n\n        .no-reviews-text {\n            font-size: 13px;\n            color: var(--text-light);\n        }\n\n        @media (max-width: 800px) {\n            .details-panel {\n                width: 100%;\n            }\n\n            .details-two-column {\n                grid-template-columns: 1fr;\n            }\n\n            .details-header-top {\n                flex-direction: column;\n                gap: 16px;\n            }\n\n            .details-header-actions {\n                flex-direction: row;\n                width: 100%;\n            }\n\n            .details-header-actions button {\n                flex: 1;\n            }\n\n            .details-stats-row {\n                grid-template-columns: repeat(2, 1fr);\n            }\n\n            .contact-grid {\n                grid-template-columns: 1fr;\n            }\n\n            .details-panel-footer {\n                flex-direction: column;\n                text-align: center;\n            }\n        }\n\n        /* Connect with Vendor Modal Styles */\n        .modal-overlay {\n            position: fixed;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background: rgba(0, 0, 0, 0.6);\n            z-index: 2000;\n            opacity: 0;\n            visibility: hidden;\n            transition: all 0.3s ease;\n        }\n\n        .modal-overlay.active {\n            opacity: 1;\n            visibility: visible;\n        }\n\n        .connect-modal {\n            position: fixed;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%) scale(0.95);\n            width: 600px;\n            max-width: 95%;\n            max-height: 90vh;\n            background: var(--bg-white);\n            border-radius: 16px;\n            z-index: 2001;\n            opacity: 0;\n            visibility: hidden;\n            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n            display: flex;\n            flex-direction: column;\n            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n        }\n\n        .connect-modal.active {\n            opacity: 1;\n            visibility: visible;\n            transform: translate(-50%, -50%) scale(1);\n        }\n\n        .connect-modal-header {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-start;\n            padding: 24px 24px 16px;\n            border-bottom: 1px solid var(--border);\n        }\n\n        .connect-modal-title-section {\n            flex: 1;\n        }\n\n        .connect-modal-title {\n            font-size: 20px;\n            font-weight: 700;\n            color: var(--text-dark);\n            margin-bottom: 8px;\n        }\n\n        .connect-modal-vendor {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n        }\n\n        .connect-modal-vendor-logo {\n            width: 32px;\n            height: 32px;\n            border-radius: 6px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 14px;\n            font-weight: 700;\n            color: white;\n        }\n\n        .connect-modal-vendor-name {\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--text-gray);\n        }\n\n        .modal-close-btn {\n            width: 36px;\n            height: 36px;\n            border: 1px solid var(--border);\n            background: var(--bg-white);\n            font-size: 24px;\n            color: var(--text-gray);\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 8px;\n            transition: all 0.2s;\n            flex-shrink: 0;\n        }\n\n        .modal-close-btn:hover {\n            background: var(--bg-light);\n            color: var(--text-dark);\n            border-color: var(--text-gray);\n        }\n\n        .connect-modal-content {\n            flex: 1;\n            overflow-y: auto;\n            padding: 24px;\n        }\n\n        .connect-intro {\n            background: rgba(30, 93, 184, 0.06);\n            border: 1px solid rgba(30, 93, 184, 0.15);\n            border-radius: 8px;\n            padding: 14px 16px;\n            margin-bottom: 24px;\n            font-size: 13px;\n            color: var(--text-gray);\n            line-height: 1.6;\n        }\n\n        .connect-intro-icon {\n            color: var(--primary);\n            margin-right: 6px;\n        }\n\n        .form-section {\n            margin-bottom: 28px;\n        }\n\n        .form-section:last-child {\n            margin-bottom: 0;\n        }\n\n        .form-section-title {\n            font-size: 14px;\n            font-weight: 700;\n            color: var(--text-dark);\n            margin-bottom: 16px;\n            display: flex;\n            align-items: center;\n            gap: 8px;\n        }\n\n        .form-section-number {\n            width: 22px;\n            height: 22px;\n            background: var(--primary);\n            color: white;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 12px;\n            font-weight: 700;\n        }\n\n        .form-section-optional {\n            font-weight: 400;\n            color: var(--text-gray);\n            margin-left: 6px;\n        }\n\n        .connect-volume-row {\n            display: grid;\n            grid-template-columns: 1fr 1fr;\n            gap: 24px;\n            align-items: start;\n        }\n\n        .connect-volume-row .form1-label-uppercase {\n            text-transform: uppercase;\n            letter-spacing: 0.3px;\n        }\n\n        .connect-services-grid {\n            display: grid;\n            grid-template-columns: 1fr 1fr;\n            gap: 10px;\n        }\n\n        .connect-services-grid .checkbox-item {\n            margin: 0;\n        }\n\n        @media (max-width: 640px) {\n            .connect-volume-row {\n                grid-template-columns: 1fr;\n            }\n        }\n\n        .form-grid {\n            display: grid;\n            grid-template-columns: 1fr 1fr;\n            gap: 14px;\n        }\n\n        .form-group {\n            display: flex;\n            flex-direction: column;\n            gap: 6px;\n        }\n\n        .form-group.full-width {\n            grid-column: 1 / -1;\n        }\n\n        .form1-label {\n            font-size: 12px;\n            font-weight: 600;\n            color: var(--text-gray);\n            text-transform: uppercase;\n            letter-spacing: 0.3px;\n        }\n\n        .form-input {\n            padding: 10px 14px;\n            border: 1px solid var(--border);\n            border-radius: 6px;\n            font-size: 14px;\n            color: var(--text-dark);\n            background: var(--bg-white);\n            transition: all 0.2s;\n        }\n\n        .form-input:focus {\n            outline: none;\n            border-color: var(--primary);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .form-input.readonly {\n            background: var(--bg-light);\n            color: var(--text-gray);\n            cursor: not-allowed;\n        }\n\n        .form-input.readonly:focus {\n            border-color: var(--border);\n            box-shadow: none;\n        }\n\n        .form1-select {\n            padding: 10px 14px;\n            border: 1px solid var(--border);\n            border-radius: 6px;\n            font-size: 14px;\n            color: var(--text-dark);\n            background: var(--bg-white);\n            cursor: pointer;\n            transition: all 0.2s;\n            appearance: none;\n            background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\n            background-repeat: no-repeat;\n            background-position: right 12px center;\n            padding-right: 36px;\n        }\n\n        .form1-select:focus {\n            outline: none;\n            border-color: var(--primary);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .form-textarea {\n            width: 100%;\n            box-sizing: border-box;\n            padding: 12px 14px;\n            border: 1px solid var(--border);\n            border-radius: 6px;\n            font-size: 14px;\n            color: var(--text-dark);\n            background: var(--bg-white);\n            resize: vertical;\n            min-height: 100px;\n            font-family: inherit;\n            transition: all 0.2s;\n        }\n\n        .form-textarea:focus {\n            outline: none;\n            border-color: var(--primary);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .checkbox-group {\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n        }\n\n        .checkbox-row {\n            display: grid;\n            grid-template-columns: 1fr 1fr;\n            gap: 10px;\n        }\n\n        .checkbox-item {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            padding: 10px 14px;\n            border: 1px solid var(--border);\n            border-radius: 6px;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .checkbox-item:hover {\n            border-color: var(--primary);\n            background: rgba(30, 93, 184, 0.02);\n        }\n\n        .checkbox-item.checked {\n            border-color: var(--primary);\n            background: rgba(30, 93, 184, 0.06);\n        }\n\n        .checkbox-item input[type=\"checkbox\"] {\n            width: 18px;\n            height: 18px;\n            accent-color: var(--primary);\n            cursor: pointer;\n        }\n\n        .checkbox-item label {\n            font-size: 13px;\n            color: var(--text-dark);\n            cursor: pointer;\n            flex: 1;\n        }\n\n        .form-submit-section {\n            padding-top: 20px;\n            border-top: 1px solid var(--border);\n            margin-top: 8px;\n        }\n\n        .btn-submit-connect {\n            width: 100%;\n            background: var(--primary);\n            border: none;\n            color: white;\n            padding: 14px 24px;\n            border-radius: 8px;\n            font-size: 15px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n            margin-bottom: 12px;\n        }\n\n        .btn-submit-connect:hover {\n            background: var(--primary-dark);\n            transform: translateY(-1px);\n            box-shadow: 0 4px 12px rgba(30, 93, 184, 0.25);\n        }\n\n        .btn-submit-connect:disabled {\n            background: var(--text-light);\n            cursor: not-allowed;\n            transform: none;\n            box-shadow: none;\n        }\n\n        .form-helper-text {\n            font-size: 12px;\n            color: var(--text-light);\n            text-align: center;\n        }\n\n        /* Success State */\n        .connect-success {\n            text-align: center;\n            padding: 40px 20px;\n        }\n\n        .connect-success-icon {\n            width: 64px;\n            height: 64px;\n            background: rgba(76, 175, 80, 0.12);\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 32px;\n            margin: 0 auto 20px;\n        }\n\n        .connect-success-title {\n            font-size: 20px;\n            font-weight: 700;\n            color: var(--text-dark);\n            margin-bottom: 8px;\n        }\n\n        .connect-success-text {\n            font-size: 14px;\n            color: var(--text-gray);\n            margin-bottom: 24px;\n        }\n\n        .btn-success-close {\n            background: var(--primary);\n            border: none;\n            color: white;\n            padding: 12px 32px;\n            border-radius: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-success-close:hover {\n            background: var(--primary-dark);\n        }\n\n        /* Requested Status Badge */\n        .btn-requested {\n            background: rgba(76, 175, 80, 0.1);\n            border: 1px solid rgba(76, 175, 80, 0.3);\n            color: var(--success);\n            padding: 12px 24px;\n            border-radius: 6px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: default;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 6px;\n        }\n\n        .btn-requested-header {\n            background: rgba(76, 175, 80, 0.1);\n            border: 1px solid rgba(76, 175, 80, 0.3);\n            color: var(--success);\n            padding: 12px 28px;\n            border-radius: 6px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: default;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n        }\n\n        @media (max-width: 600px) {\n            .connect-modal {\n                width: 100%;\n                max-width: 100%;\n                height: 100%;\n                max-height: 100%;\n                border-radius: 0;\n            }\n\n            .form-grid {\n                grid-template-columns: 1fr;\n            }\n\n            .checkbox-row {\n                grid-template-columns: 1fr;\n            }\n        }\n\n        /* Request Vendor Modal Styles */\n        .request-vendor-subtitle {\n            font-size: 14px;\n            color: var(--text-gray);\n            line-height: 1.5;\n            margin-top: 4px;\n        }\n\n        .request-form-group {\n            margin-bottom: 20px;\n        }\n\n        .request-form-label {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--text-dark);\n            margin-bottom: 10px;\n        }\n\n        .request-label-icon {\n            font-size: 16px;\n        }\n\n        .required {\n            color: #e53935;\n        }\n\n        .optional {\n            font-weight: 400;\n            color: var(--text-light);\n            font-size: 13px;\n        }\n\n        .request-input-wrapper {\n            position: relative;\n            display: flex;\n            align-items: center;\n        }\n\n        .request-input-icon {\n            position: absolute;\n            left: 14px;\n            font-size: 16px;\n            color: var(--text-light);\n            pointer-events: none;\n        }\n\n        .request-form-input {\n            width: 100%;\n            padding: 12px 14px 12px 44px;\n            border: 1px solid var(--border);\n            border-radius: 8px;\n            font-size: 14px;\n            color: var(--text-dark);\n            background: var(--bg-white);\n            transition: all 0.2s;\n        }\n\n        .request-form-input:focus {\n            outline: none;\n            border-color: var(--primary);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .request-form-input::placeholder {\n            color: var(--text-light);\n        }\n\n        .request-form-select {\n            width: 100%;\n            padding: 3px 14px 12px 44px;\n            border: 1px solid var(--border);\n            border-radius: 8px;\n            font-size: 14px;\n            color: var(--text-dark);\n            background: var(--bg-white);\n            cursor: pointer;\n            transition: all 0.2s;\n            appearance: none;\n            background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\n            background-repeat: no-repeat;\n            background-position: right 14px center;\n        }\n\n        .request-form-select:focus {\n            outline: none;\n            border-color: var(--primary);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .request-textarea-wrapper {\n            position: relative;\n        }\n\n        .request-form-textarea {\n            width: 100%;\n            padding: 14px;\n            border: 1px solid var(--border);\n            border-radius: 8px;\n            font-size: 14px;\n            color: var(--text-dark);\n            background: var(--bg-white);\n            resize: vertical;\n            min-height: 100px;\n            font-family: inherit;\n            transition: all 0.2s;\n        }\n\n        .request-form-textarea:focus {\n            outline: none;\n            border-color: var(--primary);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .request-form-textarea::placeholder {\n            color: var(--text-light);\n        }\n\n        .textarea-icon {\n            position: absolute;\n            bottom: 12px;\n            left: 14px;\n            font-size: 16px;\n            color: var(--text-light);\n            pointer-events: none;\n        }\n\n        .request-radio-group {\n            display: flex;\n            flex-direction: column;\n            gap: 12px;\n            margin-bottom: 24px;\n        }\n\n        .request-radio-item {\n            display: flex;\n            align-items: flex-start;\n            gap: 12px;\n            padding: 14px 16px;\n            border: 1px solid var(--border);\n            border-radius: 8px;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .request-radio-item:hover {\n            border-color: var(--primary);\n            background: rgba(30, 93, 184, 0.02);\n        }\n\n        .request-radio-item input[type=\"radio\"] {\n            width: 18px;\n            height: 18px;\n            margin-top: 2px;\n            accent-color: var(--primary);\n            cursor: pointer;\n            flex-shrink: 0;\n        }\n\n        .radio-content {\n            display: flex;\n            flex-direction: column;\n            gap: 2px;\n        }\n\n        .radio-title {\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        .radio-description {\n            font-size: 12px;\n            color: var(--text-light);\n        }\n\n        .request-form-actions {\n            display: flex;\n            justify-content: flex-end;\n            gap: 12px;\n            padding-top: 20px;\n            border-top: 1px solid var(--border);\n        }\n\n        .btn-request-cancel {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            color: var(--text-dark);\n            padding: 12px 24px;\n            border-radius: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-request-cancel:hover {\n            border-color: var(--text-gray);\n            background: var(--bg-light);\n        }\n\n        .btn-request-submit {\n            background: var(--primary);\n            border: none;\n            color: white;\n            padding: 12px 24px;\n            border-radius: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-request-submit:hover {\n            background: var(--primary-dark);\n        }\n\n        /* Request Vendor Success */\n        .request-success {\n            text-align: center;\n            padding: 40px 20px;\n        }\n\n        .request-success-icon {\n            width: 64px;\n            height: 64px;\n            background: rgba(76, 175, 80, 0.12);\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 32px;\n            margin: 0 auto 20px;\n        }\n\n        .request-success-title {\n            font-size: 20px;\n            font-weight: 700;\n            color: var(--text-dark);\n            margin-bottom: 8px;\n        }\n\n        .request-success-text {\n            font-size: 14px;\n            color: var(--text-gray);\n            margin-bottom: 24px;\n            line-height: 1.5;\n        }\n\n        /* Add to Cart Modal Styles */\n        .cart-modal-overlay {\n            position: fixed;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background: rgba(0, 0, 0, 0.5);\n            z-index: 3000;\n            opacity: 0;\n            visibility: hidden;\n            transition: all 0.3s ease;\n        }\n\n        .cart-modal-overlay.active {\n            opacity: 1;\n            visibility: visible;\n        }\n\n        .cart-modal {\n            position: fixed;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%) scale(0.95);\n            width: 500px;\n            max-width: 95%;\n            background: var(--bg-white);\n            border-radius: 12px;\n            z-index: 3001;\n            opacity: 0;\n            visibility: hidden;\n            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n            overflow: hidden;\n        }\n\n        .cart-modal.active {\n            opacity: 1;\n            visibility: visible;\n            transform: translate(-50%, -50%) scale(1);\n        }\n\n        @media (min-width: 1022px) {\n            .cart-modal {\n                width: 56%;\n                max-width: 56%;\n            }\n        }\n\n        .cart-modal-header {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-start;\n            padding: 20px 24px;\n            border-bottom: 1px solid var(--border);\n            background: var(--bg-light);\n        }\n\n        .cart-modal-header-content {\n            display: flex;\n            align-items: flex-start;\n            gap: 12px;\n        }\n\n        .cart-success-icon {\n            width: 24px;\n            height: 24px;\n            background: var(--success);\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: white;\n            font-size: 14px;\n            flex-shrink: 0;\n            margin-top: 2px;\n        }\n\n        .cart-modal-title {\n            font-size: 16px;\n            font-weight: 700;\n            color: var(--text-dark);\n            margin-bottom: 4px;\n        }\n\n        .cart-modal-subtitle {\n            font-size: 13px;\n            color: var(--text-gray);\n        }\n\n        .cart-modal-close {\n            width: 32px;\n            height: 32px;\n            border: none;\n            background: transparent;\n            font-size: 22px;\n            color: var(--text-gray);\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 6px;\n            transition: all 0.2s;\n        }\n\n        .cart-modal-close:hover {\n            background: var(--bg-white);\n            color: var(--text-dark);\n        }\n\n        .cart-modal-body {\n            padding: 24px;\n        }\n\n        .cart-product-label {\n            font-size: 13px;\n            font-weight: 600;\n            color: var(--text-dark);\n            margin-bottom: 16px;\n        }\n\n        .cart-product-details {\n            display: flex;\n            gap: 16px;\n            margin-bottom: 20px;\n            min-width: 0;\n        }\n\n        .cart-product-image {\n            width: 80px;\n            height: 80px;\n            background: var(--bg-light);\n            border: 1px solid var(--border);\n            border-radius: 8px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 36px;\n            flex-shrink: 0;\n        }\n\n        .cart-product-info {\n            flex: 1;\n            min-width: 0;\n        }\n\n        .cart-product-name {\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--primary);\n            margin-bottom: 10px;\n            line-height: 1.4;\n            max-width: 100%;\n            overflow-wrap: anywhere;\n            word-break: break-word;\n        }\n\n        .cart-product-meta {\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n        }\n\n        .cart-product-meta-first-row {\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n            gap: 16px 24px;\n            font-size: 13px;\n        }\n\n        .cart-product-meta-first-row .cart-meta-group {\n            display: flex;\n            align-items: center;\n            gap: 6px;\n        }\n\n        .cart-product-meta-row {\n            display: flex;\n            gap: 24px;\n            font-size: 13px;\n        }\n\n        .cart-meta-label {\n            color: var(--text-gray);\n        }\n\n        .cart-meta-value {\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        .cart-meta-price {\n            font-weight: 700;\n            color: var(--success);\n        }\n\n        .cart-product-sku {\n            font-size: 12px;\n            color: var(--text-light);\n            align-items: flex-start;\n            flex-wrap: wrap;\n            gap: 6px 12px;\n            min-width: 0;\n        }\n\n        .cart-product-sku .cart-meta-label {\n            flex-shrink: 0;\n        }\n\n        .cart-product-sku .cart-meta-value {\n            flex: 1 1 0;\n            min-width: 0;\n            max-width: 100%;\n            overflow-wrap: anywhere;\n            word-break: break-word;\n        }\n\n        .cart-subtotal {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            padding-top: 16px;\n            border-top: 1px solid var(--border);\n        }\n\n        .cart-subtotal-label {\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        .cart-subtotal-value {\n            font-size: 18px;\n            font-weight: 700;\n            color: var(--text-dark);\n        }\n\n        .cart-modal-actions {\n            display: flex;\n            gap: 12px;\n            padding: 20px 24px;\n            border-top: 1px solid var(--border);\n            background: var(--bg-white);\n        }\n\n        .btn-continue-shopping {\n            flex: 1;\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            color: var(--text-dark);\n            padding: 12px 20px;\n            border-radius: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-continue-shopping:hover {\n            border-color: var(--primary);\n            color: var(--primary);\n        }\n\n        .btn-proceed-checkout {\n            flex: 1;\n            background: var(--primary);\n            border: none;\n            color: white;\n            padding: 12px 20px;\n            border-radius: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-proceed-checkout:hover {\n            background: var(--primary-dark);\n        }\n\n        /* Write Review Modal Styles */\n        .review-modal-overlay {\n            position: fixed;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background: rgba(0, 0, 0, 0.5);\n            z-index: 3000;\n            opacity: 0;\n            visibility: hidden;\n            transition: all 0.3s ease;\n        }\n\n        .review-modal-overlay.active {\n            opacity: 1;\n            visibility: visible;\n        }\n\n        .review-modal {\n            position: fixed;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%) scale(0.95);\n            width: 500px;\n            max-width: 95%;\n            max-height: 90vh;\n            background: var(--bg-white);\n            border-radius: 12px;\n            z-index: 3001;\n            opacity: 0;\n            visibility: hidden;\n            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n            display: flex;\n            flex-direction: column;\n        }\n\n        .review-modal.active {\n            opacity: 1;\n            visibility: visible;\n            transform: translate(-50%, -50%) scale(1);\n        }\n\n        .review-modal-header {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            padding: 20px 24px;\n            border-bottom: 1px solid var(--border);\n        }\n\n        .review-modal-title {\n            font-size: 18px;\n            font-weight: 700;\n            color: var(--text-dark);\n        }\n\n        .review-modal-close {\n            width: 32px;\n            height: 32px;\n            border: none;\n            background: transparent;\n            font-size: 22px;\n            color: var(--text-gray);\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 6px;\n            transition: all 0.2s;\n        }\n\n        .review-modal-close:hover {\n            background: var(--bg-light);\n            color: var(--text-dark);\n        }\n\n        .review-modal-content {\n            flex: 1;\n            overflow-y: auto;\n            padding: 24px;\n        }\n\n        .review-vendor-info {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            padding: 16px;\n            background: var(--bg-light);\n            border-radius: 8px;\n            margin-bottom: 24px;\n        }\n\n        .review-vendor-logo {\n            width: 48px;\n            height: 48px;\n            border-radius: 8px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 20px;\n            font-weight: 700;\n            color: white;\n        }\n\n        .review-vendor-details h4 {\n            font-size: 15px;\n            font-weight: 600;\n            color: var(--text-dark);\n            margin-bottom: 2px;\n        }\n\n        .review-vendor-details span {\n            font-size: 13px;\n            color: var(--text-gray);\n        }\n\n        .review-form-group {\n            margin-bottom: 20px;\n        }\n\n        .review-form-label {\n            display: block;\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--text-dark);\n            margin-bottom: 8px;\n        }\n\n        .review-form-label .required {\n            color: #e53935;\n        }\n\n        .star-rating {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n        }\n\n        .star-rating-stars {\n            display: flex;\n            gap: 4px;\n        }\n\n        .star-rating-star {\n            font-size: 28px;\n            color: #ddd;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .star-rating-star:hover,\n        .star-rating-star.active {\n            color: var(--rating);\n            transform: scale(1.1);\n        }\n\n        .star-rating-text {\n            font-size: 13px;\n            color: var(--text-gray);\n        }\n\n        .review-form-input {\n            width: 100%;\n            padding: 12px 14px;\n            border: 1px solid var(--border);\n            border-radius: 8px;\n            font-size: 14px;\n            color: var(--text-dark);\n            transition: all 0.2s;\n        }\n\n        .review-form-input:focus {\n            outline: none;\n            border-color: var(--primary);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .review-form-textarea {\n            width: 100%;\n            padding: 12px 14px;\n            border: 1px solid var(--border);\n            border-radius: 8px;\n            font-size: 14px;\n            color: var(--text-dark);\n            resize: vertical;\n            min-height: 120px;\n            font-family: inherit;\n            transition: all 0.2s;\n        }\n\n        .review-form-textarea:focus {\n            outline: none;\n            border-color: var(--primary);\n            box-shadow: 0 0 0 3px rgba(30, 93, 184, 0.1);\n        }\n\n        .review-char-count {\n            font-size: 12px;\n            color: var(--text-light);\n            margin-top: 6px;\n        }\n\n        .review-recommend {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            padding: 14px 16px;\n            background: var(--bg-light);\n            border-radius: 8px;\n            cursor: pointer;\n        }\n\n        .review-recommend input[type=\"checkbox\"] {\n            width: 18px;\n            height: 18px;\n            accent-color: var(--primary);\n        }\n\n        .review-recommend span {\n            font-size: 14px;\n            color: var(--text-dark);\n        }\n\n        .review-modal-footer {\n            display: flex;\n            gap: 12px;\n            padding: 20px 24px;\n            border-top: 1px solid var(--border);\n        }\n\n        .btn-review-cancel {\n            flex: 1;\n            background: var(--bg-light);\n            border: none;\n            color: var(--text-dark);\n            padding: 12px 20px;\n            border-radius: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-review-cancel:hover {\n            background: #e0e0e0;\n        }\n\n        .btn-review-submit {\n            flex: 1.5;\n            background: var(--primary);\n            border: none;\n            color: white;\n            padding: 12px 20px;\n            border-radius: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-review-submit:hover {\n            background: var(--primary-dark);\n        }\n\n        /* Customer Reviews List Styles */\n        .reviews-list {\n            display: flex;\n            flex-direction: column;\n            gap: 16px;\n        }\n\n        .review-item {\n            padding: 16px;\n            background: var(--bg-light);\n            border-radius: 8px;\n        }\n\n        .review-item-header {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-start;\n            margin-bottom: 10px;\n        }\n\n        .review-author {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n        }\n\n        .review-author-avatar {\n            width: 36px;\n            height: 36px;\n            border-radius: 50%;\n            background: var(--primary);\n            color: white;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 14px;\n            font-weight: 600;\n        }\n\n        .review-author-info h5 {\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--text-dark);\n            margin-bottom: 2px;\n        }\n\n        .review-author-info span {\n            font-size: 12px;\n            color: var(--text-light);\n        }\n\n        .review-rating-stars {\n            color: var(--rating);\n            font-size: 14px;\n        }\n\n        .review-item-title {\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--text-dark);\n            margin-bottom: 8px;\n        }\n\n        .review-item-text {\n            font-size: 13px;\n            color: var(--text-gray);\n            line-height: 1.6;\n            margin-bottom: 10px;\n        }\n\n        .review-recommend-badge {\n            display: inline-flex;\n            align-items: center;\n            gap: 6px;\n            font-size: 12px;\n            color: var(--success);\n            background: rgba(76, 175, 80, 0.1);\n            padding: 4px 10px;\n            border-radius: 4px;\n        }\n\n        .reviews-summary {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding-bottom: 16px;\n            margin-bottom: 16px;\n            border-bottom: 1px solid var(--border);\n        }\n\n        .reviews-summary-left {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n        }\n\n        .reviews-avg-rating {\n            font-size: 32px;\n            font-weight: 700;\n            color: var(--text-dark);\n        }\n\n        .reviews-avg-info {\n            display: flex;\n            flex-direction: column;\n            gap: 2px;\n        }\n\n        .reviews-avg-stars {\n            color: var(--rating);\n            font-size: 16px;\n        }\n\n        .reviews-count {\n            font-size: 12px;\n            color: var(--text-gray);\n        }\n\n        /* Shopping Cart Page Styles */\n        .cart-page {\n            display: none;\n            position: fixed;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background: var(--bg-light);\n            z-index: 999;\n            overflow-y: auto;\n        }\n\n        .cart-page.active {\n            display: block;\n        }\n\n        .cart-page-header {\n            background: var(--bg-white);\n            border-bottom: 1px solid var(--border);\n            padding: 16px 0;\n            position: sticky;\n            top: 0;\n            z-index: 100;\n            box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n        }\n\n        .cart-page-header-content {\n            max-width: 1320px;\n            margin: 0 auto;\n            padding: 0 20px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n        }\n\n        .cart-back-link {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            color: var(--text-gray);\n            font-size: 14px;\n            cursor: pointer;\n            transition: color 0.2s;\n        }\n\n        .cart-back-link:hover {\n            color: var(--primary);\n        }\n\n        .cart-header-right {\n            display: flex;\n            align-items: center;\n            gap: 20px;\n        }\n\n        .cart-header-icon {\n            position: relative;\n            font-size: 20px;\n            color: var(--text-gray);\n            cursor: pointer;\n        }\n\n        .cart-header-icon:hover {\n            color: var(--primary);\n        }\n\n        .cart-badge {\n            position: absolute;\n            top: -8px;\n            right: -8px;\n            background: #e53935;\n            color: white;\n            font-size: 10px;\n            font-weight: 700;\n            width: 18px;\n            height: 18px;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n\n        .cart-user-info {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            cursor: pointer;\n        }\n\n        .cart-user-avatar {\n            width: 36px;\n            height: 36px;\n            border-radius: 50%;\n            background: linear-gradient(135deg, #667BC6, #4A5BA8);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: white;\n            font-size: 14px;\n            font-weight: 600;\n        }\n\n        .cart-user-name {\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        .cart-user-role {\n            font-size: 12px;\n            color: var(--text-light);\n        }\n\n        .cart-page-content {\n            max-width: 1320px;\n            margin: 0 auto;\n            padding: 30px 20px;\n        }\n\n        .cart-page-title {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            font-size: 24px;\n            font-weight: 700;\n            color: var(--text-dark);\n            margin-bottom: 8px;\n        }\n\n        .cart-page-title-icon {\n            font-size: 22px;\n        }\n\n        .cart-item-count {\n            font-size: 14px;\n            color: var(--text-gray);\n            margin-bottom: 24px;\n        }\n\n        .cart-layout {\n            display: grid;\n            grid-template-columns: 1fr 380px;\n            gap: 24px;\n            align-items: start;\n        }\n\n        /* Cart Items Section */\n        .cart-items-section {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 12px;\n            overflow-x: auto;\n        }\n\n        .cart-items-header {\n            display: grid;\n            grid-template-columns: minmax(0, 1.25fr) 64px 88px 64px 72px 32px;\n            gap: 8px;\n            padding: 12px 14px;\n            background: var(--bg-light);\n            border-bottom: 1px solid var(--border);\n            font-size: 11px;\n            font-weight: 600;\n            color: var(--text-gray);\n            text-transform: uppercase;\n            letter-spacing: 0.4px;\n            min-width: 620px;\n        }\n\n        .cart-items-header > div:not(:first-child) {\n            text-align: center;\n        }\n\n        .cart-item {\n            display: grid;\n            grid-template-columns: minmax(0, 1.25fr) 64px 88px 64px 72px 32px;\n            gap: 8px;\n            padding: 12px 14px;\n            border-bottom: 1px solid var(--border);\n            align-items: center;\n            min-width: 620px;\n        }\n\n        .cart-item:last-child {\n            border-bottom: none;\n        }\n\n        .cart-item-info {\n            display: flex;\n            gap: 10px;\n            align-items: center;\n            min-width: 0;\n        }\n\n        .cart-item-image {\n            width: 56px;\n            height: 56px;\n            /* background: var(--bg-light);\n            border: 1px solid var(--border);\n            border-radius: 8px; */\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 28px;\n            flex-shrink: 0;\n        }\n\n        .cart-item-details h4 {\n            font-size: 13px;\n            font-weight: 600;\n            color: var(--text-dark);\n            margin-bottom: 4px;\n            line-height: 1.35;\n        }\n\n        .cart-item-meta {\n            font-size: 12px;\n            color: var(--text-gray);\n            display: flex;\n            flex-direction: column;\n            gap: 2px;\n        }\n\n        .cart-item-meta span {\n            display: flex;\n            gap: 4px;\n        }\n\n        .cart-item-meta strong {\n            color: var(--text-dark);\n        }\n\n        .cart-quantity {\n            display: flex;\n            align-items: center;\n            gap: 0;\n            border: 1px solid var(--border);\n            border-radius: 6px;\n            overflow: hidden;\n            width: fit-content;\n            justify-self: center;\n        }\n\n        .cart-qty-btn {\n            width: 26px;\n            height: 28px;\n            border: none;\n            background: var(--bg-light);\n            color: var(--text-dark);\n            font-size: 14px;\n            cursor: pointer;\n            transition: all 0.2s;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n\n        .cart-qty-btn:hover {\n            background: var(--primary);\n            color: white;\n        }\n\n        .cart-qty-input {\n            width: 32px;\n            height: 28px;\n            border: none;\n            border-left: 1px solid var(--border);\n            border-right: 1px solid var(--border);\n            text-align: center;\n            font-size: 13px;\n            font-weight: 600;\n            color: var(--text-dark);\n            padding: 0;\n        }\n\n        .cart-qty-input:focus {\n            outline: none;\n        }\n\n        .cart-item-price {\n            font-size: 13px;\n            font-weight: 600;\n            color: var(--text-dark);\n            text-align: center;\n            white-space: nowrap;\n        }\n\n        .cart-item-discount {\n            font-size: 13px;\n            text-align: center;\n            white-space: nowrap;\n        }\n\n        .cart-item-subtotal {\n            font-size: 13px;\n            font-weight: 700;\n            color: var(--text-dark);\n            text-align: center;\n            white-space: nowrap;\n        }\n\n        .cart-item-action {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n\n        .cart-item-remove {\n            width: 28px;\n            height: 28px;\n            border: none;\n            background: transparent;\n            color: var(--text-light);\n            font-size: 18px;\n            cursor: pointer;\n            border-radius: 6px;\n            transition: all 0.2s;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n        .cart-item-remove .cart-item-remove-icon {\n            font-size: 22px;\n        }\n\n        .cart-item-remove:hover {\n            background: #ffebee;\n            color: #e53935;\n        }\n\n        /* Order Summary Section */\n        .order-summary {\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            border-radius: 12px;\n            padding: 24px;\n            position: sticky;\n            top: 100px;\n        }\n\n        .order-summary-title {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            font-size: 16px;\n            font-weight: 700;\n            color: var(--text-dark);\n            margin-bottom: 20px;\n            padding-bottom: 16px;\n            border-bottom: 1px solid var(--border);\n        }\n\n        .order-summary-rows {\n            display: flex;\n            flex-direction: column;\n            gap: 12px;\n            margin-bottom: 16px;\n        }\n\n        .order-summary-row {\n            display: flex;\n            justify-content: space-between;\n            font-size: 14px;\n        }\n\n        .order-summary-row .label {\n            color: var(--text-gray);\n        }\n\n        .order-summary-row .value {\n            color: var(--text-dark);\n            font-weight: 500;\n        }\n\n        .order-summary-row.discount .label {\n            color: var(--success);\n        }\n\n        .order-summary-row.discount .value {\n            color: var(--success);\n        }\n\n        .order-summary-row.tbd .value {\n            color: var(--text-light);\n            font-size: 13px;\n        }\n\n        .order-summary-total {\n            display: flex;\n            justify-content: space-between;\n            padding-top: 16px;\n            border-top: 1px solid var(--border);\n            margin-bottom: 20px;\n        }\n\n        .order-summary-total .label {\n            font-size: 15px;\n            font-weight: 600;\n            color: var(--text-dark);\n        }\n\n        .order-summary-total .value {\n            font-size: 20px;\n            font-weight: 700;\n            color: var(--text-dark);\n        }\n\n        .discount-code-section {\n            margin-bottom: 16px;\n        }\n\n        .btn-apply-discount {\n            width: 100%;\n            padding: 12px;\n            border: 1px dashed var(--primary);\n            background: rgba(30, 93, 184, 0.04);\n            color: var(--primary);\n            border-radius: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 8px;\n            transition: all 0.2s;\n        }\n\n        .btn-apply-discount:hover {\n            background: rgba(30, 93, 184, 0.08);\n        }\n\n        .discount-input-group {\n            display: none;\n            gap: 8px;\n            margin-top: 12px;\n        }\n\n        .discount-input-group.active {\n            display: flex;\n        }\n\n        .discount-input {\n            flex: 1;\n            padding: 10px 14px;\n            border: 1px solid var(--border);\n            border-radius: 6px;\n            font-size: 14px;\n        }\n\n        .discount-input:focus {\n            outline: none;\n            border-color: var(--primary);\n        }\n\n        .btn-apply-code {\n            padding: 10px 16px;\n            background: var(--primary);\n            border: none;\n            color: white;\n            border-radius: 6px;\n            font-size: 13px;\n            font-weight: 600;\n            cursor: pointer;\n        }\n\n        .btn-apply-code:hover {\n            background: var(--primary-dark);\n        }\n\n        .applied-discount {\n            display: none;\n            align-items: center;\n            justify-content: space-between;\n            padding: 10px 14px;\n            background: rgba(76, 175, 80, 0.08);\n            border: 1px solid rgba(76, 175, 80, 0.3);\n            border-radius: 8px;\n            margin-top: 12px;\n        }\n\n        .applied-discount.active {\n            display: flex;\n        }\n\n        .applied-discount-info {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            font-size: 13px;\n            color: var(--success);\n            font-weight: 600;\n        }\n\n        .applied-discount-remove {\n            background: none;\n            border: none;\n            color: var(--text-gray);\n            cursor: pointer;\n            font-size: 16px;\n        }\n\n        .applied-discount-remove:hover {\n            color: #e53935;\n        }\n\n        .special-fees-section {\n            margin-bottom: 20px;\n            padding: 14px;\n            border: 1px solid var(--border);\n            border-radius: 8px;\n        }\n\n        .special-fees-title {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            font-size: 13px;\n            font-weight: 600;\n            color: var(--text-dark);\n            margin-bottom: 8px;\n        }\n\n        .special-fees-empty {\n            font-size: 12px;\n            color: var(--text-light);\n        }\n\n        .order-summary-actions {\n            display: flex;\n            flex-direction: column;\n            gap: 12px;\n        }\n\n        .btn-checkout {\n            width: 100%;\n            padding: 14px;\n            background: var(--primary);\n            border: none;\n            color: white;\n            border-radius: 8px;\n            font-size: 15px;\n            font-weight: 600;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 8px;\n            transition: all 0.2s;\n        }\n\n        .btn-checkout:hover {\n            background: var(--primary-dark);\n            transform: translateY(-1px);\n            box-shadow: 0 4px 12px rgba(30, 93, 184, 0.25);\n        }\n\n        .btn-continue-shopping-cart {\n            width: 100%;\n            padding: 12px;\n            background: var(--bg-white);\n            border: 1px solid var(--border);\n            color: var(--text-dark);\n            border-radius: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .btn-continue-shopping-cart:hover {\n            border-color: var(--primary);\n            color: var(--primary);\n        }\n\n        .secure-checkout-text {\n            text-align: center;\n            font-size: 11px;\n            color: var(--text-light);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 6px;\n            margin-top: 16px;\n            }\n\n        /* Empty Cart State */\n        .empty-cart {\n            text-align: center;\n            padding: 60px 20px;\n        }\n\n        .empty-cart-icon {\n            font-size: 64px;\n            margin-bottom: 20px;\n            opacity: 0.3;\n        }\n\n        .empty-cart-title {\n            font-size: 20px;\n            font-weight: 700;\n            color: var(--text-dark);\n            margin-bottom: 8px;\n        }\n\n        .empty-cart-text {\n            font-size: 14px;\n            color: var(--text-gray);\n            margin-bottom: 24px;\n        }\n\n        .btn-start-shopping {\n            padding: 12px 32px;\n            background: var(--primary);\n            border: none;\n            color: white;\n            border-radius: 8px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n        }\n\n        .btn-start-shopping:hover {\n            background: var(--primary-dark);\n        }\n\n        /* Cart Savings Banner */\n        .cart-savings-banner {\n            background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(76, 175, 80, 0.05));\n            border: 1px solid rgba(76, 175, 80, 0.2);\n            border-radius: 8px;\n            padding: 12px 16px;\n            margin-bottom: 16px;\n            display: flex;\n            align-items: center;\n            gap: 10px;\n        }\n\n        .cart-savings-icon {\n            font-size: 20px;\n        }\n\n        .cart-savings-text {\n            font-size: 13px;\n            color: var(--success);\n            font-weight: 500;\n        }\n\n        .cart-savings-amount {\n            font-weight: 700;\n        }\n\n        @media (max-width: 900px) {\n            .cart-layout {\n                grid-template-columns: 1fr;\n            }\n\n            .order-summary {\n                position: static;\n            }\n\n            .cart-items-header {\n                display: grid;\n            }\n\n            .cart-item {\n                grid-template-columns: minmax(0, 1.25fr) 64px 88px 64px 72px 32px;\n            }\n\n            .cart-item-info {\n                flex-direction: row;\n                align-items: center;\n            }\n        }\n\n        @keyframes slideUp {\n            from {\n                opacity: 0;\n                transform: translateY(20px);\n            }\n            to {\n                opacity: 1;\n                transform: translateY(0);\n            }\n        }\n\n        .vendor-card {\n            animation: slideUp 0.5s ease-out forwards;\n        }\n\n        .vendor-card:nth-child(1) { animation-delay: 0.05s; }\n        .vendor-card:nth-child(2) { animation-delay: 0.1s; }\n        .vendor-card:nth-child(3) { animation-delay: 0.15s; }\n        .vendor-card:nth-child(4) { animation-delay: 0.2s; }\n        .vendor-card:nth-child(5) { animation-delay: 0.25s; }\n        .vendor-card:nth-child(6) { animation-delay: 0.3s; }\n        .vendor-card:nth-child(7) { animation-delay: 0.35s; }\n        .vendor-card:nth-child(8) { animation-delay: 0.4s; }\n        .vendor-card:nth-child(9) { animation-delay: 0.45s; }\n\n        @media (max-width: 900px) {\n            .cta-section {\n                grid-template-columns: 1fr;\n                gap: 24px;\n            }\n\n            .hero h1 {\n                font-size: 28px;\n            }\n\n            .controls {\n                flex-direction: column;\n            }\n\n            .search-wrapper {\n                min-width: 100%;\n            }\n\n            .vendors-grid {\n                grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n            }\n        }\n\n        @media (max-width: 600px) {\n            .main {\n                padding: 24px 16px;\n            }\n\n            .hero h1 {\n                font-size: 24px;\n            }\n\n            .vendors-grid {\n                grid-template-columns: 1fr;\n            }\n\n            .vendor-image {\n                height: 140px;\n            }\n\n            .cta-section {\n                padding: 20px;\n            }\n          }\n\n          /* Shared datatable (pp-table) — used by ordercheckoutpop and ProductSelectionModal */\n          .pp-table-container {\n            flex: 1;\n            max-height: 520px;\n            overflow-y: auto;\n            overflow-x: auto;\n          }\n          .pp-table {\n            width: 100%;\n            border-collapse: collapse;\n          }\n          .pp-table thead {\n            position: sticky;\n            top: 0;\n            z-index: 10;\n            background: #fff;\n          }\n          .pp-table thead tr {\n            border-bottom: 2px solid #e5e7eb;\n          }\n          .pp-table th {\n            padding: 16px 20px;\n            text-align: left;\n            font-size: 13px;\n            font-weight: 600;\n            color: #6b7280;\n            text-transform: uppercase;\n            letter-spacing: 0.05em;\n            background: #f9fafb;\n            white-space: nowrap;\n          }\n          .pp-table td {\n            padding: 24px 20px;\n            font-size: 14px;\n            color: #374151;\n            vertical-align: middle;\n          }\n          .pp-table tbody tr {\n            border-bottom: 1px solid #f3f4f6;\n            transition: all 0.2s;\n          }\n          .pp-table tbody tr:hover {\n            background: #fafbfc;\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n          }\n\n          /* ProductSelectionModal: no horizontal scroll, product name truncate */\n          .psm-table-container {\n            overflow-x: hidden;\n          }\n          .psm-products-table td:nth-child(2) {\n            overflow: hidden;\n          }\n          .psm-products-table .table-cells-product-name {\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            min-width: 0;\n          }\n         .list-group-item {\n  background: transparent !important;\n}\n\n/* Order cart page table — keeps Product/Price/Qty/Discount/Subtotal/Action on one row */\n.order-cart-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.order-cart-table thead th {\n  padding: 12px 10px;\n  background: var(--bg-light, #f8f9fa);\n  border-bottom: 1px solid var(--border, #e0e0e0);\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-gray, #666);\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.order-cart-table thead th:first-child {\n  text-align: left;\n  padding-left: 14px;\n}\n\n.order-cart-table tbody td {\n  padding: 12px 10px;\n  border-bottom: 1px solid var(--border, #e0e0e0);\n  vertical-align: middle;\n  text-align: center;\n}\n\n.order-cart-table tbody td:first-child {\n  text-align: left;\n  padding-left: 14px;\n}\n\n.order-cart-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.order-cart-col-product { width: 36%; }\n.order-cart-col-price { width: 12%; }\n.order-cart-col-qty { width: 16%; }\n.order-cart-col-discount { width: 12%; }\n.order-cart-col-subtotal { width: 14%; }\n.order-cart-col-action { width: 10%; }\n\n.order-cart-table .cart-item-info {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  min-width: 0;\n}\n\n.order-cart-table .cart-item-details {\n  min-width: 0;\n  flex: 1;\n}\n\n.order-cart-table .cart-item-details h4 {\n  font-size: 13px;\n  margin-bottom: 4px;\n  word-break: break-word;\n}\n\n.order-cart-table .custom-fields-container {\n  max-width: 100%;\n}\n\n.order-cart-table .cart-quantity {\n  margin: 0 auto;\n}\n\n.order-cart-table tbody td.cart-item-action {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n  padding: 12px 8px;\n}\n\n.order-cart-table tbody td.cart-item-action .cart-item-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  margin: 0;\n  line-height: 1;\n}\n\n.order-cart-table tbody td.cart-item-action .cart-item-remove-icon {\n  display: block;\n  line-height: 1;\n}\n\n@media (max-width: 900px) {\n  .cart-items-section {\n    overflow-x: auto;\n  }\n\n  .order-cart-table {\n    min-width: 640px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
